function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("lE3ki", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$d9b8953399247ca2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $e9YVH;
    var $261Bl;
    var $gxzum;
    var $4JyIO;
    var $1jUsD;
    var $doZTA;
    const $d9b8953399247ca2$var$KnowledgeHubCategoryApp = (0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>(parcelRequire("hh9mX")), {
        moduleId: "./src/packages/servicedesk/knowledge-hub-category/src/ui/index.tsx"
    });
    const $d9b8953399247ca2$var$View = ()=>{
        const [{ match: matchRouter }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4JyIO")).KnowledgeHubAppBase), {
            appName: (0, (0, parcelRequire("e9YVH")).APP_NAMES).KB_CATEGORY
        }, ({ projectId: projectId, projectKey: projectKey, locale: locale, activationId: activationId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxzum")).KnowledgeBaseBreadcrumb), {
                projectKey: projectKey
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($d9b8953399247ca2$var$KnowledgeHubCategoryApp, {
                projectId: projectId,
                projectKey: projectKey,
                categoryId: (0, (0, parcelRequire("261Bl")).toCategoryGuid)(matchRouter.params?.categoryId || ''),
                locale: locale,
                activationId: activationId
            })));
    };
    var $d9b8953399247ca2$export$2e2bcd8739ae039 = $d9b8953399247ca2$var$View;
});
parcelRegister("261Bl", function(module, exports) {
    $parcel$export(module.exports, "categoryGuidToString", ()=>$21d0c574129f0705$export$43162cfd3260b2fe);
    $parcel$export(module.exports, "toCategoryGuid", ()=>$21d0c574129f0705$export$be5c80c4ad1faf99);
    const $21d0c574129f0705$export$43162cfd3260b2fe = (guid)=>guid;
    const $21d0c574129f0705$export$be5c80c4ad1faf99 = (guid)=>guid;
});
parcelRegister("gxzum", function(module, exports) {
    $parcel$export(module.exports, "KnowledgeBaseBreadcrumb", ()=>$032b4919c4efb274$export$f2521acff636c885);
    var $5uXOq = parcelRequire("5uXOq");
    var $c2D8L;
    var $koVbs;
    var $3HwlS;
    var $2PO6B;
    const $032b4919c4efb274$export$f2521acff636c885 = ({ projectKey: projectKey, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const constructHref = ()=>(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && window.location.href.includes('/categories') ? `/jira/servicedesk/projects/${projectKey}/knowledge/categories` : `/jira/servicedesk/projects/${projectKey}/knowledge`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c2D8L")).default), {
            breadcrumb: {
                href: constructHref(),
                text: formatMessage((0, (0, parcelRequire("2PO6B")).default).knowledgeBase),
                type: 'jsd-knowledge-base'
            }
        }, children);
    };
    var $032b4919c4efb274$export$2e2bcd8739ae039 = $032b4919c4efb274$export$f2521acff636c885;
});
parcelRegister("2PO6B", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9b70732324f96788$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9b70732324f96788$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        knowledgeBase: {
            "id": "servicedesk-knowledge-common.knowledge-hub-breadcrumb.knowledge-base",
            "defaultMessage": "Knowledge base"
        }
    });
});
parcelRegister("4JyIO", function(module, exports) {
    $parcel$export(module.exports, "KnowledgeHubAppBase", ()=>$7e2d47ddd83763db$export$f848f52481042e56);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $e0Brz;
    var $gEFwt;
    var $kb4zh;
    var $3HwlS;
    var $cf7yQ;
    var $cbMay;
    var $6GLlD;
    var $e33py;
    var $gq0sA;
    var $4S0uJ;
    const $7e2d47ddd83763db$export$f848f52481042e56 = (props)=>{
        const { appName: appName, shouldRemoveMargin: shouldRemoveMargin = false } = props;
        const [{ data: pageContextData, error: pageContextError }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { projectContext: projectContext, tenantContext: tenantContext, serviceDeskContext: serviceDeskContext } = pageContextData || {};
        const { projectKey: projectKey, projectName: projectName } = projectContext || {};
        const { locale: locale, activationId: activationId } = tenantContext || {};
        const { projectId: projectId } = projectContext || {};
        const { portalId: portalId } = serviceDeskContext || {};
        if (!pageContextData && !pageContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kb4zh")).default), null);
        const CustomizedPageStyle = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && shouldRemoveMargin ? (0, (0, parcelRequire("6Ll2T")).default) : (0, (0, parcelRequire("4S0uJ")).PageStyle);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6GLlD")).default), {
            appName: appName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e33py")).ServiceDeskDocumentTitle), {
            projectName: projectName,
            section: "knowledge"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cbMay")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e0Brz")).BreadcrumbManager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEFwt")).default), {
            baseUrl: "",
            projectKey: projectKey,
            projectName: projectName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement(CustomizedPageStyle, null, props.children({
            projectKey: projectKey,
            projectId: projectId,
            portalId: portalId,
            locale: locale,
            activationId: activationId
        }))))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cf7yQ")).JsdGettingStartedPanelShouldRender), null));
    };
    var $7e2d47ddd83763db$export$2e2bcd8739ae039 = $7e2d47ddd83763db$export$f848f52481042e56;
});
parcelRegister("cf7yQ", function(module, exports) {
    $parcel$export(module.exports, "JsdGettingStartedPanelShouldRender", ()=>$8aa55ef5824c4e4d$export$46976e0f90edfcfe);
    $parcel$export(module.exports, "JsdGettingStartedPanel", ()=>$8aa55ef5824c4e4d$export$6f9913539cfb4ab6);
    $parcel$export(module.exports, "JsdGettingStartedPanelOpenButton", ()=>$8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad);
    $parcel$export(module.exports, "JsdGettingStartedPanelReopenSpotlight", ()=>$8aa55ef5824c4e4d$export$c7732c55900cf0b9);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("3kACf")).then(({ JsdGettingStartedPanelShouldRender: JsdGettingStartedPanelShouldRender })=>JsdGettingStartedPanelShouldRender), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/should-render/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanel = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("CFRIm")).then(({ JsdGettingStartedPanel: JsdGettingStartedPanel })=>JsdGettingStartedPanel), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/panel/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("hnw8Z")).then(({ JsdGettingStartedPanelOpenButton: JsdGettingStartedPanelOpenButton })=>JsdGettingStartedPanelOpenButton), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/open-button/async.tsx"
    });
    const $8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("7opQ6")).then(({ JsdGettingStartedPanelReopenSpotlight: JsdGettingStartedPanelReopenSpotlight })=>JsdGettingStartedPanelReopenSpotlight), {
        moduleId: "./src/packages/servicedesk/getting-started-panel/src/ui/reopen-spotlight/async.tsx"
    });
    const $8aa55ef5824c4e4d$export$46976e0f90edfcfe = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-should-render",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelShouldRender, null));
    $8aa55ef5824c4e4d$export$46976e0f90edfcfe.displayName = 'AsyncJsdGettingStartedPanelShouldRender';
    const $8aa55ef5824c4e4d$export$6f9913539cfb4ab6 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-panel",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanel, null));
    $8aa55ef5824c4e4d$export$6f9913539cfb4ab6.displayName = 'AsyncJsdGettingStartedPanel';
    const $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-open-button",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelOpenButton, null));
    $8aa55ef5824c4e4d$export$4cb23b2c31a1b2ad.displayName = 'AsyncJsdGettingStartedPanelOpenButton';
    const $8aa55ef5824c4e4d$export$c7732c55900cf0b9 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jsm-getting-started-panel-async-reopen-spotlight",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8aa55ef5824c4e4d$var$AsyncGettingStartedPanelReopenSpotlight, null));
    $8aa55ef5824c4e4d$export$c7732c55900cf0b9.displayName = 'AsyncJsdGettingStartedPanelReopenSpotlight';
});
parcelRegister("3kACf", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("chQyv")
    ]).then(()=>parcelRequire('hZyYK'));
});
parcelRegister("CFRIm", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("3Xgpx")
    ]).then(()=>parcelRequire('2NciN'));
});
parcelRegister("hnw8Z", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hlGg7")
    ]).then(()=>parcelRequire('4F6ZA'));
});
parcelRegister("7opQ6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("eXDqW")
    ]).then(()=>parcelRequire('6Wput'));
});
parcelRegister("cbMay", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$342ca5599182c99e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $825UM;
    var $ks7Ah;
    var $342ca5599182c99e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ks7Ah")).default), null, ({ isOpen: isOpen, onClose: onClose })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("825UM")).default), {
                isOpen: isOpen,
                onClose: onClose
            }));
});
parcelRegister("825UM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6d18ceb0644bdde$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iJDK4;
    var $4uJJm;
    var $6z7Gx;
    var $gq0sA;
    var $lVJAU;
    var $261Bl;
    var $lw2HC;
    var $7U3kA;
    const $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory = (props)=>{
        const { isOpen: isOpen, onClose: onClose } = props;
        const { push: push } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const [{ data: pageContextData }] = (0, (0, parcelRequire("gq0sA")).usePageContext)();
        const { projectContext: projectContext, tenantContext: tenantContext } = pageContextData || {};
        const { projectId: projectId, projectKey: projectKey } = projectContext || {};
        const [{ isSubmitting: isSubmitting, formValues: formValues, error: error, createdCategory: createdCategory }, { createCategory: createCategory, handleFormInputChange: handleFormInputChange, resetCreatedCategory: resetCreatedCategory }] = (0, (0, parcelRequire("lw2HC")).useCreateCategoryData)();
        const activationId = tenantContext?.activationId || '';
        const isValid = !!formValues.name && formValues.name.length !== 0;
        const onChange = (field, value)=>{
            handleFormInputChange(field, value);
        };
        (0, $5uXOq.useEffect)(()=>{
            if (!createdCategory) return;
            onClose();
            resetCreatedCategory();
            push(`/jira/servicedesk/projects/${projectKey}/knowledge/categories/${(0, (0, parcelRequire("261Bl")).categoryGuidToString)(createdCategory.id)}`);
        }, [
            createdCategory,
            projectKey,
            push,
            onClose,
            resetCreatedCategory
        ]);
        const onSubmit = (e, analyticsEvent)=>{
            e.preventDefault();
            if (isSubmitting || !isValid) return;
            projectId && createCategory(projectId, analyticsEvent, activationId);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iJDK4")).default), {
            data: {
                source: `knowledgeCreateCategory${(0, $4d5e0871c06cee03$export$1171103ea9083ffa)}`,
                actionSubject: 'category',
                attributes: {
                    context: (0, (0, parcelRequire("6z7Gx")).ANALYTIC_CONTEXTS).KNOWLEDGE
                }
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uJJm")).default), null, isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7U3kA")).default), {
            onChange: onChange,
            onClose: onClose,
            onSubmit: onSubmit,
            formValues: formValues,
            formError: error.formError,
            fieldErrors: error.fieldErrors,
            isSubmitting: isSubmitting,
            isDisabled: !isValid
        })));
    };
    var $a6d18ceb0644bdde$export$2e2bcd8739ae039 = $a6d18ceb0644bdde$var$KnowledgeHubCreateCategory;
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("6z7Gx", function(module, exports) {
    $parcel$export(module.exports, "ANALYTIC_CONTEXTS", ()=>$c0766aa675d05766$export$ca021921d5c56515);
    $parcel$export(module.exports, "ttiRecommendedSlo", ()=>$c0766aa675d05766$export$dc391c7d81907d3a);
    $parcel$export(module.exports, "trackJsdFetchErrors", ()=>$c0766aa675d05766$export$ebdbd98df5a27905);
    var $jcw0u;
    var $a7EYT;
    const $c0766aa675d05766$export$ca021921d5c56515 = {
        AUTOMATION_SETTINGS: 'AutomationSettings',
        KNOWLEDGE: 'Knowledge',
        QUEUES: 'Queues',
        CSAT: 'Csat'
    };
    const $c0766aa675d05766$export$cca3c4e11cb0a5ce = 1000;
    const $c0766aa675d05766$export$dc391c7d81907d3a = 4000;
    const $c0766aa675d05766$export$ebdbd98df5a27905 = async (payload)=>{
        const { error: error, attributes: attributes } = payload;
        if (error instanceof (0, (0, parcelRequire("a7EYT")).JsdFetchError)) {
            const { reasonKey: reasonKey } = error;
            (0, (0, parcelRequire("jcw0u")).trackFetchErrors)({
                ...payload,
                attributes: {
                    ...attributes,
                    reasonKey: reasonKey
                }
            });
            return;
        }
        (0, (0, parcelRequire("jcw0u")).trackFetchErrors)(payload);
    };
});
parcelRegister("a7EYT", function(module, exports) {
    $parcel$export(module.exports, "JsdFetchError", ()=>$99def0fa5fc488a1$export$fee0012ae6cb3438);
    $parcel$export(module.exports, "performGetRequest", ()=>$99def0fa5fc488a1$export$4a53ae1be8ec80c7);
    $parcel$export(module.exports, "performPutRequest", ()=>$99def0fa5fc488a1$export$9ead1f9103e6de6b);
    $parcel$export(module.exports, "performPostRequest", ()=>$99def0fa5fc488a1$export$692a4d9808143175);
    $parcel$export(module.exports, "performDeleteRequest", ()=>$99def0fa5fc488a1$export$8ef51cba9d28f819);
    var $gccSB = parcelRequire("gccSB");
    var $cjFoH = parcelRequire("cjFoH");
    var $aDvGo;
    var $fnyT4;
    var $jJZqs;
    var $eusud;
    const $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY = 'validation.error';
    class $99def0fa5fc488a1$export$fee0012ae6cb3438 extends (0, (0, parcelRequire("jJZqs")).default) {
        constructor(statusCode, message, reasonKey, response){
            super(statusCode, (0, ($parcel$interopDefault($gccSB)))(message) ? `Fetch call failed with status code: ${statusCode}` : message);
            this.name = 'JsdFetchError';
            if (!(0, ($parcel$interopDefault($cjFoH)))(reasonKey)) this.reasonKey = reasonKey;
            if (!(0, ($parcel$interopDefault($cjFoH)))(response)) this.response = response;
        }
    }
    const $99def0fa5fc488a1$var$transformMessageErrorsFromServer = (errors = [])=>errors.reduce((messages, { errorMessage: errorMessage })=>{
            messages.push(errorMessage);
            return messages;
        }, []).join(' ');
    const $99def0fa5fc488a1$var$putOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PUT'
    };
    const $99def0fa5fc488a1$var$postOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'POST'
    };
    const $99def0fa5fc488a1$var$deleteOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'DELETE'
    };
    const $99def0fa5fc488a1$var$patchOptions = {
        ...(0, (0, parcelRequire("aDvGo")).default),
        method: 'PATCH'
    };
    const $99def0fa5fc488a1$var$processResponse = async (response)=>{
        if ((0, $3cd8a0ece36fbae5$export$9de493bcd9b1d977) === response.status) {
            const jsonResponse = await response.json();
            const { errors: errors, reasonKey: reasonKey } = jsonResponse;
            if (reasonKey === $99def0fa5fc488a1$var$VALIDATION_ERROR_KEY) throw (0, (0, parcelRequire("eusud")).transformValidationErrorFromServer)(jsonResponse);
            const message = $99def0fa5fc488a1$var$transformMessageErrorsFromServer(errors);
            throw new $99def0fa5fc488a1$export$fee0012ae6cb3438(response.status, message, reasonKey, jsonResponse);
        }
        if (!response.ok) {
            const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`, traceId);
            else throw new (0, (0, parcelRequire("jJZqs")).default)(response.status, `Error server response: ${response.status}`);
        }
        if (response.status === (0, $3cd8a0ece36fbae5$export$3288b14b6745c572)) return Promise.resolve(null);
        return response.text().then((text)=>text ? JSON.parse(text) : null);
    };
    const $99def0fa5fc488a1$export$4a53ae1be8ec80c7 = (url, options = {})=>fetch(url, {
            ...(0, (0, parcelRequire("aDvGo")).default),
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$9ead1f9103e6de6b = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$putOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$692a4d9808143175 = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$postOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$8ef51cba9d28f819 = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$deleteOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
    const $99def0fa5fc488a1$export$52be6ab13d7e758d = (url, options = {})=>fetch(url, {
            ...$99def0fa5fc488a1$var$patchOptions,
            ...options
        }).then($99def0fa5fc488a1$var$processResponse);
});
const $3cd8a0ece36fbae5$export$ff39ebd4bb12b718 = 201;
const $3cd8a0ece36fbae5$export$3288b14b6745c572 = 204;
const $3cd8a0ece36fbae5$export$9de493bcd9b1d977 = 400;
const $3cd8a0ece36fbae5$export$67d19e9a991baa07 = 401;
const $3cd8a0ece36fbae5$export$a3269a3914b007e3 = 403;
const $3cd8a0ece36fbae5$export$8bca792d963eb0ef = 404;
const $3cd8a0ece36fbae5$export$4a3cb39801694eee = 407;
const $3cd8a0ece36fbae5$export$fa405bbf47d510e2 = 408;
const $3cd8a0ece36fbae5$export$c09e7ea0fc79f34f = 409;
const $3cd8a0ece36fbae5$export$5244030134e99 = 412;
const $3cd8a0ece36fbae5$export$f90ac1df0b60853d = 413;
const $3cd8a0ece36fbae5$export$a447d0a965e16776 = 422;
const $3cd8a0ece36fbae5$export$3b48aba8957000cd = 426;
const $3cd8a0ece36fbae5$export$6763168a631449a2 = 429;
const $3cd8a0ece36fbae5$export$e813cd7045fcc98d = 500;
const $3cd8a0ece36fbae5$export$2ce38d41a306034e = 502;
const $3cd8a0ece36fbae5$export$974c37534b0191b1 = 503;
const $3cd8a0ece36fbae5$export$5400e8dddac3fcf3 = 504;
parcelRegister("gq0sA", function(module, exports) {
    $parcel$export(module.exports, "usePageContext", ()=>$2299d7a4f1092420$export$9c25024bdfe755f7);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $dxCvy;
    var $9OXo1;
    var $dFOAR;
    const $2299d7a4f1092420$var$getProjectContextResource = ()=>(0, (0, parcelRequire("dxCvy")).projectContextResourceWithCache);
    const $2299d7a4f1092420$export$9c25024bdfe755f7 = (customContext)=>{
        const tenantContext = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const { data: projectContext, loading: projectContextLoading, error: projectContextError } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($2299d7a4f1092420$var$getProjectContextResource(), customContext);
        const [{ data: serviceDeskContext, loading: serviceDeskLoading, error: serviceDeskError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)(projectContext?.projectKey || undefined, customContext);
        const pageContextData = (0, $5uXOq.useMemo)(()=>({
                data: projectContext && serviceDeskContext ? {
                    serviceDeskContext: {
                        portalId: serviceDeskContext.portalId,
                        portalUrl: serviceDeskContext.portalUrl,
                        canSeeNewIssueView: serviceDeskContext.canSeeNewIssueView,
                        userRole: serviceDeskContext.userRole,
                        serviceDeskId: serviceDeskContext.serviceDeskId
                    },
                    projectContext: {
                        projectId: projectContext.projectId,
                        projectKey: projectContext.projectKey,
                        projectName: projectContext.projectName,
                        projectType: projectContext.projectType,
                        isAdmin: projectContext.isProjectAdmin || tenantContext.isAdmin,
                        isProjectSimplified: projectContext.simplified
                    },
                    tenantContext: {
                        baseUrl: tenantContext.baseUrl,
                        locale: tenantContext.locale,
                        userFullname: tenantContext.userFullname,
                        cloudId: tenantContext.cloudId,
                        fabricPfDirUrl: tenantContext.fabricPfDirUrl,
                        atlassianAccountId: tenantContext.atlassianAccountId,
                        isJiraAdmin: tenantContext.isAdmin,
                        isSiteAdmin: tenantContext.isSiteAdmin,
                        activationId: tenantContext.activationId
                    }
                } : null,
                loading: projectContextLoading || serviceDeskLoading,
                error: serviceDeskError || projectContextError || null
            }), [
            tenantContext,
            projectContext,
            serviceDeskContext,
            projectContextLoading,
            serviceDeskLoading,
            serviceDeskError,
            projectContextError
        ]);
        return [
            pageContextData
        ];
    };
});
parcelRegister("dFOAR", function(module, exports) {
    $parcel$export(module.exports, "useServiceDeskContext", ()=>$6c09349e97fba749$export$712ead87353ac687);
    var $5uXOq = parcelRequire("5uXOq");
    var $324W5;
    var $cAofY;
    const $6c09349e97fba749$var$getServiceDeskContextResource = ()=>(0, (0, parcelRequire("cAofY")).serviceDeskContextResource);
    const $6c09349e97fba749$export$712ead87353ac687 = (projectKey, customContext)=>{
        const { data: data, loading: loading, error: error, refresh: refreshCache } = (0, (0, parcelRequire("324W5")).useResourceWithCustomRouterContext)($6c09349e97fba749$var$getServiceDeskContextResource(), customContext);
        (0, $5uXOq.useEffect)(()=>{
            if (!false) refreshCache();
        }, [
            projectKey,
            refreshCache
        ]);
        return [
            {
                data: data,
                loading: loading,
                error: error
            }
        ];
    };
});
parcelRegister("lw2HC", function(module, exports) {
    $parcel$export(module.exports, "initialCreateCategoryData", ()=>$ba746da67c53f4b3$export$4947e9942a5d137c);
    $parcel$export(module.exports, "KnowledgeCommonSubscriber", ()=>$ba746da67c53f4b3$export$d226f0c95b79366b);
    $parcel$export(module.exports, "UserCapabilitiesSubscriber", ()=>$ba746da67c53f4b3$export$42b7b5df8c1dee52);
    $parcel$export(module.exports, "useFlagData", ()=>$ba746da67c53f4b3$export$a9ac4a6dcb7104bf);
    $parcel$export(module.exports, "useGetCategory", ()=>$ba746da67c53f4b3$export$3fa52226f8fff61e);
    $parcel$export(module.exports, "useDraftShareId", ()=>$ba746da67c53f4b3$export$2602997fd4d9b312);
    $parcel$export(module.exports, "useArticleId", ()=>$ba746da67c53f4b3$export$a5eb46485735066a);
    $parcel$export(module.exports, "useIsFetchingDraftDetails", ()=>$ba746da67c53f4b3$export$428db75bed41f9d);
    $parcel$export(module.exports, "useRedirectionData", ()=>$ba746da67c53f4b3$export$e30071c464cba7f9);
    $parcel$export(module.exports, "useUserCapabilities", ()=>$ba746da67c53f4b3$export$7ae10e817e068c57);
    $parcel$export(module.exports, "useIsPermittedSpaces", ()=>$ba746da67c53f4b3$export$60270d772f1f3c76);
    $parcel$export(module.exports, "useCategoriesData", ()=>$ba746da67c53f4b3$export$56b47c5ebac10997);
    $parcel$export(module.exports, "useCreateCategoryData", ()=>$ba746da67c53f4b3$export$1e7300097c003415);
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $kz5Uo;
    var $cSB1I;
    const $ba746da67c53f4b3$export$61e797cf03b496e1 = {
        hasConfluenceLicense: false,
        articleUserCapabilities: {
            canCreateArticle: false
        },
        spaceUserCapabilities: {
            editableSpaces: [],
            readableSpaces: []
        }
    };
    const $ba746da67c53f4b3$export$4947e9942a5d137c = {
        isSubmitting: false,
        formValues: {
            name: '',
            description: ''
        },
        error: {
            formError: undefined,
            fieldErrors: undefined
        },
        createdCategory: null
    };
    const $ba746da67c53f4b3$export$d4c72bab9d6cc13a = {
        draftShareId: '',
        articleId: '',
        published: false,
        closed: false,
        deleted: false,
        redirectionData: {
            onPublishRedirectUrl: '',
            onCloseRedirectUrl: ''
        },
        isFetchingDraftDetails: false,
        spacesPermitted: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        permittedSpaces: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        userCapabilities: {
            isLoading: false,
            error: null,
            data: {
                ...$ba746da67c53f4b3$export$61e797cf03b496e1
            }
        },
        linkedSpaces: {
            isLoading: false,
            data: null,
            error: null,
            totalSize: 0
        },
        showConfluenceCreatePageError: false,
        categoriesData: {
            isLoading: true,
            categories: [],
            isCategoriesSupported: false,
            error: null
        },
        createCategoryData: {
            ...$ba746da67c53f4b3$export$4947e9942a5d137c
        },
        spaceKey: '',
        flags: []
    };
    const $ba746da67c53f4b3$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $ba746da67c53f4b3$export$d4c72bab9d6cc13a,
        actions: (0, parcelRequire("kz5Uo")).actions,
        name: 'KnowledgeCommonStore'
    });
    const $ba746da67c53f4b3$export$d226f0c95b79366b = (0, (0, parcelRequire("51nlc")).createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9);
    const $ba746da67c53f4b3$export$42b7b5df8c1dee52 = (0, (0, parcelRequire("51nlc")).createSubscriber)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        displayName: 'UserCapabilitiesSubscriber',
        selector: (0, (0, parcelRequire("cSB1I")).getUserCapabilities)
    });
    const $ba746da67c53f4b3$export$a3c47cea95d8bbd1 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCommonFlags)
    });
    const $ba746da67c53f4b3$export$a9ac4a6dcb7104bf = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getKnowledgeCommonFlags)
    });
    const $ba746da67c53f4b3$export$3fa52226f8fff61e = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCategory)
    });
    const $ba746da67c53f4b3$export$2602997fd4d9b312 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getDraftShareId)
    });
    const $ba746da67c53f4b3$export$a5eb46485735066a = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getArticleId)
    });
    const $ba746da67c53f4b3$export$428db75bed41f9d = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getIsFetchingDraftDetails)
    });
    const $ba746da67c53f4b3$export$e30071c464cba7f9 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getRedirectionData)
    });
    const $ba746da67c53f4b3$export$7ae10e817e068c57 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getUserCapabilities)
    });
    const $ba746da67c53f4b3$export$60270d772f1f3c76 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getPermittedSpaces)
    });
    const $ba746da67c53f4b3$export$40685b8df387d08 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getLinkedSpaces)
    });
    const $ba746da67c53f4b3$export$56b47c5ebac10997 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCategoriesData)
    });
    const $ba746da67c53f4b3$export$1e7300097c003415 = (0, (0, parcelRequire("3sQ5x")).createHook)($ba746da67c53f4b3$export$6f57813fe9f31bf9, {
        selector: (0, (0, parcelRequire("cSB1I")).getCreateCategoryData)
    });
});
parcelRegister("kz5Uo", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$78ea76781fae4c5f$export$e324594224ef24da);
    var $lx7EO;
    var $heXZI;
    var $dsFMC;
    var $aInVL;
    var $3twc2;
    var $klUDT;
    var $2tTYZ;
    var $ik7FP;
    var $dAXEk;
    var $dIiIO;
    var $gpe3Z;
    var $1TU0Q;
    var $jIuZj;
    var $eP4xZ;
    var $8QyFO;
    var $1VmcQ;
    const $78ea76781fae4c5f$export$e324594224ef24da = {
        setRedirectionData: (0, parcelRequire("1TU0Q")).setRedirectionData,
        resetRedirectionData: (0, parcelRequire("1TU0Q")).resetRedirectionData,
        publishSuccess: (0, parcelRequire("aInVL")).publishSuccess,
        savedSuccess: (0, parcelRequire("3twc2")).savedSuccess,
        fetchDraftAndNavigateToEditor: (0, parcelRequire("ik7FP")).fetchDraftAndNavigateToEditor,
        navigateCreateDraftRoute: (0, parcelRequire("gpe3Z")).navigateCreateDraftRoute,
        fetchCreateArticlePermission: (0, parcelRequire("2tTYZ")).fetchCreateArticlePermission,
        fetchLinkedSpaces: (0, parcelRequire("dAXEk")).fetchLinkedSpaces,
        resetDraftArticleData: (0, parcelRequire("8QyFO")).resetDraftArticleData,
        articleDeleteSuccess: (0, parcelRequire("lx7EO")).articleDeleteSuccess,
        fetchUserCapabilities: (0, parcelRequire("dIiIO")).fetchUserCapabilities,
        fetchCategories: (0, parcelRequire("klUDT")).fetchCategories,
        reorderCategories: (0, parcelRequire("eP4xZ")).reorderCategories,
        createCategory: (0, parcelRequire("heXZI")).createCategory,
        handleFormInputChange: (0, parcelRequire("heXZI")).handleFormInputChange,
        resetCreatedCategory: (0, parcelRequire("heXZI")).resetCreatedCategory,
        updateCategorySuccess: (0, parcelRequire("1VmcQ")).updateCategorySuccess,
        deleteCategorySuccess: (0, parcelRequire("dsFMC")).deleteCategorySuccess,
        removeCommonFlag: (0, parcelRequire("jIuZj")).removeCommonFlag
    };
});
parcelRegister("lx7EO", function(module, exports) {
    $parcel$export(module.exports, "articleDeleteSuccess", ()=>$cfa855108534d4c5$export$7e6f4a244457270c);
    const $cfa855108534d4c5$export$7e6f4a244457270c = (articleId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                deleted: true,
                articleId: articleId
            });
        };
});
parcelRegister("heXZI", function(module, exports) {
    $parcel$export(module.exports, "createCategory", ()=>$015500bcb6a585cb$export$7ce9dbcc6d544b1);
    $parcel$export(module.exports, "handleFormInputChange", ()=>$015500bcb6a585cb$export$8e52c4bd9075cb96);
    $parcel$export(module.exports, "resetCreatedCategory", ()=>$015500bcb6a585cb$export$98485bfbe8c8269a);
    var $jcw0u;
    var $8zOmE;
    var $fPjip;
    var $j8qrr;
    var $lw2HC;
    const $015500bcb6a585cb$export$7ce9dbcc6d544b1 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
            const { formValues: formValues } = {
                ...getState().createCategoryData
            };
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    isSubmitting: true
                }
            });
            try {
                const category = await (0, (0, parcelRequire("j8qrr")).createCategory)(projectId, formValues, activationId);
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: [
                            ...getState().categoriesData.categories,
                            category
                        ]
                    },
                    createCategoryData: {
                        ...(0, (0, parcelRequire("lw2HC")).initialCreateCategoryData),
                        createdCategory: category
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'categoryCreate success');
            } catch (error) {
                const { fieldErrors: fieldErrors, formError: formError } = (0, (0, parcelRequire("fPjip")).toErrors)(error);
                setState({
                    ...getState(),
                    createCategoryData: {
                        ...getState().createCategoryData,
                        isSubmitting: false,
                        error: {
                            formError: formError,
                            fieldErrors: fieldErrors
                        }
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'categoryCreate',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
            }
        };
    const $015500bcb6a585cb$export$8e52c4bd9075cb96 = (field, value)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    formValues: {
                        ...getState().createCategoryData.formValues,
                        [field]: value
                    }
                }
            });
        };
    const $015500bcb6a585cb$export$98485bfbe8c8269a = ()=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                createCategoryData: {
                    ...getState().createCategoryData,
                    createdCategory: null
                }
            });
        };
});
parcelRegister("fPjip", function(module, exports) {
    $parcel$export(module.exports, "toErrors", ()=>$fdef67eb1eab7980$export$b0ccdd1765e7cb42);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $i2U8h;
    var $guSo6;
    const $fdef67eb1eab7980$var$errorKeyToMessage = {
        'jsd.apollo.error.limit.exceeded': (0, (0, parcelRequire("i2U8h")).default).categoriesLimitExceeded,
        'jsd.apollo.error.project.permission.no.view.project.permission': (0, (0, parcelRequire("i2U8h")).default).categoriesNoPermission,
        'jsd.apollo.field.error.category.name.cannot.be.blank': (0, (0, parcelRequire("i2U8h")).default).categoriesNameFieldBlank,
        'jsd.apollo.field.error.category.exceeded.name.length': (0, (0, parcelRequire("i2U8h")).default).categoriesNameFieldTooLong,
        'jsd.apollo.field.error.category.description.cannot.be.blank': (0, (0, parcelRequire("i2U8h")).default).categoriesDescriptionFieldBlank,
        'jsd.apollo.field.error.category.exceeded.description.length': (0, (0, parcelRequire("i2U8h")).default).categoriesDescriptionFieldTooLong
    };
    const $fdef67eb1eab7980$export$b0ccdd1765e7cb42 = (errorResponse)=>{
        const fieldErrorsResponse = errorResponse.fieldErrors || {};
        const fieldErrors = Object.keys(fieldErrorsResponse).reduce((acc, field)=>({
                ...acc,
                [field]: {
                    message: $fdef67eb1eab7980$var$errorKeyToMessage[fieldErrorsResponse[field].errorKey] || (0, (0, parcelRequire("i2U8h")).default).categoriesGenericMessage
                }
            }), {});
        const formError = errorResponse.errorKey ? {
            message: $fdef67eb1eab7980$var$errorKeyToMessage[errorResponse.errorKey] || (0, (0, parcelRequire("i2U8h")).default).categoriesGenericMessage
        } : undefined;
        return {
            formError: formError,
            fieldErrors: fieldErrors
        };
    };
    const $fdef67eb1eab7980$export$7ce9dbcc6d544b1 = (projectId, activationId, payload)=>(0, (0, parcelRequire("guSo6")).createCategory)(projectId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw({
                nativeError: errorResponse,
                formattedError: $fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)
            }));
    const $fdef67eb1eab7980$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload)=>(0, (0, parcelRequire("guSo6")).updateCategory)(projectId, categoryId, activationId, payload).catch((errorResponse)=>(0, $kVLXA.Observable).throw($fdef67eb1eab7980$export$b0ccdd1765e7cb42(errorResponse)));
});
parcelRegister("i2U8h", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ed327d012ea36dd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $6ed327d012ea36dd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        categoriesGenericMessage: {
            "id": "servicedesk-knowledge-services.categories-generic-message",
            "defaultMessage": "We couldn't create the category. Wait a moment, then try again."
        },
        categoriesNoPermission: {
            "id": "servicedesk-knowledge-services.categories-no-permission",
            "defaultMessage": "You'll need to be an agent to create a category. Ask an admin to check your permissions."
        },
        categoriesLimitExceeded: {
            "id": "servicedesk-knowledge-services.categories-limit-exceeded",
            "defaultMessage": "You have exceeded the maximum number of categories for this project. The maximum number of categories per project is 30."
        },
        categoriesNameFieldBlank: {
            "id": "servicedesk-knowledge-services.categories-name-field-blank",
            "defaultMessage": "Name cannot be blank"
        },
        categoriesDescriptionFieldBlank: {
            "id": "servicedesk-knowledge-services.categories-description-field-blank",
            "defaultMessage": "Description cannot be blank"
        },
        categoriesNameFieldTooLong: {
            "id": "servicedesk-knowledge-services.categories-name-field-too-long",
            "defaultMessage": "Name cannot be longer than 100 characters"
        },
        categoriesDescriptionFieldTooLong: {
            "id": "servicedesk-knowledge-services.categories-description-field-too-long",
            "defaultMessage": "Description cannot be longer than 150 characters"
        }
    });
});
parcelRegister("guSo6", function(module, exports) {
    $parcel$export(module.exports, "listCategories", ()=>$61a0664d6d43d351$export$db54be5b1772ef4b);
    $parcel$export(module.exports, "createCategory", ()=>$61a0664d6d43d351$export$7ce9dbcc6d544b1);
    $parcel$export(module.exports, "updateCategory", ()=>$61a0664d6d43d351$export$daaacb0271870c9);
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $5OrSA;
    var $2Lj35;
    const $61a0664d6d43d351$export$db54be5b1772ef4b = (projectId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`);
    };
    const $61a0664d6d43d351$export$c0a90379dccf4f2f = (projectId, categoryId, activationId, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category/`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}`, {
            method: 'DELETE'
        });
    };
    const $61a0664d6d43d351$export$7ce9dbcc6d544b1 = (projectId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>{
        const categoryPath = `api/project/${projectId}/category`;
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/${categoryPath}`, {
            method: 'POST',
            body: JSON.stringify(payload)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $61a0664d6d43d351$export$ce3ba7bb235ce057 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        let body = {
            articleId: articleId,
            featured: isFeatured
        };
        body = {
            ...body,
            spaceKey: spaceKey
        };
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/article`, {
            method: 'POST',
            body: JSON.stringify(body)
        });
    };
    const $61a0664d6d43d351$export$b6002acecf935894 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/spaceKey/${spaceKey}/article/${articleId}`, {
            method: 'DELETE'
        });
    const $61a0664d6d43d351$export$daaacb0271870c9 = (projectId, categoryId, activationId, payload, apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e))=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}`, {
            method: 'PUT',
            body: JSON.stringify(payload)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    const $61a0664d6d43d351$export$b9f575b5360cf530 = ({ projectId: projectId, categoryId: categoryId, articleId: articleId, isFeatured: isFeatured, spaceKey: spaceKey, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        let body = {
            featured: isFeatured
        };
        body = {
            ...body,
            spaceKey: spaceKey
        };
        return (0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/${(0, (0, parcelRequire("2Lj35")).categoryGuidToString)(categoryId)}/article/${articleId}`, {
            method: 'PUT',
            body: JSON.stringify(body)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
    };
    const $61a0664d6d43d351$export$e90b3dc42a0ddf96 = ({ projectId: projectId, categories: categories, activationId: activationId, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>(0, (0, parcelRequire("5OrSA")).fetchJson$)(`${apolloPath}/${activationId}/api/project/${projectId}/category/order`, {
            method: 'PUT',
            body: JSON.stringify(categories)
        }).catch(({ response: response })=>(0, $kVLXA.Observable).throw(response));
});
parcelRegister("5OrSA", function(module, exports) {
    $parcel$export(module.exports, "fetchJson$", ()=>$f90c86f7d1f72b9b$export$2ba52855e389d39e);
    $parcel$export(module.exports, "fetchText$", ()=>$f90c86f7d1f72b9b$export$64ab95a52860b608);
    parcelRequire("3q49N");
    parcelRequire("c66Ur");
    var $561FV = parcelRequire("561FV");
    var $kVLXA = parcelRequire("kVLXA");
    var $487fd;
    var $7f4tk;
    var $7zmUm;
    const $f90c86f7d1f72b9b$var$buildErrorResponse = (message, statusCode, traceId)=>({
            response: {
                errors: [
                    {
                        errorMessage: message
                    }
                ],
                reasonKey: 'generic.error',
                reasonCode: `${statusCode}`
            },
            statusCode: statusCode,
            traceId: traceId
        });
    const $f90c86f7d1f72b9b$var$toAnError = (error)=>{
        const traceId = error.traceId;
        try {
            const response = JSON.parse(error.message);
            if ((0, ($parcel$interopDefault($561FV)))(response, 'message') && (0, ($parcel$interopDefault($561FV)))(response, 'status-code')) return $f90c86f7d1f72b9b$var$buildErrorResponse(response.message, parseInt(response['status-code'], 10), traceId);
            return {
                response: response,
                statusCode: error.statusCode,
                traceId: traceId
            };
        } catch (e) {
            return $f90c86f7d1f72b9b$var$buildErrorResponse(error.message, error.statusCode, traceId);
        }
    };
    const $f90c86f7d1f72b9b$export$6d71b655afe1638d = (url, opts)=>(0, (0, parcelRequire("7f4tk")).default)(url, opts).catch((error)=>Promise.reject($f90c86f7d1f72b9b$var$toAnError(error)));
    const $f90c86f7d1f72b9b$export$2ba52855e389d39e = (url, opts)=>(0, (0, parcelRequire("487fd")).default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
    const $f90c86f7d1f72b9b$export$64ab95a52860b608 = (url, opts)=>(0, (0, parcelRequire("7zmUm")).default)(url, opts).catch((error)=>(0, $kVLXA.Observable).throw($f90c86f7d1f72b9b$var$toAnError(error)));
});
parcelRegister("487fd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96196282ac54fa24$export$2e2bcd8739ae039);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("c66Ur");
    parcelRequire("1oQta");
    parcelRequire("d0pqD");
    parcelRequire("fPS7b");
    var $aDvGo;
    var $x9xyg;
    var $fnyT4;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    const $96196282ac54fa24$var$noContentStatus = 204;
    const $96196282ac54fa24$var$transformUrl = (url)=>{
        const lUrl = url.replace(/\//g, '_');
        const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
        return resUrl;
    };
    function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
        const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
        let key;
        const isPerformanceCheckEnabled = !!perf;
        if (isPerformanceCheckEnabled) {
            const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
            key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
            (0, (0, parcelRequire("x9xyg")).setMark)(`BEGIN_${key}`);
        }
        return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, (0, parcelRequire("aDvGo")).default), opts), (0, (0, parcelRequire("51xpa")).makeObservabilityHeaders)(url)))).mergeMap((response)=>{
            if (isPerformanceCheckEnabled) (0, (0, parcelRequire("x9xyg")).setMark)(`END_${key}`);
            if (!response.ok) {
                const { status: status } = response;
                return response.text().then((str)=>{
                    const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
                    if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, str, traceId);
                    else throw new (0, (0, parcelRequire("jJZqs")).default)(status, str);
                });
            }
            if (typeof headersProcessor === 'function') headersProcessor(response.headers);
            if (response.status === $96196282ac54fa24$var$noContentStatus) return (0, $kVLXA.Observable).of(null);
            return response.json();
        });
    }
    var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;
});
parcelRegister("7zmUm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$198ed207dec01cca$export$2e2bcd8739ae039);
    var $7uUwQ = parcelRequire("7uUwQ");
    var $kVLXA = parcelRequire("kVLXA");
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    var $aDvGo;
    var $fnyT4;
    var $jJZqs;
    var $8KpGl;
    var $51xpa;
    const $198ed207dec01cca$var$noContentStatus = 204;
    var $198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, (0, parcelRequire("8KpGl")).getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, (0, parcelRequire("aDvGo")).default), options), (0, (0, parcelRequire("51xpa")).makeObservabilityHeaders)(url)))).mergeMap((response)=>{
            if (!response.ok) {
                const { status: status } = response;
                const traceId = response.headers.get((0, (0, parcelRequire("fnyT4")).TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, (0, parcelRequire("jJZqs")).default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
                else throw new (0, (0, parcelRequire("jJZqs")).default)(status);
            }
            if (response.status === $198ed207dec01cca$var$noContentStatus) return (0, $kVLXA.Observable).of(null);
            return (0, $kVLXA.Observable).of(response.responseText || 'OK');
        });
});
parcelRegister("2Lj35", function(module, exports) {
    $parcel$export(module.exports, "categoryGuidToString", ()=>$6a4fff955a10b2dc$export$43162cfd3260b2fe);
    $parcel$export(module.exports, "toCategoryGuid", ()=>$6a4fff955a10b2dc$export$be5c80c4ad1faf99);
    const $6a4fff955a10b2dc$export$804bcd2704a6d077 = (appLinkId)=>appLinkId;
    const $6a4fff955a10b2dc$export$43162cfd3260b2fe = (guid)=>guid;
    const $6a4fff955a10b2dc$export$be5c80c4ad1faf99 = (guid)=>guid;
});
const $45c806b56a43da0e$export$8ce6d23ffa1a190a = '/jsd-apollo';
const $45c806b56a43da0e$export$f224912d4ec4705e = '/gateway/api/jsd-apollo-stargate/sharded/workspace';
const $d7e8e0de2b5415e5$export$d42203c46ecda0b5 = 'ncs';
const $d7e8e0de2b5415e5$export$22ba648868203514 = 'synchrony';
const $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c = 'JSM';
const $d7e8e0de2b5415e5$export$a40257481ddef37e = 'atlassianAccount';
const $d7e8e0de2b5415e5$export$d57b6b390e78d90f = 'jsm-nebula';
const $d7e8e0de2b5415e5$export$85314a8fbb8155e1 = 'MONTHLY';
const $d7e8e0de2b5415e5$export$d1eb58f682ad65ad = 'ANNUAL';
const $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4 = 'INACTIVE';
parcelRegister("j8qrr", function(module, exports) {
    $parcel$export(module.exports, "createCategory", ()=>$50b96e14ac428fad$export$7ce9dbcc6d544b1);
    var $7f4tk;
    const $50b96e14ac428fad$export$f0b37505cff627e3 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
    const $50b96e14ac428fad$export$7ce9dbcc6d544b1 = (projectId, payload, activationId)=>{
        const url = $50b96e14ac428fad$export$f0b37505cff627e3(projectId, activationId);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };
});
parcelRegister("dsFMC", function(module, exports) {
    $parcel$export(module.exports, "deleteCategorySuccess", ()=>$3c95377777bb5342$export$aa2eaa46022bd60b);
    const $3c95377777bb5342$export$aa2eaa46022bd60b = (categoryId)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: [
                        ...getState().categoriesData.categories.filter((category)=>category.id !== categoryId)
                    ]
                }
            });
        };
});
parcelRegister("aInVL", function(module, exports) {
    $parcel$export(module.exports, "publishSuccess", ()=>$7490ef4194dfdc47$export$a435a3808fe5155f);
    const $7490ef4194dfdc47$export$a435a3808fe5155f = ({ articleId: articleId, draftShareId: draftShareId, spaceKey: spaceKey })=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                published: true,
                articleId: articleId,
                draftShareId: draftShareId,
                spaceKey: spaceKey
            });
        };
});
parcelRegister("3twc2", function(module, exports) {
    $parcel$export(module.exports, "savedSuccess", ()=>$7e5a4ff1e4d62f76$export$2bf589c797fe6b4f);
    const $7e5a4ff1e4d62f76$export$2bf589c797fe6b4f = ({ articleId: articleId, draftShareId: draftShareId })=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                closed: true,
                articleId: articleId,
                draftShareId: draftShareId
            });
        };
});
parcelRegister("klUDT", function(module, exports) {
    $parcel$export(module.exports, "fetchCategories", ()=>$1022d05f23af34ff$export$416ec9f5729de215);
    var $jcw0u;
    var $8zOmE;
    var $1d66W;
    const $1022d05f23af34ff$export$416ec9f5729de215 = (projectId, analyticsEvent, activationId)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...getState(),
                categoriesData: {
                    ...initialState.categoriesData,
                    isLoading: true
                }
            });
            try {
                const { categories: categories, categoriesSupported: categoriesSupported } = await (0, (0, parcelRequire("1d66W")).fetchCategories)(projectId, activationId);
                setState({
                    ...getState(),
                    categoriesData: {
                        categories: categories,
                        isCategoriesSupported: categoriesSupported,
                        isLoading: false,
                        error: null
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'onFetchCategories success', {
                    projectId: projectId
                });
            } catch (error) {
                setState({
                    ...getState(),
                    categoriesData: {
                        ...initialState.categoriesData,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'onFetchCategoriesFailure',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
            }
        };
});
parcelRegister("1d66W", function(module, exports) {
    $parcel$export(module.exports, "fetchCategories", ()=>$b7d9de4ee333d2ce$export$416ec9f5729de215);
    var $7f4tk;
    const $b7d9de4ee333d2ce$export$5cf4b2ebebe43941 = (projectId, activationId)=>`${0, $45c806b56a43da0e$export$f224912d4ec4705e}/${activationId}/api/project/${projectId}/category`;
    const $b7d9de4ee333d2ce$export$416ec9f5729de215 = (projectId, activationId)=>{
        const url = $b7d9de4ee333d2ce$export$5cf4b2ebebe43941(projectId, activationId);
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET'
        });
    };
});
parcelRegister("2tTYZ", function(module, exports) {
    $parcel$export(module.exports, "fetchCreateArticlePermission", ()=>$ac71c34762d51de0$export$c5bf032e1fb1ad18);
    var $8zOmE;
    var $cVUDi;
    var $5ukFp;
    const $ac71c34762d51de0$var$EVENT_NAME = 'createPermissionsForSpace';
    const $ac71c34762d51de0$export$c5bf032e1fb1ad18 = ({ cloudId: cloudId, spaceKeys: spaceKeys, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...initialState,
                spacesPermitted: {
                    ...initialState.spacesPermitted,
                    isLoading: true
                }
            });
            try {
                const { promotedSpaces: promotedSpaces } = await (0, (0, parcelRequire("5ukFp")).getCreatePermissionsForSpace)(cloudId, spaceKeys);
                const permittedSpaces = promotedSpaces.spaces.map(({ id: id, text: text })=>({
                        spaceKey: id,
                        spaceName: text
                    }));
                setState({
                    ...initialState,
                    spacesPermitted: {
                        ...initialState.spacesPermitted,
                        isLoading: false,
                        data: permittedSpaces,
                        totalSize: promotedSpaces.spaces.length
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `${$ac71c34762d51de0$var$EVENT_NAME} succedded`);
            } catch (error) {
                setState({
                    ...initialState,
                    spacesPermitted: {
                        ...initialState.spacesPermitted,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, 'createSpacePermissions', 'knowledgeCommon');
            }
        };
});
parcelRegister("cVUDi", function(module, exports) {
    $parcel$export(module.exports, "fireErrorAnalyticsEvents", ()=>$9d8927ca77b8220f$export$b84e314c48e09c44);
    $parcel$export(module.exports, "getPageOnDelete", ()=>$9d8927ca77b8220f$export$99689dbe56145ad5);
    $parcel$export(module.exports, "fireCustomErrorAnalytics", ()=>$9d8927ca77b8220f$export$3d13cbe76aeaf5e8);
    $parcel$export(module.exports, "getViewArticleUrl", ()=>$9d8927ca77b8220f$export$4b1de73aa951498c);
    $parcel$export(module.exports, "getAllDraftsUrl", ()=>$9d8927ca77b8220f$export$939c0821a1193768);
    $parcel$export(module.exports, "getAllArticlesUrl", ()=>$9d8927ca77b8220f$export$240e98bbb8304c52);
    $parcel$export(module.exports, "getFlag", ()=>$9d8927ca77b8220f$export$a19b74191e00c5e);
    $parcel$export(module.exports, "getCommonFlagData", ()=>$9d8927ca77b8220f$export$f44d45dc3db56277);
    $parcel$export(module.exports, "filterSupportedBillingPeriod", ()=>$9d8927ca77b8220f$export$9f13ed259dc4b1bf);
    $parcel$export(module.exports, "formatTrialEndDate", ()=>$9d8927ca77b8220f$export$da56c66ce2766e02);
    var $jcw0u;
    var $jJZqs;
    var $8zOmE;
    var $fyKAM;
    const $9d8927ca77b8220f$var$TEAM_NAME = 'jsm-nebula';
    const $9d8927ca77b8220f$export$1a5a4674dd906e7e = (statusCode)=>statusCode === 0;
    const $9d8927ca77b8220f$export$d31fd506ce75fa65 = (statusCode)=>statusCode >= 400 && statusCode < 500;
    const $9d8927ca77b8220f$export$53ee51427129200c = (statusCode)=>$9d8927ca77b8220f$export$1a5a4674dd906e7e(statusCode) || $9d8927ca77b8220f$export$d31fd506ce75fa65(statusCode);
    const $9d8927ca77b8220f$export$b84e314c48e09c44 = (error, id, packageName, attributes)=>{
        if (error && typeof error.statusCode === 'number') {
            const { statusCode: statusCode } = error;
            const lowPriorityError = statusCode >= 400 && statusCode < 500;
            const errorMetaId = lowPriorityError ? `${id}__4xx` : `${id}`;
            const transformedError = error instanceof (0, (0, parcelRequire("jJZqs")).default) ? error : new (0, (0, parcelRequire("jJZqs")).default)(statusCode);
            const errorObj = {
                error: transformedError,
                meta: {
                    id: errorMetaId,
                    packageName: packageName,
                    teamName: $9d8927ca77b8220f$var$TEAM_NAME
                },
                ...attributes && {
                    attributes: attributes
                }
            };
            (0, (0, parcelRequire("jcw0u")).default)(errorObj);
        } else (0, (0, parcelRequire("jcw0u")).default)({
            error: error instanceof Error ? error : new Error(JSON.stringify(error)),
            meta: {
                id: `${id}__JS_ERROR`,
                packageName: packageName,
                teamName: $9d8927ca77b8220f$var$TEAM_NAME
            },
            ...attributes && {
                attributes: attributes
            }
        });
    };
    const $9d8927ca77b8220f$export$99689dbe56145ad5 = (currentPage, updateDataSize, perPage)=>{
        const lastPage = Math.ceil(updateDataSize / perPage);
        return currentPage > lastPage ? lastPage : currentPage;
    };
    const $9d8927ca77b8220f$export$3d13cbe76aeaf5e8 = ({ error: error, event: event, id: id, packageName: packageName, attributes: attributes })=>{
        if (error && typeof error.statusCode === 'number' && !$9d8927ca77b8220f$export$53ee51427129200c(error.statusCode)) event && (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(event, id);
        $9d8927ca77b8220f$export$b84e314c48e09c44(error, id, packageName, attributes);
    };
    const $9d8927ca77b8220f$export$4b1de73aa951498c = (projectKey, contentId, spaceKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles/${contentId}?spaceKey=${spaceKey}`;
    const $9d8927ca77b8220f$export$939c0821a1193768 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/drafts`;
    const $9d8927ca77b8220f$export$240e98bbb8304c52 = (projectKey)=>`/jira/servicedesk/projects/${projectKey}/knowledge/articles`;
    const $9d8927ca77b8220f$export$a19b74191e00c5e = (title, description, flagType)=>({
            title: title,
            description: description,
            id: (0, (0, parcelRequire("fyKAM")).generateNanoId)(),
            flagType: flagType
        });
    const $9d8927ca77b8220f$export$a6125e21263de883 = (state)=>{
        const { draftShareId: draftShareId, articleId: articleId, published: published, closed: closed, deleted: deleted } = state;
        const isDraftPublished = Boolean(draftShareId && articleId && published && !closed);
        const isArticleSavedWithUnpublishedChanges = Boolean(!draftShareId && articleId && !published && closed);
        const isDraftSavedWithUnpublishedChanges = Boolean(draftShareId && articleId && closed && !published);
        const isArticleDeleted = Boolean(articleId && deleted);
        return {
            isDraftPublished: isDraftPublished,
            isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges,
            isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges,
            isArticleDeleted: isArticleDeleted
        };
    };
    const $9d8927ca77b8220f$export$f44d45dc3db56277 = (state, messages)=>{
        let flag = {
            id: '',
            title: {
                id: '',
                defaultMessage: '',
                description: ''
            },
            description: {
                id: '',
                defaultMessage: '',
                description: ''
            },
            type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
        };
        const { showConfluenceCreatePageError: showConfluenceCreatePageError } = state;
        if (showConfluenceCreatePageError) {
            flag = {
                id: 'draftErrorFlag',
                title: messages.confluenceCreatePageFailureTitle,
                description: messages.confluenceCreatePageFailureDescription,
                type: (0, $3026c2757a468eb7$export$f215947b3d76a6b7)
            };
            return flag;
        }
        const { isDraftPublished: isDraftPublished, isArticleSavedWithUnpublishedChanges: isArticleSavedWithUnpublishedChanges, isDraftSavedWithUnpublishedChanges: isDraftSavedWithUnpublishedChanges, isArticleDeleted: isArticleDeleted } = $9d8927ca77b8220f$export$a6125e21263de883(state);
        if (isDraftPublished) flag = {
            id: 'draftPublishedFlag',
            title: messages.draftSuccessFlagTitle,
            description: messages.draftSuccessFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isDraftSavedWithUnpublishedChanges) flag = {
            id: 'draftSavedFlag',
            title: messages.draftSuccessSavedFlagTitle,
            description: messages.draftSuccessSavedFlagDescription || '',
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isArticleSavedWithUnpublishedChanges) flag = {
            id: 'draftPublishedFlag',
            title: messages.articleSuccessSavedFlagTitle,
            description: messages.articleSuccessSavedFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        if (isArticleDeleted) flag = {
            id: 'articleDeletedFlag',
            title: messages.articleDeletedFlagTitle,
            description: messages.articleDeletedFlagDescription,
            type: (0, $3026c2757a468eb7$export$516433e8a6db7503)
        };
        return flag;
    };
    const $9d8927ca77b8220f$export$9f13ed259dc4b1bf = (billingPeriod)=>{
        if (billingPeriod === (0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1)) return 0, $d7e8e0de2b5415e5$export$85314a8fbb8155e1;
        if (billingPeriod === (0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad)) return 0, $d7e8e0de2b5415e5$export$d1eb58f682ad65ad;
        return 0, $d7e8e0de2b5415e5$export$1635bbf8efc1cbc4;
    };
    const $9d8927ca77b8220f$export$da56c66ce2766e02 = (trialEndDate)=>{
        if (trialEndDate != null && trialEndDate !== '') return new Date(trialEndDate);
        return null;
    };
});
const $3026c2757a468eb7$export$516433e8a6db7503 = 'SUCCESS';
const $3026c2757a468eb7$export$a0a5e05447abb018 = 'WARNING';
const $3026c2757a468eb7$export$f215947b3d76a6b7 = 'ERROR';
const $3026c2757a468eb7$export$21bdd502a5302e06 = 'INFO';
parcelRegister("fyKAM", function(module, exports) {
    $parcel$export(module.exports, "generateNanoId", ()=>$ef446b866ecb6566$export$a4f5444a5996c185);
    var $9J4h7;
    const $ef446b866ecb6566$export$a4f5444a5996c185 = ()=>(0, (0, parcelRequire("9J4h7")).nanoid)(12);
    const $ef446b866ecb6566$export$e73c8bd0f20705a = ()=>(0, (0, parcelRequire("9J4h7")).nanoid)();
});
parcelRegister("9J4h7", function(module, exports) {
    $parcel$export(module.exports, "nanoid", ()=>$714ba1f43c1bc4b0$export$ac4959f4f1338dfc);
    let $714ba1f43c1bc4b0$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
    let $714ba1f43c1bc4b0$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
        let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
        let step = -~(1.6 * mask * defaultSize / alphabet.length);
        return (size = defaultSize)=>{
            let id = '';
            while(true){
                let bytes = getRandom(step);
                let j = step;
                while(j--){
                    id += alphabet[bytes[j] & mask] || '';
                    if (id.length === size) return id;
                }
            }
        };
    };
    let $714ba1f43c1bc4b0$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$714ba1f43c1bc4b0$export$a5cee9e955a615e5(alphabet, size, $714ba1f43c1bc4b0$export$4385e60b38654f68);
    let $714ba1f43c1bc4b0$export$ac4959f4f1338dfc = (size = 21)=>{
        let id = '';
        let bytes = crypto.getRandomValues(new Uint8Array(size));
        while(size--)id += (0, $11cc6b8f5f8db98c$export$2b646eea95309f00)[bytes[size] & 63];
        return id;
    };
});
const $11cc6b8f5f8db98c$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';
parcelRegister("5ukFp", function(module, exports) {
    $parcel$export(module.exports, "getCreatePermissionsForSpace", ()=>$4d7a1d82dc21430a$export$a4d40fb662e5fd46);
    $parcel$export(module.exports, "getLinkedSpaces", ()=>$4d7a1d82dc21430a$export$b764c9ef97480a8e);
    var $ebyGx = parcelRequire("ebyGx");
    var $7f4tk;
    const $4d7a1d82dc21430a$export$a4d40fb662e5fd46 = (cloudId, spaceKeys)=>{
        const queryString = (0, $ebyGx.stringify)({
            promotedSpaceKey: spaceKeys,
            promotedSpacesLimit: spaceKeys.length,
            otherSpacesLimit: 0
        });
        return (0, (0, parcelRequire("7f4tk")).default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/spaces?${queryString}`);
    };
    const $4d7a1d82dc21430a$export$b764c9ef97480a8e = (projectKey)=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/servicedesk/1/servicedesk/${projectKey}/kb`);
});
parcelRegister("ik7FP", function(module, exports) {
    $parcel$export(module.exports, "fetchDraftAndNavigateToEditor", ()=>$76ec8efa1f92f234$export$e8292dc9536b9de8);
    var $EQUM3;
    var $8zOmE;
    var $cVUDi;
    var $gpe3Z;
    var $1TU0Q;
    const $76ec8efa1f92f234$var$EVENT_NAME = 'createNewConfluencePage';
    const $76ec8efa1f92f234$export$e8292dc9536b9de8 = ({ spaceKey: spaceKey, routerActions: routerActions, projectKey: projectKey, projectId: projectId, onCloseRedirectUrl: onCloseRedirectUrl = '', onPublishRedirectUrl: onPublishRedirectUrl = '', analyticsEvent: analyticsEvent, topicId: topicId, topicName: topicName })=>async ({ setState: setState, getState: getState, dispatch: dispatch })=>{
            try {
                setState({
                    ...getState(),
                    isFetchingDraftDetails: true
                });
                const createContentParams = {
                    spaceKey: spaceKey,
                    parentProductContentContainerId: String(projectId),
                    parentProduct: (0, $d7e8e0de2b5415e5$export$f6fc4a5779d5dc2c),
                    title: topicName
                };
                const { contentId: contentId, draftShareId: draftShareId } = await (0, (0, parcelRequire("EQUM3")).createContent)(createContentParams);
                setState({
                    ...getState(),
                    articleId: contentId,
                    draftShareId: draftShareId,
                    isFetchingDraftDetails: false
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${$76ec8efa1f92f234$var$EVENT_NAME} succedded`, {
                    topicId: topicId
                });
                dispatch((0, (0, parcelRequire("1TU0Q")).setRedirectionData)({
                    onCloseRedirectUrl: onCloseRedirectUrl,
                    onPublishRedirectUrl: onPublishRedirectUrl
                }));
                dispatch((0, (0, parcelRequire("gpe3Z")).navigateCreateDraftRoute)({
                    routerActions: routerActions,
                    projectKey: projectKey,
                    topicId: topicId,
                    selectedSpaceKey: spaceKey
                }));
            } catch (error) {
                setState({
                    ...getState(),
                    isFetchingDraftDetails: false,
                    showConfluenceCreatePageError: true
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, $76ec8efa1f92f234$var$EVENT_NAME, 'knowledgeCommon');
            }
        };
});
parcelRegister("EQUM3", function(module, exports) {
    $parcel$export(module.exports, "createContent", ()=>$3a868b7a198d9613$export$41c7a4cacf5bab80);
    var $kcRHd;
    const $3a868b7a198d9613$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS = [
        'parentProduct',
        'parentProductContentContainerId',
        'spaceKey'
    ];
    const $3a868b7a198d9613$export$4de094b68e927f31 = 'X-Atl-EmbeddablePage-EntityIDs';
    const $3a868b7a198d9613$export$41c7a4cacf5bab80 = async ({ spaceKey: spaceKey, parentPageId: parentPageId, parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, domain: domain = '', title: title, body: body })=>{
        const payload = {
            type: 'page',
            status: 'draft',
            metadata: {
                properties: {
                    editor: {
                        value: 'v2'
                    }
                },
                frontend: {
                    embedded: true
                }
            },
            space: {
                key: spaceKey
            },
            title: title,
            body: body
        };
        if (parentPageId) payload.ancestors = [
            {
                id: parentPageId
            }
        ];
        const baseurl = domain ? `https://${domain}` : domain;
        const unlicensedAccessHeader = $3a868b7a198d9613$var$getUnlicensedAccessHeader({
            parentProduct: parentProduct,
            parentProductContentContainerId: parentProductContentContainerId,
            spaceKey: spaceKey
        });
        let response;
        try {
            response = await fetch(`${baseurl}/wiki/rest/api/content`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    credentials: 'include',
                    ...unlicensedAccessHeader
                },
                body: JSON.stringify(payload)
            });
        } catch (e) {
            throw new Error(`Network failure ${e}`);
        }
        const responseJson = await response.json();
        if (!response.ok) throw new (0, (0, parcelRequire("kcRHd")).CreateError)(`Status: ${responseJson.statusCode} Message: ${responseJson.message}`, responseJson.statusCode);
        return {
            draftShareId: $3a868b7a198d9613$var$getDraftShareId(responseJson),
            spaceKey: responseJson?.space?.key,
            contentId: responseJson?.id,
            status: responseJson?.status,
            subType: responseJson?.subType
        };
    };
    const $3a868b7a198d9613$var$getDraftShareId = (data)=>(data?._links?.editui || '').match(/draftShareId=(.*?)(#|&|$)/)?.[1] || undefined;
    const $3a868b7a198d9613$var$getUnlicensedAccessHeader = ({ parentProduct: parentProduct, parentProductContentContainerId: parentProductContentContainerId, spaceKey: spaceKey })=>{
        const headerValue = {
            parentProduct: parentProduct,
            parentProductContentContainerId: parentProductContentContainerId,
            spaceKey: spaceKey
        };
        const isValidHeader = $3a868b7a198d9613$var$REQUIRED_UNLICENSED_ACCESS_HEADER_KEYS.every((key)=>Boolean(headerValue[key]));
        return isValidHeader ? {
            [$3a868b7a198d9613$export$4de094b68e927f31]: JSON.stringify(headerValue)
        } : undefined;
    };
});
parcelRegister("kcRHd", function(module, exports) {
    $parcel$export(module.exports, "CreateError", ()=>$833f2119ab19b46a$export$91ee1703d5a5ab8b);
    class $833f2119ab19b46a$export$91ee1703d5a5ab8b extends Error {
        constructor(message, statusCode){
            super(message);
            this.statusCode = statusCode;
        }
    }
});
parcelRegister("gpe3Z", function(module, exports) {
    $parcel$export(module.exports, "navigateCreateDraftRoute", ()=>$4f804a011e2794bb$export$4e7c7ad076f5f5fc);
    var $6udl5;
    const $4f804a011e2794bb$export$4e7c7ad076f5f5fc = ({ routerActions: routerActions, projectKey: projectKey, selectedSpaceKey: selectedSpaceKey, topicId: topicId })=>async ({ getState: getState })=>{
            const { articleId: articleId, draftShareId: draftShareId } = {
                ...getState()
            };
            const EDIT_DRAFT_ROUTE = (0, (0, parcelRequire("6udl5")).getDraftEditUrl)(projectKey, selectedSpaceKey, articleId, draftShareId, topicId);
            routerActions.push(EDIT_DRAFT_ROUTE);
        };
});
parcelRegister("6udl5", function(module, exports) {
    $parcel$export(module.exports, "getDraftEditUrl", ()=>$ed1cffe35d42c3de$export$5e8433ae3ce7c696);
    $parcel$export(module.exports, "isDraftCreatedWithNCS", ()=>$ed1cffe35d42c3de$export$fc0fa1dc4749f854);
    $parcel$export(module.exports, "findCategory", ()=>$ed1cffe35d42c3de$export$93e9d221203aed67);
    const $ed1cffe35d42c3de$export$5e8433ae3ce7c696 = (projectKey, selectedSpaceKey, articleId, draftShareId, topicId)=>{
        let draftEditUrl = `/jira/servicedesk/projects/${projectKey}/knowledge/space/${selectedSpaceKey}/articles/${articleId}/edit?draftShareId=${draftShareId}`;
        if (topicId) draftEditUrl += `&topicId=${topicId}`;
        return draftEditUrl;
    };
    const $ed1cffe35d42c3de$export$fc0fa1dc4749f854 = (collabService)=>collabService === (0, $d7e8e0de2b5415e5$export$d42203c46ecda0b5);
    const $ed1cffe35d42c3de$export$93e9d221203aed67 = (categoriesData, categoryId)=>{
        if (categoriesData.categories) return categoriesData.categories.find((category)=>category.id === categoryId);
        return undefined;
    };
});
parcelRegister("1TU0Q", function(module, exports) {
    $parcel$export(module.exports, "setRedirectionData", ()=>$35239289cee1669b$export$c026d4a8850c302d);
    $parcel$export(module.exports, "resetRedirectionData", ()=>$35239289cee1669b$export$7c6d6762f8b5b4db);
    const $35239289cee1669b$export$c026d4a8850c302d = (redirectionData)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                redirectionData: redirectionData
            });
        };
    const $35239289cee1669b$export$7c6d6762f8b5b4db = ()=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                redirectionData: {
                    onPublishRedirectUrl: '',
                    onCloseRedirectUrl: ''
                }
            });
        };
});
parcelRegister("dAXEk", function(module, exports) {
    $parcel$export(module.exports, "fetchLinkedSpaces", ()=>$1976703425aa0479$export$1999596e4ea30c16);
    var $5ukFp;
    const $1976703425aa0479$export$1999596e4ea30c16 = (projectKey)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...initialState,
                linkedSpaces: {
                    ...initialState.linkedSpaces,
                    isLoading: true
                }
            });
            try {
                const response = await (0, (0, parcelRequire("5ukFp")).getLinkedSpaces)(projectKey);
                const linkedSpaces = response.map(({ spaceKey: spaceKey, spaceName: spaceName })=>({
                        spaceKey: spaceKey,
                        spaceName: spaceName
                    }));
                setState({
                    ...initialState,
                    linkedSpaces: {
                        ...initialState.linkedSpaces,
                        isLoading: false,
                        data: linkedSpaces,
                        totalSize: linkedSpaces.length
                    }
                });
            } catch (error) {
                setState({
                    ...initialState,
                    linkedSpaces: {
                        ...initialState.linkedSpaces,
                        isLoading: false,
                        error: error
                    }
                });
            }
        };
});
parcelRegister("dIiIO", function(module, exports) {
    $parcel$export(module.exports, "fetchUserCapabilities", ()=>$c701340a34445280$export$d1eac56717011ed4);
    var $8zOmE;
    var $cVUDi;
    var $8FVnr;
    const $c701340a34445280$var$EVENT_NAME = 'fetchUserCapabilities';
    const $c701340a34445280$export$d1eac56717011ed4 = (projectId, activationId, analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const initialState = {
                ...getState()
            };
            setState({
                ...getState(),
                userCapabilities: {
                    ...initialState.userCapabilities,
                    isLoading: true
                }
            });
            try {
                const data = await (0, (0, parcelRequire("8FVnr")).fetchUserCapabilities)(projectId, activationId);
                setState({
                    ...getState(),
                    userCapabilities: {
                        ...initialState.userCapabilities,
                        isLoading: false,
                        data: data,
                        error: null
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, `${$c701340a34445280$var$EVENT_NAME} succeeded`);
            } catch (error) {
                setState({
                    ...getState(),
                    userCapabilities: {
                        ...initialState.userCapabilities,
                        isLoading: false,
                        error: error
                    }
                });
                (0, (0, parcelRequire("cVUDi")).fireErrorAnalyticsEvents)(error, `${$c701340a34445280$var$EVENT_NAME} failed`, 'knowledgeCommon');
            }
        };
});
parcelRegister("8FVnr", function(module, exports) {
    $parcel$export(module.exports, "fetchUserCapabilities", ()=>$11ef201d32e47a4e$export$d1eac56717011ed4);
    var $7f4tk;
    const $11ef201d32e47a4e$export$d1eac56717011ed4 = (projectId, activationId)=>{
        const url = `${(0, $45c806b56a43da0e$export$f224912d4ec4705e)}/${activationId}/api/project/${projectId}/user/capabilities`;
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'GET'
        });
    };
});
parcelRegister("jIuZj", function(module, exports) {
    $parcel$export(module.exports, "removeCommonFlag", ()=>$3807c62af5ab354f$export$a2af96a4f99f3900);
    const $3807c62af5ab354f$export$a2af96a4f99f3900 = (flagId)=>async ({ getState: getState, setState: setState })=>{
            const { flags: currentFlags } = getState();
            const flags = currentFlags.filter(({ id: id })=>id !== flagId);
            setState({
                ...getState(),
                flags: flags
            });
        };
});
parcelRegister("eP4xZ", function(module, exports) {
    $parcel$export(module.exports, "reorderCategories", ()=>$d1c7d54ec7e0876f$export$32f957e287d37daa);
    var $ajpes = parcelRequire("ajpes");
    var $jcw0u;
    var $8zOmE;
    var $261Bl;
    var $1wnS6;
    const $d1c7d54ec7e0876f$export$cde74ed295a2b838 = (categories, fromIndex, toIndex)=>{
        const newCategories = [
            ...categories
        ];
        const movedItem = newCategories.splice(fromIndex, 1)[0];
        if (movedItem !== undefined) newCategories.splice(toIndex, 0, movedItem);
        return newCategories;
    };
    const $d1c7d54ec7e0876f$export$32f957e287d37daa = (projectId, fromIndex, toIndex, analyticsEvent, activationId, onReorderMismatch, onReorderFailure)=>async ({ setState: setState, getState: getState })=>{
            const categoryToBeMovedId = getState().categoriesData.categories[fromIndex].id;
            const initiallyOrderedCategories = [
                ...getState().categoriesData.categories
            ];
            const newlyOrderedCategories = $d1c7d54ec7e0876f$export$cde74ed295a2b838(getState().categoriesData.categories, fromIndex, toIndex);
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: newlyOrderedCategories
                }
            });
            try {
                const { categories: categories } = await (0, (0, parcelRequire("1wnS6")).orderCategories)({
                    projectId: projectId,
                    activationId: activationId,
                    categories: [
                        {
                            categoryId: categoryToBeMovedId,
                            order: toIndex
                        }
                    ]
                });
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(analyticsEvent, 'category reordered', {
                    id: (0, (0, parcelRequire("261Bl")).categoryGuidToString)(categoryToBeMovedId)
                });
                const expectedCategoryIdOrder = newlyOrderedCategories.map((category)=>category.id);
                const actualCategoryIdOrder = categories.map((categoryResult)=>categoryResult.id);
                if (!(0, ($parcel$interopDefault($ajpes)))(expectedCategoryIdOrder, actualCategoryIdOrder)) {
                    setState({
                        ...getState(),
                        categoriesData: {
                            ...getState().categoriesData,
                            categories: categories
                        }
                    });
                    onReorderMismatch();
                }
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'reorderCategories',
                        packageName: 'jiraServicedeskKnowledgeCommon',
                        teamName: (0, $d7e8e0de2b5415e5$export$d57b6b390e78d90f)
                    },
                    error: error
                });
                setState({
                    ...getState(),
                    categoriesData: {
                        ...getState().categoriesData,
                        categories: [
                            ...initiallyOrderedCategories
                        ]
                    }
                });
                onReorderFailure();
            }
        };
});
parcelRegister("1wnS6", function(module, exports) {
    $parcel$export(module.exports, "orderCategories", ()=>$56b61b6811b7fda7$export$e90b3dc42a0ddf96);
    var $7f4tk;
    const $56b61b6811b7fda7$export$e90b3dc42a0ddf96 = ({ projectId: projectId, activationId: activationId, categories: categories, apolloPath: apolloPath = (0, $45c806b56a43da0e$export$f224912d4ec4705e) })=>{
        const url = `${apolloPath}/${activationId}/api/project/${projectId}/category/order`;
        return (0, (0, parcelRequire("7f4tk")).default)(url, {
            method: 'PUT',
            body: JSON.stringify(categories)
        });
    };
});
parcelRegister("8QyFO", function(module, exports) {
    $parcel$export(module.exports, "resetDraftArticleData", ()=>$c895191ddea664b2$export$e4dbf2710e8c685d);
    const $c895191ddea664b2$export$e4dbf2710e8c685d = (resetDelete)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                draftShareId: '',
                closed: false,
                published: false,
                showConfluenceCreatePageError: false,
                spaceKey: '',
                ...resetDelete && {
                    deleted: false,
                    articleId: ''
                }
            });
        };
});
parcelRegister("1VmcQ", function(module, exports) {
    $parcel$export(module.exports, "updateCategorySuccess", ()=>$10ef8418d41dbca6$export$7d46e556893bba77);
    const $10ef8418d41dbca6$export$7d46e556893bba77 = (updatedCategory)=>async ({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                categoriesData: {
                    ...getState().categoriesData,
                    categories: getState().categoriesData.categories.map((category)=>category.id === updatedCategory.id ? updatedCategory : category)
                }
            });
        };
});
parcelRegister("cSB1I", function(module, exports) {
    $parcel$export(module.exports, "getDraftShareId", ()=>$b10361f0e26ced23$export$f31b9480a5e4fdcf);
    $parcel$export(module.exports, "getArticleId", ()=>$b10361f0e26ced23$export$2d21c0faccc1d33f);
    $parcel$export(module.exports, "getIsFetchingDraftDetails", ()=>$b10361f0e26ced23$export$19d926b900e1c065);
    $parcel$export(module.exports, "getRedirectionData", ()=>$b10361f0e26ced23$export$fdde4bb390e025db);
    $parcel$export(module.exports, "getPermittedSpaces", ()=>$b10361f0e26ced23$export$4a419b2d3bb6a3fc);
    $parcel$export(module.exports, "getLinkedSpaces", ()=>$b10361f0e26ced23$export$b764c9ef97480a8e);
    $parcel$export(module.exports, "getUserCapabilities", ()=>$b10361f0e26ced23$export$f7db3ef62579b328);
    $parcel$export(module.exports, "getCategoriesData", ()=>$b10361f0e26ced23$export$b416461ac52d8504);
    $parcel$export(module.exports, "getCreateCategoryData", ()=>$b10361f0e26ced23$export$e0cf4a4b69bbc694);
    $parcel$export(module.exports, "getCategory", ()=>$b10361f0e26ced23$export$410364bbb673ddbc);
    $parcel$export(module.exports, "getCommonFlags", ()=>$b10361f0e26ced23$export$b94d9d28300025a9);
    $parcel$export(module.exports, "getKnowledgeCommonFlags", ()=>$b10361f0e26ced23$export$1a5b9662b382779c);
    var $cVUDi;
    var $6udl5;
    const $b10361f0e26ced23$export$c9cab98530df1a79 = ({ published: published })=>published;
    const $b10361f0e26ced23$export$f31b9480a5e4fdcf = ({ draftShareId: draftShareId })=>draftShareId;
    const $b10361f0e26ced23$export$2d21c0faccc1d33f = ({ articleId: articleId })=>articleId;
    const $b10361f0e26ced23$export$19d926b900e1c065 = ({ isFetchingDraftDetails: isFetchingDraftDetails })=>isFetchingDraftDetails;
    const $b10361f0e26ced23$export$fdde4bb390e025db = (state)=>state.redirectionData;
    const $b10361f0e26ced23$export$4a419b2d3bb6a3fc = (state)=>state.spacesPermitted;
    const $b10361f0e26ced23$export$b764c9ef97480a8e = (state)=>state.linkedSpaces;
    const $b10361f0e26ced23$export$f7db3ef62579b328 = (state)=>state.userCapabilities;
    const $b10361f0e26ced23$export$b416461ac52d8504 = (state)=>state.categoriesData;
    const $b10361f0e26ced23$export$e0cf4a4b69bbc694 = (state)=>state.createCategoryData;
    const $b10361f0e26ced23$export$410364bbb673ddbc = (state, categoryId)=>(0, (0, parcelRequire("6udl5")).findCategory)(state.categoriesData, categoryId);
    const $b10361f0e26ced23$export$b94d9d28300025a9 = ({ flags: flags })=>flags;
    const $b10361f0e26ced23$export$1a5b9662b382779c = (state, messages)=>(0, (0, parcelRequire("cVUDi")).getCommonFlagData)({
            ...state
        }, messages);
});
parcelRegister("7U3kA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c2ae948e58435135$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    var $4EETE;
    var $bTmOP;
    var $2Yyer;
    var $4qSaV;
    var $i9cxd;
    var $2TrWf;
    var $hZHze;
    var $9fuVs;
    var $koVbs;
    var $9oIFN;
    var $5TOVG;
    const $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { isSubmitting: isSubmitting = false, isDisabled: isDisabled = false, onChange: onChange, onClose: onClose, onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), {
            onClose: onClose,
            width: "small"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i9cxd")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2TrWf")).default), null, formatMessage((0, (0, parcelRequire("5TOVG")).default).title))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Yyer")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hZHze")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9oIFN")).default), {
            onChange: onChange,
            onSubmit: onSubmit,
            formError: formError,
            fieldErrors: fieldErrors,
            isDisabled: isSubmitting
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4qSaV")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4EETE")).default), {
            appearance: "primary",
            onClick: onSubmit,
            isLoading: isSubmitting,
            isDisabled: isDisabled
        }, formatMessage((0, (0, parcelRequire("5TOVG")).default).createAction)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            onClick: onClose
        }, formatMessage((0, (0, parcelRequire("5TOVG")).default).cancelAction)))));
    };
    var $c2ae948e58435135$export$2e2bcd8739ae039 = $c2ae948e58435135$var$KnowledgeHubCreateCategoryStateless;
});
parcelRegister("hZHze", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$69dc4a27be9f367e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $dvXtt;
    var $7GEKO;
    var $gvRPW;
    class $69dc4a27be9f367e$var$ViewTracker extends (0, $5uXOq.Component) {
        componentDidMount() {
            this.props.onMount();
        }
        render() {
            return null;
        }
    }
    const $69dc4a27be9f367e$var$ViewTrackerWithAnalytics = (0, (0, parcelRequire("dvXtt")).default)({
        componentName: 'view-tracker'
    })((0, (0, parcelRequire("7GEKO")).default)({
        onMount: (createEvent)=>createEvent({
                action: (0, (0, parcelRequire("gvRPW")).PAGE_EVENT_ACTION)
            }).fire()
    })($69dc4a27be9f367e$var$ViewTracker));
    var $69dc4a27be9f367e$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($69dc4a27be9f367e$var$ViewTrackerWithAnalytics, {
            onMount: (0, ($parcel$interopDefault($8Rkzz)))
        });
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("9oIFN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$49788ff41cd45114$export$2e2bcd8739ae039);
    var $8oe80;
    var $3pn3a;
    var $49788ff41cd45114$export$2e2bcd8739ae039 = (0, (0, parcelRequire("8oe80")).default)('form', {
        onSubmit: 'submitted'
    })((0, (0, parcelRequire("3pn3a")).default));
});
parcelRegister("3pn3a", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$da6b524a14a97bee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $knKRw;
    var $gT07g;
    var $6HBFQ;
    var $8mGGj;
    var $koVbs;
    var $7cbM0;
    var $7VpFm;
    const $da6b524a14a97bee$var$CreateCategoryForm = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { onSubmit: onSubmit, formError: formError, fieldErrors: fieldErrors, isDisabled: isDisabled = false, testId: testId } = props;
        const createOnChangeHandlerForField = (field)=>(e)=>{
                props.onChange(field, e.currentTarget.value);
            };
        const errorMessage = (field)=>fieldErrors && !!fieldErrors[field] ? formatMessage(fieldErrors[field].message) : undefined;
        return ((0, ($parcel$interopDefault($5uXOq))).createElement("form", {
            onSubmit: onSubmit,
            disabled: isDisabled
        }, formError && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gT07g")).default), {
            appearance: "error",
            testId: testId && `${testId}--section-message`
        }, formatMessage(formError.message)), (0, ($parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, (0, parcelRequire("7VpFm")).default).helpText)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knKRw")).default), {
            error: errorMessage('name'),
            label: formatMessage((0, (0, parcelRequire("7VpFm")).default).nameFieldLabel),
            isRequired: true,
            name: "name"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7cbM0")).default), {
                error: errorMessage('name')
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8mGGj")).default), {
                ...fieldProps,
                isRequired: true,
                autoComplete: "off",
                placeholder: formatMessage((0, (0, parcelRequire("7VpFm")).default).nameFieldPlaceholder),
                isInvalid: fieldErrors && !!fieldErrors.name,
                maxLength: 100,
                onChange: createOnChangeHandlerForField('name'),
                isDisabled: isDisabled,
                autoFocus: true
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("knKRw")).default), {
            error: errorMessage('description'),
            label: formatMessage((0, (0, parcelRequire("7VpFm")).default).descriptionFieldLabel),
            name: "description"
        }, ({ fieldProps: fieldProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7cbM0")).default), {
                error: errorMessage('description')
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6HBFQ")).default), {
                ...fieldProps,
                maxLength: 150,
                minimumRows: 3,
                autoComplete: "off",
                placeholder: formatMessage((0, (0, parcelRequire("7VpFm")).default).descriptionFieldPlaceholder),
                isInvalid: fieldErrors && !!fieldErrors.description,
                isDisabled: isDisabled,
                onChange: createOnChangeHandlerForField('description')
            })))));
    };
    var $da6b524a14a97bee$export$2e2bcd8739ae039 = $da6b524a14a97bee$var$CreateCategoryForm;
});
parcelRegister("knKRw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$110243b5cd2eb92d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    parcelRequire("3joPi");
    var $bkJDg;
    var $1FTEF;
    var $lOr6E;
    var $7VnW8;
    var $8knNZ;
    var $6cAn5 = parcelRequire("6cAn5");
    function $110243b5cd2eb92d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $110243b5cd2eb92d$var$fieldWrapperStyles = {
        name: "wkpnc",
        styles: "margin-block-start:var(--ds-space-100, 8px)"
    };
    function $110243b5cd2eb92d$var$isEvent(event) {
        return Boolean(event && event.target);
    }
    function $110243b5cd2eb92d$var$isFunction(x) {
        return typeof x === 'function';
    }
    function $110243b5cd2eb92d$var$usePreviousRef(current) {
        const ref = (0, $5uXOq.useRef)(current);
        (0, $5uXOq.useEffect)(()=>{
            ref.current = current;
        });
        return ref;
    }
    function $110243b5cd2eb92d$var$isShallowEqual(previousValue, currentValue) {
        if (previousValue === currentValue) return true;
        if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
        if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
        return false;
    }
    function $110243b5cd2eb92d$export$2e2bcd8739ae039(props) {
        const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).FormContext));
        const isDisabled = (0, $5uXOq.useContext)((0, (0, parcelRequire("lOr6E")).IsDisabledContext)) || props.isDisabled || false;
        const defaultValue = $110243b5cd2eb92d$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
        const latestPropsRef = $110243b5cd2eb92d$var$usePreviousRef(props);
        const isDefaultValueChanged = !$110243b5cd2eb92d$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
        const [state, setState] = (0, $5uXOq.useState)({
            fieldProps: {
                onChange: ()=>{},
                onBlur: ()=>{},
                onFocus: ()=>{},
                value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
            },
            error: undefined,
            valid: false,
            meta: {
                dirty: false,
                dirtySinceLastSubmit: false,
                touched: false,
                valid: false,
                validating: false,
                submitting: false,
                submitFailed: false,
                error: undefined,
                submitError: undefined
            }
        });
        const latestStateRef = $110243b5cd2eb92d$var$usePreviousRef(state);
        (0, $5uXOq.useEffect)(()=>{
            typeof $6cAn5;
            function fieldStateToMeta(value = {}) {
                return {
                    dirty: value.dirty || false,
                    dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                    touched: value.touched || false,
                    valid: value.valid || false,
                    submitting: value.submitting || false,
                    submitFailed: value.submitFailed || false,
                    error: value.error,
                    submitError: value.submitError,
                    validating: !!value.validating
                };
            }
            const unregister = registerField(latestPropsRef.current.name, isDefaultValueChanged || $110243b5cd2eb92d$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
                const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
                const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
                const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
                const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
                const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
                function getTransform(eventOrValue, currentValue) {
                    if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                    if ($110243b5cd2eb92d$var$isEvent(eventOrValue)) {
                        const { currentTarget: currentTarget } = eventOrValue;
                        if (currentTarget.type === 'checkbox') {
                            if (currentTarget.checked) return currentTarget.value || true;
                            return currentTarget.value ? undefined : false;
                        } else if (currentTarget) return currentTarget.value;
                    } else return eventOrValue;
                }
                setState({
                    fieldProps: {
                        onChange: (e)=>{
                            fieldState.change(getTransform(e, fieldState.value));
                        },
                        onBlur: fieldState.blur,
                        onFocus: fieldState.focus,
                        value: fieldState.value
                    },
                    error: modifiedError || undefined,
                    valid: modifiedValid || false,
                    meta: fieldStateToMeta(fieldState)
                });
            }, {
                dirty: true,
                dirtySinceLastSubmit: true,
                touched: true,
                valid: true,
                submitting: true,
                submitFailed: true,
                value: true,
                error: true,
                submitError: true,
                validating: true
            }, {
                getValidator: ()=>function validate(value, formState, fieldState) {
                        const supplied = latestPropsRef.current.validate;
                        if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                    }
            });
            return unregister;
        }, [
            latestPropsRef,
            latestStateRef,
            registerField,
            props.name,
            isDefaultValueChanged
        ]);
        const uid = (0, (0, parcelRequire("bkJDg")).useId)();
        const fieldId = (0, $5uXOq.useMemo)(()=>{
            return props.id ? props.id : `${props.name}-${uid}`;
        }, [
            props.id,
            props.name,
            uid
        ]);
        const getDescribedBy = ()=>{
            let value = '';
            if (state.error) value += `${fieldId}-error `;
            if (state.valid) value += `${fieldId}-valid `;
            return `${value}${fieldId}-helper`;
        };
        const extendedFieldProps = {
            ...state.fieldProps,
            name: props.name,
            isDisabled: isDisabled,
            isInvalid: Boolean(state.error),
            isRequired: Boolean(props.isRequired),
            'aria-invalid': state.error ? 'true' : 'false',
            'aria-describedby': getDescribedBy(),
            'aria-labelledby': `${fieldId}-label`,
            id: fieldId
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $110243b5cd2eb92d$var$fieldWrapperStyles,
            "data-testid": props.testId
        }, props.label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7VnW8")).Label), {
            htmlFor: fieldId,
            id: `${fieldId}-label`,
            testId: props.testId && `${props.testId}--label`
        }, props.label, props.isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8knNZ")).default), null), props.elementAfterLabel), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("1FTEF")).FieldId).Provider, {
            value: fieldId
        }, props.children({
            fieldProps: extendedFieldProps,
            error: state.error,
            valid: state.valid,
            meta: state.meta
        })));
    }
});
parcelRegister("1FTEF", function(module, exports) {
    $parcel$export(module.exports, "FieldId", ()=>$b38f467b8b7721b2$export$3c4232819458a302);
    var $5uXOq = parcelRequire("5uXOq");
    const $b38f467b8b7721b2$export$3c4232819458a302 = (0, $5uXOq.createContext)(undefined);
});
parcelRegister("lOr6E", function(module, exports) {
    $parcel$export(module.exports, "FormContext", ()=>$75a5255a3d60692c$export$c24727297075ec6a);
    $parcel$export(module.exports, "IsDisabledContext", ()=>$75a5255a3d60692c$export$c17cf6b332a82dbc);
    $parcel$export(module.exports, "default", ()=>$75a5255a3d60692c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lqWDn = parcelRequire("lqWDn");
    var $8tHJX = parcelRequire("8tHJX");
    var $gZL7V = parcelRequire("gZL7V");
    const $75a5255a3d60692c$export$c24727297075ec6a = (0, $5uXOq.createContext)({
        registerField: function() {
            return ()=>{};
        },
        getCurrentValue: ()=>undefined,
        subscribe: function() {
            return ()=>{};
        }
    });
    const $75a5255a3d60692c$export$c17cf6b332a82dbc = (0, $5uXOq.createContext)(false);
    function $75a5255a3d60692c$export$2e2bcd8739ae039(props) {
        const formRef = (0, $5uXOq.useRef)(null);
        const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
        onSubmitRef.current = props.onSubmit;
        const [form] = (0, $5uXOq.useState)(()=>{
            const finalForm = (0, $lqWDn.createForm)({
                onSubmit: (...args)=>onSubmitRef.current(...args),
                destroyOnUnregister: true,
                initialValues: {},
                mutators: {
                    setDefaultValue: ([name, defaultValue], state)=>{
                        if (state.formState.initialValues) {
                            const initialValues = state.formState.initialValues;
                            const values = state.formState.values;
                            const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                            (0, ($parcel$interopDefault($gZL7V)))(initialValues, name, value);
                            (0, ($parcel$interopDefault($gZL7V)))(values, name, value);
                        }
                    }
                }
            });
            (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
            return finalForm;
        });
        const [state, setState] = (0, $5uXOq.useState)({
            dirty: false,
            submitting: false
        });
        (0, $5uXOq.useEffect)(()=>{
            const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
                setState({
                    dirty: dirty,
                    submitting: submitting
                });
            }, {
                dirty: true,
                submitting: true
            });
            return unsubscribe;
        }, [
            form
        ]);
        const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
            form.pauseValidation();
            const unsubscribe = form.registerField(name, subscriber, subscription, config);
            form.mutators.setDefaultValue(name, defaultValue);
            form.resumeValidation();
            return unsubscribe;
        }, [
            form
        ]);
        const handleSubmit = (e)=>{
            if (e) e.preventDefault();
            form.submit();
        };
        const handleReset = (initialValues)=>{
            form.reset(initialValues);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
                const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
                if (submitButton) submitButton.click();
                e.preventDefault();
            }
        };
        const { isDisabled: isDisabled = false, children: children } = props;
        const { dirty: dirty, submitting: submitting } = state;
        const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
            const formState = form.getState();
            return formState?.values[name] || undefined;
        }, [
            form
        ]);
        const FormContextValue = (0, $5uXOq.useMemo)(()=>{
            return {
                registerField: registerField,
                getCurrentValue: getCurrentValue,
                subscribe: form.subscribe
            };
        }, [
            registerField,
            getCurrentValue,
            form.subscribe
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($75a5255a3d60692c$export$c24727297075ec6a.Provider, {
            value: FormContextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($75a5255a3d60692c$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled
        }, children({
            formProps: {
                onSubmit: handleSubmit,
                ref: formRef,
                onKeyDown: handleKeyDown
            },
            dirty: dirty,
            reset: handleReset,
            submitting: submitting,
            disabled: isDisabled,
            getState: ()=>form.getState(),
            getValues: ()=>form.getState().values,
            setFieldValue: form.change
        })));
    }
});
parcelRegister("lqWDn", function(module, exports) {
    $parcel$export(module.exports, "getIn", ()=>$f9a9822f8af64e2a$export$c52e5867d5879e24);
    $parcel$export(module.exports, "FORM_ERROR", ()=>$f9a9822f8af64e2a$export$97cd7fc25dd32915);
    $parcel$export(module.exports, "fieldSubscriptionItems", ()=>$f9a9822f8af64e2a$export$41e855cb628c1b55);
    $parcel$export(module.exports, "formSubscriptionItems", ()=>$f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
    $parcel$export(module.exports, "version", ()=>$f9a9822f8af64e2a$export$83d89fbfd8236492);
    $parcel$export(module.exports, "createForm", ()=>$f9a9822f8af64e2a$export$f681a8129d2e9d28);
    var $bS32t = parcelRequire("bS32t");
    var $ddEsc = parcelRequire("ddEsc");
    var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
    var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
    var $f9a9822f8af64e2a$var$rePropName = RegExp("[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
    var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
        var result = [];
        if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
        string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
            var key = match;
            if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
            else if (expression) key = expression.trim();
            result.push(key);
        });
        return result;
    };
    var $f9a9822f8af64e2a$var$keysCache = {};
    var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
    var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
        if (key === null || key === undefined || !key.length) return [];
        if (typeof key !== "string") throw new Error("toPath() expects a string");
        if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
            if (key.endsWith("[]")) $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
            else $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
        }
        return $f9a9822f8af64e2a$var$keysCache[key];
    };
    var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
        var path = $f9a9822f8af64e2a$var$toPath(complexKey);
        var current = state;
        for(var i = 0; i < path.length; i++){
            var key = path[i];
            if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
            current = current[key];
        }
        return current;
    };
    function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
        var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
        return typeof key === "symbol" ? key : String(key);
    }
    function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
        if (typeof input !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if (typeof res !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
        if (index >= path.length) return value1;
        var key = path[index];
        if (isNaN(key)) {
            var _extends2;
            if (current === undefined || current === null) {
                var _ref;
                var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
                return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
            }
            if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
            var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
            if (_result2 === undefined) {
                var numKeys = Object.keys(current).length;
                if (current[key] === undefined && numKeys === 0) return undefined;
                if (current[key] !== undefined && numKeys <= 1) {
                    if (!isNaN(path[index - 1]) && !destroyArrays) return {};
                    else return undefined;
                }
                current[key];
                var _final = (0, $ddEsc.default)(current, [
                    key
                ].map($f9a9822f8af64e2a$var$_toPropertyKey));
                return _final;
            }
            return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
        }
        var numericKey = Number(key);
        if (current === undefined || current === null) {
            var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            if (_result3 === undefined) return undefined;
            var _array = [];
            _array[numericKey] = _result3;
            return _array;
        }
        if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
        var existingValue = current[numericKey];
        var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
        var array = [].concat(current);
        if (destroyArrays && result === undefined) {
            array.splice(numericKey, 1);
            if (array.length === 0) return undefined;
        } else array[numericKey] = result;
        return array;
    };
    var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
        if (destroyArrays === void 0) destroyArrays = false;
        if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
        if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
        return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
    };
    var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
    var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
    function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
        var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
        var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
        var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
        var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
        if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
        var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
        var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
        var pristine = field.isEqual(initial, value1);
        var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
        var valid = !error && !submitError;
        return {
            active: active,
            blur: blur,
            change: change,
            data: data,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            error: error,
            focus: focus,
            initial: initial,
            invalid: !valid,
            length: Array.isArray(value1) ? value1.length : undefined,
            modified: modified,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            name: name,
            pristine: pristine,
            submitError: submitError,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitting: submitting,
            touched: touched,
            valid: valid,
            value: value1,
            visited: visited,
            validating: validating
        };
    }
    var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
        "active",
        "data",
        "dirty",
        "dirtySinceLastSubmit",
        "error",
        "initial",
        "invalid",
        "length",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitError",
        "submitFailed",
        "submitSucceeded",
        "submitting",
        "touched",
        "valid",
        "value",
        "visited",
        "validating"
    ];
    var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
        if (a === b) return true;
        if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        if (keysA.length !== keysB.length) return false;
        var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
        for(var idx = 0; idx < keysA.length; idx++){
            var key = keysA[idx];
            if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
        }
        return true;
    };
    function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
        var different = false;
        keys.forEach(function(key) {
            if (subscription[key]) {
                dest[key] = src[key];
                if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
            }
        });
        return different;
    }
    var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
        "data"
    ];
    var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
        var result = {
            blur: state.blur,
            change: state.change,
            focus: state.focus,
            name: state.name
        };
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
        return different || force ? result : undefined;
    };
    var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
        "active",
        "dirty",
        "dirtyFields",
        "dirtyFieldsSinceLastSubmit",
        "dirtySinceLastSubmit",
        "error",
        "errors",
        "hasSubmitErrors",
        "hasValidationErrors",
        "initialValues",
        "invalid",
        "modified",
        "modifiedSinceLastSubmit",
        "pristine",
        "submitting",
        "submitError",
        "submitErrors",
        "submitFailed",
        "submitSucceeded",
        "touched",
        "valid",
        "validating",
        "values",
        "visited"
    ];
    var $f9a9822f8af64e2a$var$shallowEqualKeys = [
        "touched",
        "visited"
    ];
    function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
        var result = {};
        var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
        return different || force ? result : undefined;
    }
    var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
        var lastArgs;
        var lastResult;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
                return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
            })) {
                lastArgs = args;
                lastResult = fn.apply(void 0, args);
            }
            return lastResult;
        };
    };
    var $f9a9822f8af64e2a$var$isPromise = function(obj) {
        return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
    };
    var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
    var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
        "debug",
        "initialValues",
        "keepDirtyOnReinitialize",
        "mutators",
        "onSubmit",
        "validate",
        "validateOnBlur"
    ];
    var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
        return a === b;
    };
    var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
        return Object.keys(errors).some(function(key) {
            var value1 = errors[key];
            if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
            return typeof value1 !== "undefined";
        });
    };
    function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
        var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
        return {
            active: active,
            dirty: !pristine,
            dirtySinceLastSubmit: dirtySinceLastSubmit,
            modifiedSinceLastSubmit: modifiedSinceLastSubmit,
            error: error,
            errors: errors,
            hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
            hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
            invalid: !valid,
            initialValues: initialValues,
            pristine: pristine,
            submitting: submitting,
            submitFailed: submitFailed,
            submitSucceeded: submitSucceeded,
            submitError: submitError,
            submitErrors: submitErrors,
            valid: valid,
            validating: validating > 0,
            values: values
        };
    }
    function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
        var notification = filter(state, lastState, subscription, force);
        if (notification) {
            subscriber(notification);
            return true;
        }
        return false;
    }
    function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
        var entries = _ref2.entries;
        Object.keys(entries).forEach(function(key) {
            var entry = entries[Number(key)];
            if (entry) {
                var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
                if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
            }
        });
    }
    function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
        if (!config) throw new Error("No config specified");
        var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
        if (!onSubmit) throw new Error("No onSubmit function specified");
        var state = {
            subscribers: {
                index: 0,
                entries: {}
            },
            fieldSubscribers: {},
            fields: {},
            formState: {
                asyncErrors: {},
                dirtySinceLastSubmit: false,
                modifiedSinceLastSubmit: false,
                errors: {},
                initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
                invalid: false,
                pristine: true,
                submitting: false,
                submitFailed: false,
                submitSucceeded: false,
                resetWhileSubmitting: false,
                valid: true,
                validating: 0,
                values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
            },
            lastFormState: undefined
        };
        var inBatch = 0;
        var validationPaused = false;
        var validationBlocked = false;
        var preventNotificationWhileValidationPaused = false;
        var nextAsyncValidationKey = 0;
        var asyncValidationPromises = {};
        var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
            return function(result) {
                delete asyncValidationPromises[key];
                return result;
            };
        };
        var changeValue = function changeValue(state, name, mutate) {
            var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
            var after = mutate(before);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
        };
        var renameField = function renameField(state, from, to) {
            if (state.fields[from]) {
                var _extends2, _extends3;
                state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                    name: to,
                    blur: function blur() {
                        return api.blur(to);
                    },
                    change: function change(value1) {
                        return api.change(to, value1);
                    },
                    focus: function focus() {
                        return api.focus(to);
                    },
                    lastFieldState: undefined
                }), _extends2));
                delete state.fields[from];
                state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
                delete state.fieldSubscribers[from];
                var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
                state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
                delete state.lastFormState;
            }
        };
        var getMutatorApi = function getMutatorApi(key) {
            return function() {
                if (mutators) {
                    var mutatableState = {
                        formState: state.formState,
                        fields: state.fields,
                        fieldSubscribers: state.fieldSubscribers,
                        lastFormState: state.lastFormState
                    };
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var returnValue = mutators[key](args, mutatableState, {
                        changeValue: changeValue,
                        getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                        renameField: renameField,
                        resetFieldState: api.resetFieldState,
                        setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                        shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                    });
                    state.formState = mutatableState.formState;
                    state.fields = mutatableState.fields;
                    state.fieldSubscribers = mutatableState.fieldSubscribers;
                    state.lastFormState = mutatableState.lastFormState;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    return returnValue;
                }
            };
        };
        var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
            result[key] = getMutatorApi(key);
            return result;
        }, {}) : {};
        var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
            var promises = [];
            if (validate) {
                var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values));
                if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                    return setErrors(errors, true);
                }));
                else setErrors(errorsOrPromise, false);
            }
            return promises;
        };
        var getValidators = function getValidators(field) {
            return Object.keys(field.validators).reduce(function(result, index) {
                var validator = field.validators[Number(index)]();
                if (validator) result.push(validator);
                return result;
            }, []);
        };
        var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
            var promises = [];
            var validators = getValidators(field);
            if (validators.length) {
                var error;
                validators.forEach(function(validator) {
                    var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                    if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                        field.validating = true;
                        var promise = errorOrPromise.then(function(error) {
                            if (state.fields[field.name]) {
                                state.fields[field.name].validating = false;
                                setError(error);
                            }
                        });
                        promises.push(promise);
                    } else if (!error) error = errorOrPromise;
                });
                setError(error);
            }
            return promises;
        };
        var runValidation = function runValidation(fieldChanged, callback) {
            if (validationPaused) {
                validationBlocked = true;
                callback();
                return;
            }
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var fieldKeys = Object.keys(safeFields);
            if (!validate && !fieldKeys.some(function(key) {
                return getValidators(safeFields[key]).length;
            })) {
                callback();
                return;
            }
            var limitedFieldLevelValidation = false;
            if (fieldChanged) {
                var changedField = safeFields[fieldChanged];
                if (changedField) {
                    var validateFields = changedField.validateFields;
                    if (validateFields) {
                        limitedFieldLevelValidation = true;
                        fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                            fieldChanged
                        ];
                    }
                }
            }
            var recordLevelErrors = {};
            var asyncRecordLevelErrors = {};
            var fieldLevelErrors = {};
            var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
                if (wasAsync) asyncRecordLevelErrors = errors || {};
                else recordLevelErrors = errors || {};
            }), fieldKeys.reduce(function(result, name) {
                return result.concat(runFieldLevelValidation(fields[name], function(error) {
                    fieldLevelErrors[name] = error;
                }));
            }, []));
            var hasAsyncValidations = promises.length > 0;
            var asyncValidationPromiseKey = ++nextAsyncValidationKey;
            var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
            if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
            var processErrors = function processErrors(afterAsync) {
                var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors : formState.asyncErrors);
                var forEachError = function forEachError(fn) {
                    fieldKeys.forEach(function(name) {
                        if (fields[name]) {
                            var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                            var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                            var fieldLevelError = fieldLevelErrors[name];
                            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                        }
                    });
                };
                forEachError(function(name, error) {
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
                });
                forEachError(function(name, error) {
                    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                        var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var copy = [].concat(existing);
                        copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                        merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                    }
                });
                if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
                if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
                formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
            };
            if (hasAsyncValidations) {
                state.formState.validating++;
                callback();
            }
            processErrors(false);
            callback();
            if (hasAsyncValidations) {
                var afterPromise = function afterPromise() {
                    state.formState.validating--;
                    callback();
                    if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
                };
                promise.then(function() {
                    if (nextAsyncValidationKey > asyncValidationPromiseKey) return;
                    processErrors(true);
                }).then(afterPromise, afterPromise);
            }
        };
        var notifyFieldListeners = function notifyFieldListeners(name) {
            if (inBatch) return;
            var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var notifyField = function notifyField(name) {
                var field = safeFields[name];
                var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
                var lastFieldState = field.lastFieldState;
                field.lastFieldState = fieldState;
                var fieldSubscriber = fieldSubscribers[name];
                if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
            };
            if (name) notifyField(name);
            else Object.keys(safeFields).forEach(notifyField);
        };
        var markAllFieldsTouched = function markAllFieldsTouched() {
            Object.keys(state.fields).forEach(function(key) {
                state.fields[key].touched = true;
            });
        };
        var hasSyncErrors = function hasSyncErrors() {
            return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
        };
        var calculateNextFormState = function calculateNextFormState() {
            var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var safeFieldKeys = Object.keys(safeFields);
            var foundDirty = false;
            var dirtyFields = safeFieldKeys.reduce(function(result, key) {
                var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (dirty) {
                    foundDirty = true;
                    result[key] = true;
                }
                return result;
            }, {});
            var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
                var nonNullLastSubmittedValues = formState.lastSubmittedValues || {};
                if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
                return result;
            }, {});
            formState.pristine = !foundDirty;
            formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
                return value1;
            }));
            formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && Object.keys(safeFields).some(function(value1) {
                return safeFields[value1].modifiedSinceLastSubmit;
            }));
            formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
            var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
            var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
                result.modified[key] = safeFields[key].modified;
                result.touched[key] = safeFields[key].touched;
                result.visited[key] = safeFields[key].visited;
                return result;
            }, {
                modified: {},
                touched: {},
                visited: {}
            }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
            nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
            nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
            nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
            nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
            nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
            return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
        };
        var callDebug = function callDebug() {
            return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
                result[key] = state.fields[key];
                return result;
            }, {}));
        };
        var notifying = false;
        var scheduleNotification = false;
        var notifyFormListeners = function notifyFormListeners() {
            if (notifying) scheduleNotification = true;
            else {
                notifying = true;
                callDebug();
                if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                    var lastFormState = state.lastFormState;
                    var nextFormState = calculateNextFormState();
                    if (nextFormState !== lastFormState) {
                        state.lastFormState = nextFormState;
                        $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                    }
                }
                notifying = false;
                if (scheduleNotification) {
                    scheduleNotification = false;
                    notifyFormListeners();
                }
            }
        };
        var beforeSubmit = function beforeSubmit() {
            return Object.keys(state.fields).some(function(name) {
                return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
            });
        };
        var afterSubmit = function afterSubmit() {
            return Object.keys(state.fields).forEach(function(name) {
                return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
            });
        };
        var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
            return Object.keys(state.fields).forEach(function(key) {
                return state.fields[key].modifiedSinceLastSubmit = false;
            });
        };
        runValidation(undefined, function() {
            notifyFormListeners();
        });
        var api = {
            batch: function batch(fn) {
                inBatch++;
                fn();
                inBatch--;
                notifyFieldListeners();
                notifyFormListeners();
            },
            blur: function blur(name) {
                var fields = state.fields, formState = state.formState;
                var previous = fields[name];
                if (previous) {
                    delete formState.active;
                    fields[name] = (0, $bS32t.default)({}, previous, {
                        active: false,
                        touched: true
                    });
                    if (validateOnBlur) runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    else {
                        notifyFieldListeners();
                        notifyFormListeners();
                    }
                }
            },
            change: function change(name, value1) {
                var fields = state.fields, formState = state.formState;
                if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                    changeValue(state, name, function() {
                        return value1;
                    });
                    var previous = fields[name];
                    if (previous) fields[name] = (0, $bS32t.default)({}, previous, {
                        modified: true,
                        modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                    });
                    if (validateOnBlur) {
                        notifyFieldListeners();
                        notifyFormListeners();
                    } else runValidation(name, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                }
            },
            get destroyOnUnregister () {
                return !!destroyOnUnregister;
            },
            set destroyOnUnregister (value){
                destroyOnUnregister = value;
            },
            focus: function focus(name) {
                var field = state.fields[name];
                if (field && !field.active) {
                    state.formState.active = name;
                    field.active = true;
                    field.visited = true;
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            },
            mutators: mutatorsApi,
            getFieldState: function getFieldState(name) {
                var field = state.fields[name];
                return field && field.lastFieldState;
            },
            getRegisteredFields: function getRegisteredFields() {
                return Object.keys(state.fields);
            },
            getState: function getState() {
                return calculateNextFormState();
            },
            initialize: function initialize(data) {
                var fields = state.fields, formState = state.formState;
                var safeFields = (0, $bS32t.default)({}, fields);
                var values = typeof data === "function" ? data(formState.values) : data;
                if (!keepDirtyOnReinitialize) formState.values = values;
                var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                    var field = safeFields[key];
                    var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                    if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                    return result;
                }, {}) : {};
                formState.initialValues = values;
                formState.values = values;
                Object.keys(savedDirtyValues).forEach(function(key) {
                    formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            isValidationPaused: function isValidationPaused() {
                return validationPaused;
            },
            pauseValidation: function pauseValidation(preventNotification) {
                if (preventNotification === void 0) preventNotification = true;
                validationPaused = true;
                preventNotificationWhileValidationPaused = preventNotification;
            },
            registerField: function registerField(name, subscriber, subscription, fieldConfig) {
                if (subscription === void 0) subscription = {};
                if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                    index: 0,
                    entries: {}
                };
                var index = state.fieldSubscribers[name].index++;
                state.fieldSubscribers[name].entries[index] = {
                    subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                    subscription: subscription,
                    notified: false
                };
                var field = state.fields[name] || {
                    active: false,
                    afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                    beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                    data: fieldConfig && fieldConfig.data || {},
                    isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                    lastFieldState: undefined,
                    modified: false,
                    modifiedSinceLastSubmit: false,
                    name: name,
                    touched: false,
                    valid: true,
                    validateFields: fieldConfig && fieldConfig.validateFields,
                    validators: {},
                    validating: false,
                    visited: false
                };
                field.blur = field.blur || function() {
                    return api.blur(name);
                };
                field.change = field.change || function(value1) {
                    return api.change(name, value1);
                };
                field.focus = field.focus || function() {
                    return api.focus(name);
                };
                state.fields[name] = field;
                var haveValidator = false;
                var silent = fieldConfig && fieldConfig.silent;
                var notify = function notify() {
                    if (silent && state.fields[name]) notifyFieldListeners(name);
                    else {
                        notifyFormListeners();
                        notifyFieldListeners();
                    }
                };
                if (fieldConfig) {
                    haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                    if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                    var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                    if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                        state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                        runValidation(undefined, notify);
                    }
                    if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
                }
                if (haveValidator) runValidation(undefined, notify);
                else notify();
                return function() {
                    var validatorRemoved = false;
                    if (state.fields[name]) {
                        validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                        delete state.fields[name].validators[index];
                    }
                    var hasFieldSubscribers = !!state.fieldSubscribers[name];
                    if (hasFieldSubscribers) delete state.fieldSubscribers[name].entries[index];
                    var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                    if (lastOne) {
                        delete state.fieldSubscribers[name];
                        delete state.fields[name];
                        if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                        if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                    }
                    if (!silent) {
                        if (validatorRemoved) runValidation(undefined, function() {
                            notifyFormListeners();
                            notifyFieldListeners();
                        });
                        else if (lastOne) notifyFormListeners();
                    }
                };
            },
            reset: function reset(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
                state.formState.submitFailed = false;
                state.formState.submitSucceeded = false;
                delete state.formState.submitError;
                delete state.formState.submitErrors;
                delete state.formState.lastSubmittedValues;
                api.initialize(initialValues || {});
            },
            resetFieldState: function resetFieldState(name) {
                state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                    active: false,
                    lastFieldState: undefined,
                    modified: false,
                    touched: false,
                    valid: true,
                    validating: false,
                    visited: false
                });
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            },
            restart: function restart(initialValues) {
                if (initialValues === void 0) initialValues = state.formState.initialValues;
                api.batch(function() {
                    for(var name in state.fields){
                        api.resetFieldState(name);
                        state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                            active: false,
                            lastFieldState: undefined,
                            modified: false,
                            modifiedSinceLastSubmit: false,
                            touched: false,
                            valid: true,
                            validating: false,
                            visited: false
                        });
                    }
                    api.reset(initialValues);
                });
            },
            resumeValidation: function resumeValidation() {
                validationPaused = false;
                preventNotificationWhileValidationPaused = false;
                if (validationBlocked) runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                validationBlocked = false;
            },
            setConfig: function setConfig(name, value1) {
                switch(name){
                    case "debug":
                        debug = value1;
                        break;
                    case "destroyOnUnregister":
                        destroyOnUnregister = value1;
                        break;
                    case "initialValues":
                        api.initialize(value1);
                        break;
                    case "keepDirtyOnReinitialize":
                        keepDirtyOnReinitialize = value1;
                        break;
                    case "mutators":
                        mutators = value1;
                        if (value1) {
                            Object.keys(mutatorsApi).forEach(function(key) {
                                if (!(key in value1)) delete mutatorsApi[key];
                            });
                            Object.keys(value1).forEach(function(key) {
                                mutatorsApi[key] = getMutatorApi(key);
                            });
                        } else Object.keys(mutatorsApi).forEach(function(key) {
                            delete mutatorsApi[key];
                        });
                        break;
                    case "onSubmit":
                        onSubmit = value1;
                        break;
                    case "validate":
                        validate = value1;
                        runValidation(undefined, function() {
                            notifyFieldListeners();
                            notifyFormListeners();
                        });
                        break;
                    case "validateOnBlur":
                        validateOnBlur = value1;
                        break;
                    default:
                        throw new Error("Unrecognised option " + name);
                }
            },
            submit: function submit() {
                var formState = state.formState;
                if (formState.submitting) return;
                delete formState.submitErrors;
                delete formState.submitError;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                if (hasSyncErrors()) {
                    markAllFieldsTouched();
                    resetModifiedAfterSubmit();
                    state.formState.submitFailed = true;
                    notifyFormListeners();
                    notifyFieldListeners();
                    return;
                }
                var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
                if (asyncValidationPromisesKeys.length) {
                    Promise.all(asyncValidationPromisesKeys.map(function(key) {
                        return asyncValidationPromises[Number(key)];
                    })).then(api.submit, console.error);
                    return;
                }
                var submitIsBlocked = beforeSubmit();
                if (submitIsBlocked) return;
                var resolvePromise;
                var completeCalled = false;
                var complete = function complete(errors) {
                    formState.submitting = false;
                    var resetWhileSubmitting = formState.resetWhileSubmitting;
                    if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                    if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                        formState.submitFailed = true;
                        formState.submitSucceeded = false;
                        formState.submitErrors = errors;
                        formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                        markAllFieldsTouched();
                    } else {
                        if (!resetWhileSubmitting) {
                            formState.submitFailed = false;
                            formState.submitSucceeded = true;
                        }
                        afterSubmit();
                    }
                    notifyFormListeners();
                    notifyFieldListeners();
                    completeCalled = true;
                    if (resolvePromise) resolvePromise(errors);
                    return errors;
                };
                formState.submitting = true;
                formState.submitFailed = false;
                formState.submitSucceeded = false;
                formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
                resetModifiedAfterSubmit();
                var result = onSubmit(formState.values, api, complete);
                if (!completeCalled) {
                    if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return result.then(complete, function(error) {
                            complete();
                            throw error;
                        });
                    } else if (onSubmit.length >= 3) {
                        notifyFormListeners();
                        notifyFieldListeners();
                        return new Promise(function(resolve) {
                            resolvePromise = resolve;
                        });
                    } else complete(result);
                }
            },
            subscribe: function subscribe(subscriber, subscription) {
                if (!subscriber) throw new Error("No callback given.");
                if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
                var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
                var subscribers = state.subscribers;
                var index = subscribers.index++;
                subscribers.entries[index] = {
                    subscriber: memoized,
                    subscription: subscription,
                    notified: false
                };
                var nextFormState = calculateNextFormState();
                $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
                return function() {
                    delete subscribers.entries[index];
                };
            }
        };
        return api;
    }
});
parcelRegister("8tHJX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62c2f612c5adb35a$export$2e2bcd8739ae039);
    var $lqWDn = parcelRequire("lqWDn");
    var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
        return !!(wtf && typeof wtf.focus === 'function');
    };
    var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
        if (typeof document === 'undefined') return [];
        return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
            return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
        }, []);
    };
    var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
        return inputs.find(function(input) {
            return input.name && (0, $lqWDn.getIn)(errors, input.name);
        });
    };
    var $62c2f612c5adb35a$var$noop = function noop() {};
    var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
        return function(form) {
            var focusOnFirstError = function focusOnFirstError(errors) {
                if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
                if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
                var firstInput = findInput$$1(getInputs(), errors);
                if (firstInput) firstInput.focus();
            };
            var originalSubmit = form.submit;
            var state = {};
            var unsubscribe = form.subscribe(function(nextState) {
                state = nextState;
            }, {
                errors: true,
                submitErrors: true
            });
            var afterSubmit = function afterSubmit() {
                var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
                if (errors && Object.keys(errors).length) focusOnFirstError(errors);
                else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
            };
            form.submit = function() {
                var result = originalSubmit.call(form);
                if (result && typeof result.then === 'function') result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
                else afterSubmit();
                return result;
            };
            return function() {
                unsubscribe();
                form.submit = originalSubmit;
            };
        };
    };
    var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
        return function() {
            if (typeof document === 'undefined') return [];
            var form = document.forms[name];
            return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : [];
        };
    };
    var $62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;
});
parcelRegister("gZL7V", function(module, exports) {
    var $ajB7H = parcelRequire("ajB7H");
    function $c5f6e64373be0bfc$var$set(object, path, value) {
        return object == null ? object : $ajB7H(object, path, value);
    }
    module.exports = $c5f6e64373be0bfc$var$set;
});
parcelRegister("7VnW8", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$bc5fcc4d894aeca1$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$bc5fcc4d894aeca1$export$ed247974535929c7);
    var $f8Sb3;
    function $bc5fcc4d894aeca1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bc5fcc4d894aeca1$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $bc5fcc4d894aeca1$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $bc5fcc4d894aeca1$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles
        }, children);
    };
    var $bc5fcc4d894aeca1$export$2e2bcd8739ae039 = $bc5fcc4d894aeca1$export$b04be29aa201d4f5;
});
parcelRegister("8knNZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d3fe143ced70112a$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $d3fe143ced70112a$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $72ba03e317f3d228$export$2010d0fb4295b346)})`,
        fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $d3fe143ced70112a$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $d3fe143ced70112a$var$requiredIndicatorStyles,
            "aria-hidden": "true",
            title: "required"
        }, "*");
    }
});
var $72ba03e317f3d228$exports = {};
$parcel$export($72ba03e317f3d228$exports, "R50", ()=>$72ba03e317f3d228$export$4b84fd0e2c617bd);
$parcel$export($72ba03e317f3d228$exports, "R75", ()=>$72ba03e317f3d228$export$b34b069eff244586);
$parcel$export($72ba03e317f3d228$exports, "R100", ()=>$72ba03e317f3d228$export$be802dd0d8b57f35);
$parcel$export($72ba03e317f3d228$exports, "R200", ()=>$72ba03e317f3d228$export$60847d42f9da92a6);
$parcel$export($72ba03e317f3d228$exports, "R300", ()=>$72ba03e317f3d228$export$4a7404f376229999);
$parcel$export($72ba03e317f3d228$exports, "R400", ()=>$72ba03e317f3d228$export$2010d0fb4295b346);
$parcel$export($72ba03e317f3d228$exports, "R500", ()=>$72ba03e317f3d228$export$2837b5a1a71d5c02);
$parcel$export($72ba03e317f3d228$exports, "Y50", ()=>$72ba03e317f3d228$export$8d9596b529bbb9cf);
$parcel$export($72ba03e317f3d228$exports, "Y75", ()=>$72ba03e317f3d228$export$41060a744ab0b7ae);
$parcel$export($72ba03e317f3d228$exports, "Y100", ()=>$72ba03e317f3d228$export$1cc05bbbf340e559);
$parcel$export($72ba03e317f3d228$exports, "Y200", ()=>$72ba03e317f3d228$export$5aae31392d72caaa);
$parcel$export($72ba03e317f3d228$exports, "Y300", ()=>$72ba03e317f3d228$export$c6930421db9fa514);
$parcel$export($72ba03e317f3d228$exports, "Y400", ()=>$72ba03e317f3d228$export$59619663aa6500fb);
$parcel$export($72ba03e317f3d228$exports, "Y500", ()=>$72ba03e317f3d228$export$874739ea9e379ab6);
$parcel$export($72ba03e317f3d228$exports, "G50", ()=>$72ba03e317f3d228$export$8a6341c32b6a3ee6);
$parcel$export($72ba03e317f3d228$exports, "G75", ()=>$72ba03e317f3d228$export$69a3bf21b9686c2b);
$parcel$export($72ba03e317f3d228$exports, "G100", ()=>$72ba03e317f3d228$export$afbce1382ec95f73);
$parcel$export($72ba03e317f3d228$exports, "G200", ()=>$72ba03e317f3d228$export$747d86715d4175de);
$parcel$export($72ba03e317f3d228$exports, "G300", ()=>$72ba03e317f3d228$export$940e1f69e873f202);
$parcel$export($72ba03e317f3d228$exports, "G400", ()=>$72ba03e317f3d228$export$a49394138f7b8e85);
$parcel$export($72ba03e317f3d228$exports, "G500", ()=>$72ba03e317f3d228$export$6fa04827ac68a4fb);
$parcel$export($72ba03e317f3d228$exports, "B50", ()=>$72ba03e317f3d228$export$226de0355ed012f8);
$parcel$export($72ba03e317f3d228$exports, "B75", ()=>$72ba03e317f3d228$export$8c13c2ee36917869);
$parcel$export($72ba03e317f3d228$exports, "B100", ()=>$72ba03e317f3d228$export$ecfc1dff386a3e7a);
$parcel$export($72ba03e317f3d228$exports, "B200", ()=>$72ba03e317f3d228$export$215b7063051591f1);
$parcel$export($72ba03e317f3d228$exports, "B300", ()=>$72ba03e317f3d228$export$e62e8919cca44969);
$parcel$export($72ba03e317f3d228$exports, "B400", ()=>$72ba03e317f3d228$export$b3de0ae08da2ce64);
$parcel$export($72ba03e317f3d228$exports, "B500", ()=>$72ba03e317f3d228$export$a6ee3d71bc067634);
$parcel$export($72ba03e317f3d228$exports, "B600", ()=>$72ba03e317f3d228$export$67f15409e87642a1);
$parcel$export($72ba03e317f3d228$exports, "B700", ()=>$72ba03e317f3d228$export$f0539dbc42dbb067);
$parcel$export($72ba03e317f3d228$exports, "P50", ()=>$72ba03e317f3d228$export$363e4475840015bb);
$parcel$export($72ba03e317f3d228$exports, "P75", ()=>$72ba03e317f3d228$export$4b0a4417ed59760f);
$parcel$export($72ba03e317f3d228$exports, "P100", ()=>$72ba03e317f3d228$export$6011520a64d9a187);
$parcel$export($72ba03e317f3d228$exports, "P200", ()=>$72ba03e317f3d228$export$a7175d4e9206bc80);
$parcel$export($72ba03e317f3d228$exports, "P300", ()=>$72ba03e317f3d228$export$b48405b95304b5a1);
$parcel$export($72ba03e317f3d228$exports, "P400", ()=>$72ba03e317f3d228$export$c71e4279dd54a18d);
$parcel$export($72ba03e317f3d228$exports, "P500", ()=>$72ba03e317f3d228$export$147899de772240ec);
$parcel$export($72ba03e317f3d228$exports, "T50", ()=>$72ba03e317f3d228$export$2cf711fe14c66f06);
$parcel$export($72ba03e317f3d228$exports, "T75", ()=>$72ba03e317f3d228$export$7a8f4d33f6f9772c);
$parcel$export($72ba03e317f3d228$exports, "T100", ()=>$72ba03e317f3d228$export$776c9c497ef08533);
$parcel$export($72ba03e317f3d228$exports, "T200", ()=>$72ba03e317f3d228$export$69cb3ca10c1e330e);
$parcel$export($72ba03e317f3d228$exports, "T300", ()=>$72ba03e317f3d228$export$9dc1ef0f3f48059b);
$parcel$export($72ba03e317f3d228$exports, "T400", ()=>$72ba03e317f3d228$export$7c835c78b6fcdef8);
$parcel$export($72ba03e317f3d228$exports, "T500", ()=>$72ba03e317f3d228$export$6036577f95c3877e);
$parcel$export($72ba03e317f3d228$exports, "N0", ()=>$72ba03e317f3d228$export$29a4f05edc054374);
$parcel$export($72ba03e317f3d228$exports, "N10", ()=>$72ba03e317f3d228$export$e655ef011c4aa1a2);
$parcel$export($72ba03e317f3d228$exports, "N20", ()=>$72ba03e317f3d228$export$9fdfb749e33cdf97);
$parcel$export($72ba03e317f3d228$exports, "N30", ()=>$72ba03e317f3d228$export$3e51e8f1440314ba);
$parcel$export($72ba03e317f3d228$exports, "N40", ()=>$72ba03e317f3d228$export$1ce2d1575d444ceb);
$parcel$export($72ba03e317f3d228$exports, "N50", ()=>$72ba03e317f3d228$export$8754fc7e6d8b3000);
$parcel$export($72ba03e317f3d228$exports, "N60", ()=>$72ba03e317f3d228$export$c2e91cbeada39b8b);
$parcel$export($72ba03e317f3d228$exports, "N70", ()=>$72ba03e317f3d228$export$5f71e19f3a7ad9de);
$parcel$export($72ba03e317f3d228$exports, "N80", ()=>$72ba03e317f3d228$export$eaa8c8a70ac22806);
$parcel$export($72ba03e317f3d228$exports, "N90", ()=>$72ba03e317f3d228$export$7c87d337fb91a97d);
$parcel$export($72ba03e317f3d228$exports, "N100", ()=>$72ba03e317f3d228$export$d6447c357493214f);
$parcel$export($72ba03e317f3d228$exports, "N200", ()=>$72ba03e317f3d228$export$f563ee71e9ee74cd);
$parcel$export($72ba03e317f3d228$exports, "N300", ()=>$72ba03e317f3d228$export$e2ef2124cf4024b1);
$parcel$export($72ba03e317f3d228$exports, "N400", ()=>$72ba03e317f3d228$export$eece5f492e429f08);
$parcel$export($72ba03e317f3d228$exports, "N500", ()=>$72ba03e317f3d228$export$c39c0fe0f26207ae);
$parcel$export($72ba03e317f3d228$exports, "N600", ()=>$72ba03e317f3d228$export$7090862dc3038a9f);
$parcel$export($72ba03e317f3d228$exports, "N700", ()=>$72ba03e317f3d228$export$ad0bacf983b7ddaa);
$parcel$export($72ba03e317f3d228$exports, "N800", ()=>$72ba03e317f3d228$export$7d61b15e0da132af);
$parcel$export($72ba03e317f3d228$exports, "N900", ()=>$72ba03e317f3d228$export$fbda843f0a27fe96);
$parcel$export($72ba03e317f3d228$exports, "N10A", ()=>$72ba03e317f3d228$export$791e57b27ca738ef);
$parcel$export($72ba03e317f3d228$exports, "N20A", ()=>$72ba03e317f3d228$export$8d43898f60b96a82);
$parcel$export($72ba03e317f3d228$exports, "N30A", ()=>$72ba03e317f3d228$export$920c0d5c49070351);
$parcel$export($72ba03e317f3d228$exports, "N40A", ()=>$72ba03e317f3d228$export$46987b49aab6d1a8);
$parcel$export($72ba03e317f3d228$exports, "N50A", ()=>$72ba03e317f3d228$export$7d3359664e8bb0e5);
$parcel$export($72ba03e317f3d228$exports, "N60A", ()=>$72ba03e317f3d228$export$d2d3bedfb276cac0);
$parcel$export($72ba03e317f3d228$exports, "N70A", ()=>$72ba03e317f3d228$export$6e5e7499ff054f6d);
$parcel$export($72ba03e317f3d228$exports, "N80A", ()=>$72ba03e317f3d228$export$59264b346c877fa7);
$parcel$export($72ba03e317f3d228$exports, "N90A", ()=>$72ba03e317f3d228$export$d092757d7c64925c);
$parcel$export($72ba03e317f3d228$exports, "N100A", ()=>$72ba03e317f3d228$export$486ab785e4bac3c6);
$parcel$export($72ba03e317f3d228$exports, "N200A", ()=>$72ba03e317f3d228$export$fba592bbc6419fea);
$parcel$export($72ba03e317f3d228$exports, "N300A", ()=>$72ba03e317f3d228$export$13609db0e6812ab8);
$parcel$export($72ba03e317f3d228$exports, "N400A", ()=>$72ba03e317f3d228$export$fbae4efaa892d883);
$parcel$export($72ba03e317f3d228$exports, "N500A", ()=>$72ba03e317f3d228$export$f13946d26f440ce6);
$parcel$export($72ba03e317f3d228$exports, "N600A", ()=>$72ba03e317f3d228$export$19f58225ac52a306);
$parcel$export($72ba03e317f3d228$exports, "N700A", ()=>$72ba03e317f3d228$export$6384f09da70e7b62);
$parcel$export($72ba03e317f3d228$exports, "N800A", ()=>$72ba03e317f3d228$export$d0dccc730683edc2);
$parcel$export($72ba03e317f3d228$exports, "DN900", ()=>$72ba03e317f3d228$export$2f6319cf7d736c2a);
$parcel$export($72ba03e317f3d228$exports, "DN800", ()=>$72ba03e317f3d228$export$95126bc8884d6634);
$parcel$export($72ba03e317f3d228$exports, "DN700", ()=>$72ba03e317f3d228$export$8338d8c35d44ff1);
$parcel$export($72ba03e317f3d228$exports, "DN600", ()=>$72ba03e317f3d228$export$5368d76ae4fbbda7);
$parcel$export($72ba03e317f3d228$exports, "DN500", ()=>$72ba03e317f3d228$export$9f0a771d16ec8d36);
$parcel$export($72ba03e317f3d228$exports, "DN400", ()=>$72ba03e317f3d228$export$abcf8c38338b4aa5);
$parcel$export($72ba03e317f3d228$exports, "DN300", ()=>$72ba03e317f3d228$export$97e81faa16a182c7);
$parcel$export($72ba03e317f3d228$exports, "DN200", ()=>$72ba03e317f3d228$export$bfe21c59123ecf33);
$parcel$export($72ba03e317f3d228$exports, "DN100", ()=>$72ba03e317f3d228$export$ee82aa2ea6a1558);
$parcel$export($72ba03e317f3d228$exports, "DN90", ()=>$72ba03e317f3d228$export$682927c6ed76be02);
$parcel$export($72ba03e317f3d228$exports, "DN80", ()=>$72ba03e317f3d228$export$91fd9994c5be9757);
$parcel$export($72ba03e317f3d228$exports, "DN70", ()=>$72ba03e317f3d228$export$d281fbfe3cff2df6);
$parcel$export($72ba03e317f3d228$exports, "DN60", ()=>$72ba03e317f3d228$export$3902c91d8b98a753);
$parcel$export($72ba03e317f3d228$exports, "DN50", ()=>$72ba03e317f3d228$export$8e8133c1ba5845b5);
$parcel$export($72ba03e317f3d228$exports, "DN40", ()=>$72ba03e317f3d228$export$33ff357f6620b39);
$parcel$export($72ba03e317f3d228$exports, "DN30", ()=>$72ba03e317f3d228$export$633847cf062b69e0);
$parcel$export($72ba03e317f3d228$exports, "DN20", ()=>$72ba03e317f3d228$export$9776a6e503bdbf76);
$parcel$export($72ba03e317f3d228$exports, "DN10", ()=>$72ba03e317f3d228$export$6c813d5160dff5db);
$parcel$export($72ba03e317f3d228$exports, "DN0", ()=>$72ba03e317f3d228$export$3d4f271a500072a);
$parcel$export($72ba03e317f3d228$exports, "DN800A", ()=>$72ba03e317f3d228$export$fe151285c22759ec);
$parcel$export($72ba03e317f3d228$exports, "DN700A", ()=>$72ba03e317f3d228$export$a101c6190d0da34);
$parcel$export($72ba03e317f3d228$exports, "DN600A", ()=>$72ba03e317f3d228$export$4b16f52932fda51);
$parcel$export($72ba03e317f3d228$exports, "DN500A", ()=>$72ba03e317f3d228$export$a74bcd7b9845b0d8);
$parcel$export($72ba03e317f3d228$exports, "DN400A", ()=>$72ba03e317f3d228$export$9209c179316d1751);
$parcel$export($72ba03e317f3d228$exports, "DN300A", ()=>$72ba03e317f3d228$export$88f55133f636c8dd);
$parcel$export($72ba03e317f3d228$exports, "DN200A", ()=>$72ba03e317f3d228$export$51126f85d1009512);
$parcel$export($72ba03e317f3d228$exports, "DN100A", ()=>$72ba03e317f3d228$export$a069b547bd23af78);
$parcel$export($72ba03e317f3d228$exports, "DN90A", ()=>$72ba03e317f3d228$export$40cce05af3b2600a);
$parcel$export($72ba03e317f3d228$exports, "DN80A", ()=>$72ba03e317f3d228$export$b78942185925a0d);
$parcel$export($72ba03e317f3d228$exports, "DN70A", ()=>$72ba03e317f3d228$export$e058fb44b8eaafca);
$parcel$export($72ba03e317f3d228$exports, "DN60A", ()=>$72ba03e317f3d228$export$92b0b8de26920c18);
$parcel$export($72ba03e317f3d228$exports, "DN50A", ()=>$72ba03e317f3d228$export$67564f7459d3fc9e);
$parcel$export($72ba03e317f3d228$exports, "DN40A", ()=>$72ba03e317f3d228$export$77868e1ca884ffa3);
$parcel$export($72ba03e317f3d228$exports, "DN30A", ()=>$72ba03e317f3d228$export$2afd71d7d3ea2cd5);
$parcel$export($72ba03e317f3d228$exports, "DN20A", ()=>$72ba03e317f3d228$export$f2a0acaab9972c70);
$parcel$export($72ba03e317f3d228$exports, "DN10A", ()=>$72ba03e317f3d228$export$9ab70e67d6475361);
$parcel$export($72ba03e317f3d228$exports, "T30", ()=>$72ba03e317f3d228$export$d2adc5dedf09fced);
$parcel$export($72ba03e317f3d228$exports, "L50", ()=>$72ba03e317f3d228$export$f51762073d2bb381);
$parcel$export($72ba03e317f3d228$exports, "L75", ()=>$72ba03e317f3d228$export$95e26d54def96891);
const $72ba03e317f3d228$export$4b84fd0e2c617bd = '#FFEBE6';
const $72ba03e317f3d228$export$b34b069eff244586 = '#FFBDAD';
const $72ba03e317f3d228$export$be802dd0d8b57f35 = '#FF8F73';
const $72ba03e317f3d228$export$60847d42f9da92a6 = '#FF7452';
const $72ba03e317f3d228$export$4a7404f376229999 = '#FF5630';
const $72ba03e317f3d228$export$2010d0fb4295b346 = '#DE350B';
const $72ba03e317f3d228$export$2837b5a1a71d5c02 = '#BF2600';
const $72ba03e317f3d228$export$8d9596b529bbb9cf = '#FFFAE6';
const $72ba03e317f3d228$export$41060a744ab0b7ae = '#FFF0B3';
const $72ba03e317f3d228$export$1cc05bbbf340e559 = '#FFE380';
const $72ba03e317f3d228$export$5aae31392d72caaa = '#FFC400';
const $72ba03e317f3d228$export$c6930421db9fa514 = '#FFAB00';
const $72ba03e317f3d228$export$59619663aa6500fb = '#FF991F';
const $72ba03e317f3d228$export$874739ea9e379ab6 = '#FF8B00';
const $72ba03e317f3d228$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $72ba03e317f3d228$export$69a3bf21b9686c2b = '#ABF5D1';
const $72ba03e317f3d228$export$afbce1382ec95f73 = '#79F2C0';
const $72ba03e317f3d228$export$747d86715d4175de = '#57D9A3';
const $72ba03e317f3d228$export$940e1f69e873f202 = '#36B37E';
const $72ba03e317f3d228$export$a49394138f7b8e85 = '#00875A';
const $72ba03e317f3d228$export$6fa04827ac68a4fb = '#006644';
const $72ba03e317f3d228$export$226de0355ed012f8 = '#DEEBFF';
const $72ba03e317f3d228$export$8c13c2ee36917869 = '#B3D4FF';
const $72ba03e317f3d228$export$ecfc1dff386a3e7a = '#4C9AFF';
const $72ba03e317f3d228$export$215b7063051591f1 = '#2684FF';
const $72ba03e317f3d228$export$e62e8919cca44969 = '#0065FF';
const $72ba03e317f3d228$export$b3de0ae08da2ce64 = '#0052CC';
const $72ba03e317f3d228$export$a6ee3d71bc067634 = '#0747A6';
const $72ba03e317f3d228$export$67f15409e87642a1 = '#669DF1';
const $72ba03e317f3d228$export$f0539dbc42dbb067 = '#8FB8F6';
const $72ba03e317f3d228$export$363e4475840015bb = '#EAE6FF';
const $72ba03e317f3d228$export$4b0a4417ed59760f = '#C0B6F2';
const $72ba03e317f3d228$export$6011520a64d9a187 = '#998DD9';
const $72ba03e317f3d228$export$a7175d4e9206bc80 = '#8777D9';
const $72ba03e317f3d228$export$b48405b95304b5a1 = '#6554C0';
const $72ba03e317f3d228$export$c71e4279dd54a18d = '#5243AA';
const $72ba03e317f3d228$export$147899de772240ec = '#403294';
const $72ba03e317f3d228$export$2cf711fe14c66f06 = '#E6FCFF';
const $72ba03e317f3d228$export$7a8f4d33f6f9772c = '#B3F5FF';
const $72ba03e317f3d228$export$776c9c497ef08533 = '#79E2F2';
const $72ba03e317f3d228$export$69cb3ca10c1e330e = '#00C7E6';
const $72ba03e317f3d228$export$9dc1ef0f3f48059b = '#00B8D9';
const $72ba03e317f3d228$export$7c835c78b6fcdef8 = '#00A3BF';
const $72ba03e317f3d228$export$6036577f95c3877e = '#008DA6';
const $72ba03e317f3d228$export$29a4f05edc054374 = '#FFFFFF';
const $72ba03e317f3d228$export$e655ef011c4aa1a2 = '#FAFBFC';
const $72ba03e317f3d228$export$9fdfb749e33cdf97 = '#F4F5F7';
const $72ba03e317f3d228$export$3e51e8f1440314ba = '#EBECF0';
const $72ba03e317f3d228$export$1ce2d1575d444ceb = '#DFE1E6';
const $72ba03e317f3d228$export$8754fc7e6d8b3000 = '#C1C7D0';
const $72ba03e317f3d228$export$c2e91cbeada39b8b = '#B3BAC5';
const $72ba03e317f3d228$export$5f71e19f3a7ad9de = '#A5ADBA';
const $72ba03e317f3d228$export$eaa8c8a70ac22806 = '#97A0AF';
const $72ba03e317f3d228$export$7c87d337fb91a97d = '#8993A4';
const $72ba03e317f3d228$export$d6447c357493214f = '#7A869A';
const $72ba03e317f3d228$export$f563ee71e9ee74cd = '#6B778C';
const $72ba03e317f3d228$export$e2ef2124cf4024b1 = '#5E6C84';
const $72ba03e317f3d228$export$eece5f492e429f08 = '#505F79';
const $72ba03e317f3d228$export$c39c0fe0f26207ae = '#42526E';
const $72ba03e317f3d228$export$7090862dc3038a9f = '#344563';
const $72ba03e317f3d228$export$ad0bacf983b7ddaa = '#253858';
const $72ba03e317f3d228$export$7d61b15e0da132af = '#172B4D';
const $72ba03e317f3d228$export$fbda843f0a27fe96 = '#091E42';
const $72ba03e317f3d228$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $72ba03e317f3d228$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $72ba03e317f3d228$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $72ba03e317f3d228$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $72ba03e317f3d228$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $72ba03e317f3d228$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $72ba03e317f3d228$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $72ba03e317f3d228$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $72ba03e317f3d228$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $72ba03e317f3d228$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $72ba03e317f3d228$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $72ba03e317f3d228$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $72ba03e317f3d228$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $72ba03e317f3d228$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $72ba03e317f3d228$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $72ba03e317f3d228$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $72ba03e317f3d228$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $72ba03e317f3d228$export$2f6319cf7d736c2a = '#E6EDFA';
const $72ba03e317f3d228$export$95126bc8884d6634 = '#DCE5F5';
const $72ba03e317f3d228$export$8338d8c35d44ff1 = '#CED9EB';
const $72ba03e317f3d228$export$5368d76ae4fbbda7 = '#B8C7E0';
const $72ba03e317f3d228$export$9f0a771d16ec8d36 = '#ABBBD6';
const $72ba03e317f3d228$export$abcf8c38338b4aa5 = '#9FB0CC';
const $72ba03e317f3d228$export$97e81faa16a182c7 = '#8C9CB8';
const $72ba03e317f3d228$export$bfe21c59123ecf33 = '#7988A3';
const $72ba03e317f3d228$export$ee82aa2ea6a1558 = '#67758F';
const $72ba03e317f3d228$export$682927c6ed76be02 = '#56637A';
const $72ba03e317f3d228$export$91fd9994c5be9757 = '#455166';
const $72ba03e317f3d228$export$d281fbfe3cff2df6 = '#3B475C';
const $72ba03e317f3d228$export$3902c91d8b98a753 = '#313D52';
const $72ba03e317f3d228$export$8e8133c1ba5845b5 = '#283447';
const $72ba03e317f3d228$export$33ff357f6620b39 = '#202B3D';
const $72ba03e317f3d228$export$633847cf062b69e0 = '#1B2638';
const $72ba03e317f3d228$export$9776a6e503bdbf76 = '#121A29';
const $72ba03e317f3d228$export$6c813d5160dff5db = '#0E1624';
const $72ba03e317f3d228$export$3d4f271a500072a = '#0D1424';
const $72ba03e317f3d228$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $72ba03e317f3d228$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $72ba03e317f3d228$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $72ba03e317f3d228$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $72ba03e317f3d228$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $72ba03e317f3d228$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $72ba03e317f3d228$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $72ba03e317f3d228$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $72ba03e317f3d228$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $72ba03e317f3d228$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $72ba03e317f3d228$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $72ba03e317f3d228$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $72ba03e317f3d228$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $72ba03e317f3d228$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $72ba03e317f3d228$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $72ba03e317f3d228$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $72ba03e317f3d228$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $72ba03e317f3d228$export$d2adc5dedf09fced = '#292A2E';
const $72ba03e317f3d228$export$f51762073d2bb381 = '#94C748';
const $72ba03e317f3d228$export$95e26d54def96891 = '#B3DF72';
parcelRegister("6HBFQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e06e4347ef638a2c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $7zSSp;
    const $e06e4347ef638a2c$var$packageName = "platform-pkg";
    const $e06e4347ef638a2c$var$packageVersion = "0.0.0-use.local";
    const $e06e4347ef638a2c$var$analyticsParams = {
        componentName: 'textArea',
        packageName: $e06e4347ef638a2c$var$packageName,
        packageVersion: $e06e4347ef638a2c$var$packageVersion
    };
    const $e06e4347ef638a2c$var$setSmartHeight = (el)=>{
        el.style.height = 'auto';
        const borderHeight = (0, (0, parcelRequire("7zSSp")).borderWidth);
        const paddingBoxHeight = el.scrollHeight;
        const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
        el.style.height = `${borderBoxHeight}px`;
    };
    const $e06e4347ef638a2c$var$InnerTextArea = (0, $5uXOq.forwardRef)((props, ref)=>{
        const ourRef = (0, $5uXOq.useRef)(null);
        const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
        (0, $5uXOq.useEffect)(()=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $e06e4347ef638a2c$var$setSmartHeight(el);
        }, [
            resize,
            value
        ]);
        const onBlurWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$e06e4347ef638a2c$var$analyticsParams
        });
        const onFocusWithAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$e06e4347ef638a2c$var$analyticsParams
        });
        const getTextAreaRef = (elementRef)=>{
            ourRef.current = elementRef;
            if (ref && typeof ref === 'object') ref.current = elementRef;
            if (ref && typeof ref === 'function') ref(elementRef);
        };
        const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
            const el = ourRef.current;
            if (resize === 'smart' && el) $e06e4347ef638a2c$var$setSmartHeight(el);
            onChange && onChange(e);
        }, [
            onChange,
            resize
        ]);
        const controlProps = {
            'data-invalid': isInvalid ? isInvalid : undefined,
            'data-compact': isCompact ? isCompact : undefined,
            'data-testid': testId ? testId : undefined
        };
        const baseStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7zSSp")).getBaseStyles)({
                minimumRows: minimumRows,
                resize: resize,
                appearance: appearance,
                isMonospaced: isMonospaced,
                maxHeight: maxHeight
            }), [
            minimumRows,
            resize,
            appearance,
            isMonospaced,
            maxHeight
        ]);
        const textAreaStyles = (0, (0, parcelRequire("f8Sb3")).css)([
            baseStyles,
            (0, (0, parcelRequire("7zSSp")).dynamicStyles)(appearance)
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("textarea", {
            ...controlProps,
            value: value,
            disabled: isDisabled,
            readOnly: isReadOnly,
            required: isRequired,
            ref: getTextAreaRef,
            onChange: handleOnChange,
            onBlur: onBlurWithAnalytics,
            onFocus: onFocusWithAnalytics,
            rows: minimumRows,
            css: textAreaStyles,
            ...rest
        });
    });
    const $e06e4347ef638a2c$var$TextArea = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function TextArea(props, ref) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)($e06e4347ef638a2c$var$InnerTextArea, {
            ref: ref,
            ...props
        });
    }));
    $e06e4347ef638a2c$var$TextArea.displayName = 'TextArea';
    var $e06e4347ef638a2c$export$2e2bcd8739ae039 = $e06e4347ef638a2c$var$TextArea;
});
parcelRegister("7zSSp", function(module, exports) {
    $parcel$export(module.exports, "borderWidth", ()=>$349f5d21489b2f74$export$12879c7697ed953d);
    $parcel$export(module.exports, "getBaseStyles", ()=>$349f5d21489b2f74$export$bff8031d86bb089);
    $parcel$export(module.exports, "dynamicStyles", ()=>$349f5d21489b2f74$export$98856a888ef36079);
    var $f8Sb3;
    var $1xPSU;
    function $349f5d21489b2f74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $349f5d21489b2f74$var$disabledRules = {
        backgroundColor: (0, parcelRequire("1xPSU")).disabledBackground,
        backgroundColorFocus: (0, parcelRequire("1xPSU")).disabledBackground,
        backgroundColorHover: (0, parcelRequire("1xPSU")).disabledBackground,
        borderColor: (0, parcelRequire("1xPSU")).disabledBorder,
        borderColorFocus: (0, parcelRequire("1xPSU")).defaultBorderColorFocus,
        textColor: (0, parcelRequire("1xPSU")).disabledTextColor
    };
    const $349f5d21489b2f74$var$invalidRules = {
        borderColor: (0, parcelRequire("1xPSU")).invalidBorderColor,
        borderColorFocus: (0, parcelRequire("1xPSU")).defaultBorderColorFocus,
        backgroundColor: (0, parcelRequire("1xPSU")).defaultBackgroundColor,
        backgroundColorFocus: (0, parcelRequire("1xPSU")).defaultBackgroundColorFocus,
        backgroundColorHover: (0, parcelRequire("1xPSU")).defaultBackgroundColorHover
    };
    const $349f5d21489b2f74$var$backgroundColor = {
        standard: (0, parcelRequire("1xPSU")).defaultBackgroundColor,
        subtle: (0, parcelRequire("1xPSU")).transparent,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$backgroundColorFocus = {
        standard: (0, parcelRequire("1xPSU")).defaultBackgroundColorFocus,
        subtle: (0, parcelRequire("1xPSU")).defaultBackgroundColorFocus,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$backgroundColorHover = {
        standard: (0, parcelRequire("1xPSU")).defaultBackgroundColorHover,
        subtle: (0, parcelRequire("1xPSU")).defaultBackgroundColorHover,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$borderColor = {
        standard: (0, parcelRequire("1xPSU")).defaultBorderColor,
        subtle: (0, parcelRequire("1xPSU")).transparent,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$borderColorFocus = {
        standard: (0, parcelRequire("1xPSU")).defaultBorderColorFocus,
        subtle: (0, parcelRequire("1xPSU")).defaultBorderColorFocus,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$borderColorHover = {
        standard: (0, parcelRequire("1xPSU")).defaultBorderColor,
        subtle: (0, parcelRequire("1xPSU")).subtleBorderColorHover,
        none: (0, parcelRequire("1xPSU")).transparent
    };
    const $349f5d21489b2f74$var$lineHeightBase = 20;
    const $349f5d21489b2f74$var$lineHeightCompact = 16;
    const $349f5d21489b2f74$var$compactVerticalPadding = 2;
    const $349f5d21489b2f74$var$verticalPadding = 6;
    const $349f5d21489b2f74$var$horizontalPadding = 8;
    const $349f5d21489b2f74$var$transitionDuration = '0.2s';
    const $349f5d21489b2f74$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
    const $349f5d21489b2f74$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
    const $349f5d21489b2f74$export$12879c7697ed953d = 2;
    const $349f5d21489b2f74$var$overrideSafariDisabledStyles = {
        WebkitTextFillColor: 'unset',
        WebkitOpacity: '1'
    };
    const $349f5d21489b2f74$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
        const contentHeight = $349f5d21489b2f74$var$lineHeightBase * minimumRows;
        return contentHeight + $349f5d21489b2f74$var$verticalPadding * 2 + borderHeight * 2;
    };
    const $349f5d21489b2f74$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
        const contentHeightCompact = $349f5d21489b2f74$var$lineHeightCompact * minimumRows;
        return contentHeightCompact + $349f5d21489b2f74$var$compactVerticalPadding * 2 + borderHeight * 2;
    };
    const $349f5d21489b2f74$var$bgAndBorderColorStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:focus': {
                backgroundColor: $349f5d21489b2f74$var$backgroundColorFocus[appearance],
                borderColor: $349f5d21489b2f74$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$349f5d21489b2f74$var$borderColorFocus[appearance]}`
            },
            '&:not(:focus)': {
                backgroundColor: $349f5d21489b2f74$var$backgroundColor[appearance],
                borderColor: $349f5d21489b2f74$var$borderColor[appearance]
            },
            '&[data-invalid]:focus': {
                backgroundColor: $349f5d21489b2f74$var$invalidRules.backgroundColorFocus,
                borderColor: $349f5d21489b2f74$var$invalidRules.borderColorFocus,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$349f5d21489b2f74$var$invalidRules.borderColorFocus}`
            },
            '&[data-invalid]:not(:focus)': {
                backgroundColor: $349f5d21489b2f74$var$invalidRules.backgroundColor,
                borderColor: $349f5d21489b2f74$var$invalidRules.borderColor,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$349f5d21489b2f74$var$invalidRules.borderColor}`
            },
            ...appearance === 'standard' ? {
                '&:disabled:focus': {
                    backgroundColor: $349f5d21489b2f74$var$disabledRules.backgroundColorFocus,
                    borderColor: $349f5d21489b2f74$var$disabledRules.borderColorFocus
                },
                '&:disabled:not(:focus)': {
                    backgroundColor: $349f5d21489b2f74$var$disabledRules.backgroundColor,
                    borderColor: $349f5d21489b2f74$var$disabledRules.borderColor
                }
            } : {}
        });
    const $349f5d21489b2f74$var$placeholderStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '&::placeholder': {
            color: (0, parcelRequire("1xPSU")).placeholderTextColor
        },
        '&:disabled::placeholder': {
            color: $349f5d21489b2f74$var$disabledRules.textColor
        }
    });
    const $349f5d21489b2f74$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && (0, (0, parcelRequire("f8Sb3")).css)({
            '&:hover:not(:read-only):not(:focus)': {
                backgroundColor: $349f5d21489b2f74$var$backgroundColorHover[appearance],
                borderColor: $349f5d21489b2f74$var$borderColorHover[appearance],
                '&:disabled': {
                    backgroundColor: $349f5d21489b2f74$var$disabledRules.backgroundColorHover
                },
                '&[data-invalid]': {
                    backgroundColor: $349f5d21489b2f74$var$invalidRules.backgroundColorHover,
                    borderColor: $349f5d21489b2f74$var$invalidRules.borderColor,
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$349f5d21489b2f74$var$invalidRules.borderColor}`
                }
            }
        });
    var $349f5d21489b2f74$var$_ref = {
        name: "utehjx",
        styles: "resize:none"
    };
    var $349f5d21489b2f74$var$_ref2 = {
        name: "bolgb9",
        styles: "resize:both"
    };
    const $349f5d21489b2f74$var$resizeStyle = (resize)=>{
        if (resize === 'horizontal' || resize === 'vertical') return (0, (0, parcelRequire("f8Sb3")).css)({
            resize: resize
        });
        if (resize === 'auto') return $349f5d21489b2f74$var$_ref2;
        return $349f5d21489b2f74$var$_ref;
    };
    const $349f5d21489b2f74$var$borderStyle = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)({
            borderStyle: appearance === 'none' ? 'none' : 'solid'
        });
    const $349f5d21489b2f74$var$fontFamilyStyle = (isMonospaced)=>(0, (0, parcelRequire("f8Sb3")).css)({
            fontFamily: isMonospaced ? $349f5d21489b2f74$var$codeFontFamily : $349f5d21489b2f74$var$fontFamily
        });
    const $349f5d21489b2f74$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
        const borderWidth = appearance !== 'none' ? 1 : 2;
        const horizontalPaddingWithoutBorderWidth = $349f5d21489b2f74$var$horizontalPadding - borderWidth;
        const borderHeight = borderWidth;
        return (0, (0, parcelRequire("f8Sb3")).css)({
            '&[data-compact]': {
                minHeight: $349f5d21489b2f74$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
                padding: `${$349f5d21489b2f74$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $349f5d21489b2f74$var$lineHeightCompact / 14
            },
            '&:not([data-compact])': {
                minHeight: $349f5d21489b2f74$var$borderBoxMinHeight(minimumRows, borderHeight),
                padding: `${$349f5d21489b2f74$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
                lineHeight: $349f5d21489b2f74$var$lineHeightBase / 14
            }
        });
    };
    const $349f5d21489b2f74$var$staticStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'block',
        boxSizing: 'border-box',
        width: '100%',
        minWidth: 0,
        maxWidth: '100%',
        margin: 0,
        position: 'relative',
        flex: '1 1 100%',
        borderRadius: "var(--ds-border-radius, 3px)",
        borderWidth: 1,
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        outline: 'none',
        overflow: 'auto',
        transition: `background-color ${$349f5d21489b2f74$var$transitionDuration} ease-in-out,
               border-color ${$349f5d21489b2f74$var$transitionDuration} ease-in-out`,
        wordWrap: 'break-word',
        '&:disabled': {
            cursor: 'not-allowed',
            ...$349f5d21489b2f74$var$overrideSafariDisabledStyles
        },
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        }
    });
    const $349f5d21489b2f74$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>(0, (0, parcelRequire("f8Sb3")).css)($349f5d21489b2f74$var$staticStyles, $349f5d21489b2f74$var$borderPaddingAndHeightStyles(minimumRows, appearance), $349f5d21489b2f74$var$resizeStyle(resize), $349f5d21489b2f74$var$borderStyle(appearance), $349f5d21489b2f74$var$fontFamilyStyle(isMonospaced), {
            maxHeight: maxHeight
        });
    const $349f5d21489b2f74$export$98856a888ef36079 = (appearance)=>(0, (0, parcelRequire("f8Sb3")).css)($349f5d21489b2f74$var$bgAndBorderColorStyles(appearance), $349f5d21489b2f74$var$hoverBackgroundAndBorderStyles(appearance), $349f5d21489b2f74$var$placeholderStyles, {
            color: (0, parcelRequire("1xPSU")).textColor,
            '&:disabled': {
                color: $349f5d21489b2f74$var$disabledRules.textColor
            }
        });
});
parcelRegister("1xPSU", function(module, exports) {
    $parcel$export(module.exports, "disabledBackground", ()=>$7d4f8489709fddb4$export$ae3cba7672df0890);
    $parcel$export(module.exports, "disabledBorder", ()=>$7d4f8489709fddb4$export$fe505fe3c5edbdf6);
    $parcel$export(module.exports, "invalidBorderColor", ()=>$7d4f8489709fddb4$export$7f333bbf7ddab792);
    $parcel$export(module.exports, "defaultBorderColor", ()=>$7d4f8489709fddb4$export$dafd83031c202ca8);
    $parcel$export(module.exports, "defaultBorderColorFocus", ()=>$7d4f8489709fddb4$export$e8320c09dc1e4012);
    $parcel$export(module.exports, "defaultBackgroundColor", ()=>$7d4f8489709fddb4$export$b13414ee9ac9cae6);
    $parcel$export(module.exports, "defaultBackgroundColorHover", ()=>$7d4f8489709fddb4$export$bca15982c103d57b);
    $parcel$export(module.exports, "defaultBackgroundColorFocus", ()=>$7d4f8489709fddb4$export$21287e4b7f134f09);
    $parcel$export(module.exports, "subtleBorderColorHover", ()=>$7d4f8489709fddb4$export$a87538d56ee366ec);
    $parcel$export(module.exports, "placeholderTextColor", ()=>$7d4f8489709fddb4$export$5e076b2557ef7bbb);
    $parcel$export(module.exports, "textColor", ()=>$7d4f8489709fddb4$export$32f78bffcd82ff28);
    $parcel$export(module.exports, "disabledTextColor", ()=>$7d4f8489709fddb4$export$eb4a7d363eec53c8);
    $parcel$export(module.exports, "transparent", ()=>$7d4f8489709fddb4$export$f4d082c200a4b4b8);
    const $7d4f8489709fddb4$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $72ba03e317f3d228$export$9fdfb749e33cdf97)})`;
    const $7d4f8489709fddb4$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $72ba03e317f3d228$export$1ce2d1575d444ceb)})`;
    const $7d4f8489709fddb4$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $72ba03e317f3d228$export$2010d0fb4295b346)})`;
    const $7d4f8489709fddb4$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`;
    const $7d4f8489709fddb4$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`;
    const $7d4f8489709fddb4$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`;
    const $7d4f8489709fddb4$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`;
    const $7d4f8489709fddb4$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`;
    const $7d4f8489709fddb4$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
    const $7d4f8489709fddb4$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $72ba03e317f3d228$export$f563ee71e9ee74cd)})`;
    const $7d4f8489709fddb4$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $72ba03e317f3d228$export$fbda843f0a27fe96)})`;
    const $7d4f8489709fddb4$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $72ba03e317f3d228$export$5f71e19f3a7ad9de)})`;
    const $7d4f8489709fddb4$export$f4d082c200a4b4b8 = 'transparent';
});
parcelRegister("8mGGj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af711023521e2d75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $9EfCw;
    const $af711023521e2d75$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $af711023521e2d75$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9EfCw")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("9EfCw")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $af711023521e2d75$export$2e2bcd8739ae039 = $af711023521e2d75$var$Textfield;
});
parcelRegister("9EfCw", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$a7502c1f5abf97ed$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$a7502c1f5abf97ed$export$3eeb47dc8e6249d9);
    const $a7502c1f5abf97ed$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $a7502c1f5abf97ed$var$backgroundColor[appearance],
            borderColor: $a7502c1f5abf97ed$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorHover[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorFocus[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$a7502c1f5abf97ed$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $a7502c1f5abf97ed$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $a7502c1f5abf97ed$var$getMaxWidth = (width)=>!width ? `100%` : width in $a7502c1f5abf97ed$var$widthMap ? $a7502c1f5abf97ed$var$widthMap[width] : +width;
    const $a7502c1f5abf97ed$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $a7502c1f5abf97ed$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $a7502c1f5abf97ed$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("7cbM0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$78c9409ad575aa5f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    function $78c9409ad575aa5f$export$2e2bcd8739ae039(props) {
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, props.children, (0, ($parcel$interopDefault($5uXOq))).createElement($78c9409ad575aa5f$var$ErrorMessage, null, props.error));
    }
    $78c9409ad575aa5f$export$2e2bcd8739ae039.defaultProps = {
        error: undefined
    };
    const $78c9409ad575aa5f$var$ErrorMessage = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz1l5o _1yt4swc3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7VpFm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$185a0480b7dde273$export$2e2bcd8739ae039);
    var $7VHMR;
    var $185a0480b7dde273$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        helpText: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.help-text",
            "defaultMessage": "Group related articles in categories to help customers find what they need."
        },
        nameFieldLabel: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-label",
            "defaultMessage": "Name"
        },
        nameFieldPlaceholder: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.name-field-placeholder",
            "defaultMessage": "Category name, e.g \"Printers\" or \"Wifi\""
        },
        descriptionFieldLabel: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-label",
            "defaultMessage": "Description"
        },
        descriptionFieldPlaceholder: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-category-form.description-field-placeholder",
            "defaultMessage": "Tell customers more about this category"
        }
    });
});
parcelRegister("5TOVG", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f748cc858c62ad0d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f748cc858c62ad0d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        title: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.title",
            "defaultMessage": "Create new category"
        },
        createAction: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.create-action",
            "defaultMessage": "Create"
        },
        cancelAction: {
            "id": "servicedesk-knowledge-common.create-category.create-category-stateless.cancel-action",
            "defaultMessage": "Cancel"
        }
    });
});
parcelRegister("ks7Ah", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$30d72adc6eb603b4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $kvQS7;
    const $30d72adc6eb603b4$var$NavDriver = (props)=>{
        const { children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kvQS7")).KbCreateCategorySubscriber), null, ({ isOpen: isOpen }, { setCreateCategoryDisplay: setCreateCategoryDisplay })=>{
            const onClose = ()=>setCreateCategoryDisplay(false);
            return children({
                isOpen: isOpen,
                onClose: onClose
            });
        });
    };
    var $30d72adc6eb603b4$export$2e2bcd8739ae039 = $30d72adc6eb603b4$var$NavDriver;
});
parcelRegister("kvQS7", function(module, exports) {
    $parcel$export(module.exports, "useKbCreateCategoryActions", ()=>$fefcd82701364dc4$export$719df9e736f08a9);
    $parcel$export(module.exports, "KbCreateCategorySubscriber", ()=>$fefcd82701364dc4$export$2b9cf8c256011b51);
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $fefcd82701364dc4$export$d4c72bab9d6cc13a = {
        isOpen: false
    };
    const $fefcd82701364dc4$var$setCreateCategoryDisplay = (isOpen)=>({ setState: setState })=>{
            setState({
                isOpen: isOpen
            });
        };
    const $fefcd82701364dc4$export$e324594224ef24da = {
        setCreateCategoryDisplay: $fefcd82701364dc4$var$setCreateCategoryDisplay
    };
    const $fefcd82701364dc4$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'kb-create-category',
        initialState: $fefcd82701364dc4$export$d4c72bab9d6cc13a,
        actions: $fefcd82701364dc4$export$e324594224ef24da
    });
    const $fefcd82701364dc4$export$719df9e736f08a9 = (0, (0, parcelRequire("3sQ5x")).createHook)($fefcd82701364dc4$var$Store, {
        selector: null
    });
    const $fefcd82701364dc4$export$2b9cf8c256011b51 = (0, (0, parcelRequire("51nlc")).createSubscriber)($fefcd82701364dc4$var$Store);
});
parcelRegister("6GLlD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b1e4a0c92f65aa33$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iXVV6;
    var $9noxX;
    var $e9YVH;
    var $9dbF6;
    var $9NiTW;
    var $cYaqS;
    const $b1e4a0c92f65aa33$var$ServiceDeskAppBase = ({ appName: appName, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cYaqS")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "serviceDesk"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9noxX")).ServiceDeskAnalyticsContext), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: (0, (0, parcelRequire("e9YVH")).toPackageName)(appName),
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, children))));
    var $b1e4a0c92f65aa33$export$2e2bcd8739ae039 = $b1e4a0c92f65aa33$var$ServiceDeskAppBase;
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
parcelRegister("cYaqS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f72fff5a1e4c8937$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jY6G;
    var $4UFLs;
    var $g3A84;
    const $f72fff5a1e4c8937$var$AccessCheck = ({ children: children })=>{
        const isSettingsRoute = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)().path.includes(`${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/:projectKey/settings/`);
        const Gate = isSettingsRoute ? (0, (0, parcelRequire("g3A84")).default) : (0, (0, parcelRequire("4UFLs")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Gate, null, children);
    };
    var $f72fff5a1e4c8937$export$2e2bcd8739ae039 = $f72fff5a1e4c8937$var$AccessCheck;
});
const $7c914880cb332728$export$967ba7bfb5ce30bd = '/jira/servicedesk/projects';
parcelRegister("4UFLs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9befbeaff9f5385d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $daoB1;
    var $7tQej;
    var $bmKPg;
    var $iDvG9;
    const $9befbeaff9f5385d$var$ProductAccessCheck = ({ children: children })=>{
        const { hasServiceDeskAccess: hasServiceDeskAccess } = (0, (0, parcelRequire("daoB1")).useApplicationPermissions)();
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        if (projectKey) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iDvG9")).default), null, children);
        return hasServiceDeskAccess ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
            to: "/jira"
        });
    };
    var $9befbeaff9f5385d$export$2e2bcd8739ae039 = $9befbeaff9f5385d$var$ProductAccessCheck;
});
parcelRegister("iDvG9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$34dd3dc578b1a167$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7tQej;
    var $bmKPg;
    var $dFOAR;
    var $fhAnU;
    const $34dd3dc578b1a167$var$AgentCheck = ({ children: children })=>{
        const [projectKey = ''] = (0, (0, parcelRequire("bmKPg")).usePathParam)('projectKey');
        const [{ data: data, error: error }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        if (data || error) {
            if (!(0, (0, parcelRequire("fhAnU")).isAccessError)(error)) {
                const { userRole: userRole = '' } = data || {};
                if (userRole === 'agent' || userRole === 'agent-project-admin') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
                if (error) throw error;
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7tQej")).Redirect), {
                to: `${(0, $7c914880cb332728$export$967ba7bfb5ce30bd)}/${projectKey}/issues`
            });
        }
        return null;
    };
    var $34dd3dc578b1a167$export$2e2bcd8739ae039 = $34dd3dc578b1a167$var$AgentCheck;
});
parcelRegister("fhAnU", function(module, exports) {
    $parcel$export(module.exports, "isAccessError", ()=>$1a790f4bb1355504$export$ddaebe4928e793cb);
    const $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES = [
        (0, $3cd8a0ece36fbae5$export$a3269a3914b007e3),
        (0, $3cd8a0ece36fbae5$export$8bca792d963eb0ef),
        (0, $3cd8a0ece36fbae5$export$67d19e9a991baa07)
    ];
    const $1a790f4bb1355504$export$ddaebe4928e793cb = (error)=>error?.statusCode != null ? $1a790f4bb1355504$var$RESTRICTED_ACCESS_CODES.includes(error.statusCode) : false;
});
parcelRegister("g3A84", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$60e7d6646168c089$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8pMQX;
    var $dFOAR;
    var $fhAnU;
    const $60e7d6646168c089$var$SettingsAccessCheck = ({ children: children })=>{
        const [{ data: serviceDeskContext, error: serviceDeskContextError }] = (0, (0, parcelRequire("dFOAR")).useServiceDeskContext)();
        const userRole = serviceDeskContext?.userRole;
        const hasAccessError = (0, (0, parcelRequire("fhAnU")).isAccessError)(serviceDeskContextError);
        if (userRole === 'agent-project-admin' && !hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        if (userRole !== undefined || hasAccessError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).ProjectNotFound), null);
        if (serviceDeskContextError) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8pMQX")).GenericError), null);
        return null;
    };
    var $60e7d6646168c089$export$2e2bcd8739ae039 = $60e7d6646168c089$var$SettingsAccessCheck;
});
parcelRegister("8pMQX", function(module, exports) {
    $parcel$export(module.exports, "ProjectNotFound", ()=>$951f6bd200bf8b89$export$849d319c342682a2);
    $parcel$export(module.exports, "GenericError", ()=>$951f6bd200bf8b89$export$7d465be8efa67280);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oKQq;
    var $6Ll2T;
    var $99gde;
    var $hIKcp;
    var $gLj7z;
    var $4R6GH;
    var $ew1Lk;
    var $bTyOW;
    var $fC09Q;
    var $iVgQf;
    var $koVbs;
    var $hDzhb;
    var $4AdE6;
    const $951f6bd200bf8b89$export$849d319c342682a2 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectsPath = '/jira/projects';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("fC09Q")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundTitle),
            description: formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundDescription),
            primaryAction: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hDzhb")).default), {
                to: projectsPath
            }, formatMessage((0, (0, parcelRequire("4AdE6")).default).notFoundAction))
        }));
    };
    const $951f6bd200bf8b89$export$7d465be8efa67280 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const traceId = (0, $5uXOq.useMemo)(()=>{
            const traceContext = (0, (0, parcelRequire("hIKcp")).getActiveTrace)();
            return traceContext?.traceId;
        }, []);
        let description = formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorDescription);
        if (traceId && (0, (0, parcelRequire("4R6GH")).fg)('jfp-trace-id-in-error-boundaries')) {
            const error = new Error('An error occurred while loading this page');
            description = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, description), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $951f6bd200bf8b89$var$styles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gLj7z")).ErrorHashAndTraceId), {
                error: error,
                traceId: traceId
            })));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericDocumentTitleJsm)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2oKQq")).default), {
            renderImage: (0, (0, parcelRequire("iVgQf")).getAkEmptyStateRenderImageFn)((0, (0, parcelRequire("bTyOW")).default)),
            maxImageWidth: 120,
            header: formatMessage((0, (0, parcelRequire("4AdE6")).default).genericErrorTitle),
            description: description
        }));
    };
    const $951f6bd200bf8b89$var$styles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.100'
    });
});
parcelRegister("gLj7z", function(module, exports) {
    $parcel$export(module.exports, "ErrorHashAndTraceId", ()=>$fe273132a82b30fc$export$61354a7dde2c2d3c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5oFIy;
    var $kobfu;
    var $ftF7i;
    const $fe273132a82b30fc$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
        const errorHash = (0, (0, parcelRequire("kobfu")).getErrorHash)(error);
        const source = `Hash ${errorHash}\nTrace ${traceId}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireOperationalAnalytics), {
            action: "rendered",
            actionSubject: "errorHashAndTraceId",
            attributes: {
                errorHash: errorHash,
                traceId: traceId
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "note"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ftF7i")).CodeBlockWithCopyButton), {
            source: source,
            copyCodeActionSubjectId: "copyErrorHashAndTraceId"
        })));
    };
});
parcelRegister("ftF7i", function(module, exports) {
    $parcel$export(module.exports, "CodeBlockWithCopyButton", ()=>$92e21bbf80c400af$export$ced1fc74d907d387);
    var $5uXOq = parcelRequire("5uXOq");
    var $gdvFP;
    var $6Ll2T;
    var $99gde;
    var $lOZGq;
    const $92e21bbf80c400af$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $92e21bbf80c400af$var$wrapperStyles,
            role: "region"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).ActionContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lOZGq")).CopyAction), {
            source: source,
            actionSubjectId: copyCodeActionSubjectId
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gdvFP")).default), {
            text: source,
            showLineNumbers: false,
            shouldWrapLongLines: false
        })));
    const $92e21bbf80c400af$var$wrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '100%',
        position: 'relative'
    });
});
parcelRegister("gdvFP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e1e3ab6f5cd16b56$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $3cdTK;
    var $1VQAj;
    var $3wq9L;
    var $kOLPm;
    const $e1e3ab6f5cd16b56$var$CodeBlock = (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false }) {
        const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
        const theme = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1VQAj")).getCodeBlockTheme)(numLines), [
            numLines
        ]);
        const getStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("1VQAj")).getCodeBlockStyles)(theme), [
            theme
        ]);
        const styles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("f8Sb3")).css)(getStyles(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)), [
            highlightedStartText,
            highlightedEndText,
            showLineNumbers,
            shouldWrapLongLines,
            getStyles
        ]);
        const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, (0, parcelRequire("3cdTK")).useHighlightLines)({
            highlight: highlight,
            testId: testId
        });
        const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
            getHighlightStyles,
            highlightedLines
        ]);
        const language = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("3wq9L")).normalizeLanguage)(providedLanguage), [
            providedLanguage
        ]);
        const languageToUse = text ? language : 'text';
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("kOLPm")).default), {
            "data-code-lang": language,
            "data-ds--code--code-block": "",
            testId: testId,
            language: languageToUse,
            css: styles,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber,
            lineProps: getLineProps,
            shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
            shouldWrapLongLines: shouldWrapLongLines,
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
            text: text
        });
    });
    $e1e3ab6f5cd16b56$var$CodeBlock.displayName = 'CodeBlock';
    var $e1e3ab6f5cd16b56$export$2e2bcd8739ae039 = $e1e3ab6f5cd16b56$var$CodeBlock;
});
parcelRegister("3cdTK", function(module, exports) {
    $parcel$export(module.exports, "useHighlightLines", ()=>$9354ecb135d9efb8$export$84415a200bdf33ed);
    var $5uXOq = parcelRequire("5uXOq");
    const $9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ = {
        'data-ds--code--row': ''
    };
    const $9354ecb135d9efb8$var$getLineStyleObject = (lineNumber, testId)=>{
        return testId ? {
            'data-testid': `${testId}-line-${lineNumber}`,
            ...$9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ
        } : $9354ecb135d9efb8$var$DEFAULT_LINE_EL_ATTR_OBJ;
    };
    const $9354ecb135d9efb8$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
        const highlightedLines = (0, $5uXOq.useMemo)(()=>{
            if (!highlight) return [];
            return highlight.split(',').map((num)=>{
                if (num.indexOf('-') > 0) {
                    const [from, to] = num.split('-').map(Number).sort((a, b)=>a - b);
                    return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
                }
                return Number(num);
            }).reduce((acc, val)=>acc.concat(val), []) || [];
        }, [
            highlight
        ]);
        const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
            if (!highlight || highlightedLines.length === 0) return $9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId);
            if (highlightedLines.includes(lineNumber)) {
                const highlightedDataAttrObj = {
                    'data-ds--code--row--highlight': ''
                };
                return {
                    ...highlightedDataAttrObj,
                    ...$9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId)
                };
            }
            return $9354ecb135d9efb8$var$getLineStyleObject(lineNumber, testId);
        }, [
            highlight,
            testId
        ]);
        return {
            getHighlightStyles: getHighlightStyles,
            highlightedLines: highlightedLines
        };
    };
});
parcelRegister("1VQAj", function(module, exports) {
    $parcel$export(module.exports, "getCodeBlockStyles", ()=>$1f3f8b295e4f1970$export$b571c24d82780698);
    $parcel$export(module.exports, "getCodeStyles", ()=>$1f3f8b295e4f1970$export$d5fcf1b7ff23707b);
    $parcel$export(module.exports, "getCodeBlockTheme", ()=>$1f3f8b295e4f1970$export$57a2d4b573afd64a);
    var $9jPr7;
    var $dW8Ue;
    const $1f3f8b295e4f1970$export$cb7aec0206b595d2 = (numLines)=>{
        if (!numLines) return '1ch';
        return `${numLines.toFixed(0).length}ch`;
    };
    const $1f3f8b295e4f1970$var$lineNumberStyle = (theme)=>({
            minWidth: `calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px) !important`,
            fontStyle: 'normal !important',
            color: `${theme.lineNumberColor} !important`,
            flexShrink: 0,
            boxSizing: 'border-box',
            paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
            paddingLeft: (0, (0, parcelRequire("9jPr7")).SPACING),
            marginRight: (0, (0, parcelRequire("9jPr7")).SPACING),
            textAlign: 'right',
            userSelect: 'none',
            display: 'block',
            '&::after': {
                content: `attr(data-ds--line-number)`
            }
        });
    const $1f3f8b295e4f1970$var$syntaxKeywordColors = (theme)=>({
            '.token': {
                '&:not([class=token],[data-ds--code--row--highlight],[data-ds--code--row])': {
                    all: 'unset'
                },
                '&.key,&.keyword': {
                    color: theme.keywordColor,
                    fontWeight: 'bolder'
                },
                '&.attr-name': {
                    color: theme.attributeColor
                },
                '&.selector': {
                    color: theme.selectorTagColor
                },
                '&.comment,&.block-comment': {
                    color: theme.commentColor,
                    fontFamily: theme.fontFamilyItalic,
                    fontStyle: 'italic'
                },
                '&.function-name': {
                    color: theme.sectionColor
                },
                '&.doctype': {
                    color: theme.docTagColor
                },
                '&.substr': {
                    color: theme.substringColor
                },
                '&.namespace': {
                    color: theme.nameColor
                },
                '&.builtin': {
                    color: theme.builtInColor
                },
                '&.entity': {
                    color: theme.literalColor
                },
                '&.bullet': {
                    color: theme.bulletColor
                },
                '&.code': {
                    color: theme.codeColor
                },
                '&.regex': {
                    color: theme.regexpColor
                },
                '&.symbol': {
                    color: theme.symbolColor
                },
                '&.variable': {
                    color: theme.variableColor
                },
                '&.url': {
                    color: theme.linkColor
                },
                '&.selector-attr': {
                    color: theme.selectorAttributeColor
                },
                '&.selector-pseudo': {
                    color: theme.selectorPseudoColor
                },
                '&.type': {
                    color: theme.typeColor
                },
                '&.quote': {
                    color: theme.quoteColor
                },
                '&.tag': {
                    color: theme.templateTagColor
                },
                '&.string': {
                    color: theme.stringColor
                },
                '&.class-name': {
                    color: theme.sectionColor
                },
                '&.title': {
                    color: theme.titleColor
                },
                '&.section': {
                    color: theme.sectionColor
                },
                '&.meta-keyword': {
                    color: theme.metaKeywordColor
                },
                '&.meta': {
                    color: theme.metaColor
                },
                '&.italic': {
                    fontStyle: 'italic'
                },
                '&.bold': {
                    fontWeight: 'bolder'
                },
                '&.function': {
                    color: theme.functionColor
                },
                '&.number': {
                    color: theme.numberColor
                },
                '&.attr-value': {
                    color: theme.attributeColor
                },
                '&.prolog': {
                    color: theme.prologColor
                },
                '&.cdata': {
                    color: theme.cdataColor
                },
                '&.punctuation': {
                    color: theme.punctuationColor
                },
                '&.property': {
                    color: theme.propertyColor
                },
                '&.constant': {
                    color: theme.constantColor
                },
                '&.deleted': {
                    color: theme.deletedColor
                },
                '&.boolean': {
                    color: theme.booleanColor
                },
                '&.char': {
                    color: theme.charColor
                },
                '&.inserted': {
                    color: theme.insertedColor
                },
                '&.operator': {
                    color: theme.operatorColor
                },
                '&.atrule': {
                    color: theme.atruleColor
                },
                '&.important': {
                    color: theme.importantColor,
                    fontWeight: 'bold'
                }
            }
        });
    const $1f3f8b295e4f1970$export$ee58a26b5d612ac1 = (theme)=>({
            fontSize: (0, (0, parcelRequire("9jPr7")).CODE_FONT_SIZE),
            fontFamily: theme.fontFamily,
            fontWeight: "var(--ds-font-weight-regular, 400)",
            backgroundColor: `var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_BG_COLOR},${theme.backgroundColor})`,
            color: theme.textColor,
            borderStyle: 'none',
            borderRadius: "var(--ds-border-radius, 3px)"
        });
    const $1f3f8b295e4f1970$export$b571c24d82780698 = (theme)=>(highlightedStartText, highlightedEndText, showLineNumbers, shouldWrapLongLines)=>({
                'code[class*="language-"], pre[class*="language-"], code': {
                    all: 'unset',
                    padding: showLineNumbers ? `${0, (0, parcelRequire("9jPr7")).SPACING}px 0` : (0, (0, parcelRequire("9jPr7")).SPACING),
                    tabSize: 4
                },
                display: 'flex',
                lineHeight: (0, (0, parcelRequire("9jPr7")).CODE_LINE_HEIGHT),
                overflowX: 'auto',
                whiteSpace: 'pre',
                direction: 'ltr',
                ...$1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme),
                ...$1f3f8b295e4f1970$var$syntaxKeywordColors(theme),
                '& .linenumber, .ds-sh-line-number': $1f3f8b295e4f1970$var$lineNumberStyle(theme),
                '& .linenumber': {
                    display: 'inline-block !important',
                    float: 'left'
                },
                '& [data-ds--code--row]': {
                    display: showLineNumbers ? 'flex' : 'block',
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    marginRight: `-${0, (0, parcelRequire("9jPr7")).SPACING}px`
                },
                '& [data-ds--code--row--highlight]': {
                    background: `${theme.highlightedLineBgColor}`,
                    '&::before, &::after': {
                        clipPath: 'inset(100%)',
                        clip: 'rect(1px, 1px, 1px, 1px)',
                        height: '1px',
                        overflow: 'hidden',
                        position: 'absolute',
                        whiteSpace: 'nowrap',
                        width: '1px'
                    },
                    '&::before': {
                        content: `" [${highlightedStartText}] "`
                    },
                    '&::after': {
                        content: `" [${highlightedEndText}] "`
                    }
                },
                '& [data-ds--code--row--highlight] .linenumber': {
                    borderLeft: `${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH} solid ${theme.highlightedLineBorderColor}`,
                    paddingLeft: `${(0, (0, parcelRequire("9jPr7")).SPACING) / 2}px !important`,
                    position: 'relative'
                },
                '& [data-ds--code--row--highlight] .linenumber::before': {
                    content: '""',
                    position: 'absolute',
                    width: (0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH),
                    top: '-1px',
                    left: `-${0, (0, parcelRequire("9jPr7")).HIGHLIGHT_BORDER_WIDTH}`,
                    borderTop: `1px solid ${theme.highlightedLineBorderColor}`
                },
                '[data-ds--code--row--highlight] + [data-ds--code--row]:not([data-ds--code--row--highlight]), [data-ds--code--row]:not([data-ds--code--row--highlight]) + [data-ds--code--row--highlight]': {
                    borderTop: '1px dashed transparent'
                },
                '[data-ds--code--row--highlight]:last-child': {
                    borderBottom: '1px dashed transparent'
                },
                '& code:first-of-type': {
                    paddingRight: `0px !important`,
                    backgroundImage: showLineNumbers ? `linear-gradient(to right, var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor}), var(${0, (0, parcelRequire("9jPr7")).VAR_CODE_LINE_NUMBER_BG_COLOR},${theme.lineNumberBgColor})
    calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent calc(${theme.lineNumberWidth} + ${0, (0, parcelRequire("9jPr7")).LINE_NUMBER_GUTTER}px), transparent)` : undefined
                },
                '& code:last-of-type': {
                    paddingRight: `${0, (0, parcelRequire("9jPr7")).SPACING}px !important`,
                    flexBasis: 'auto',
                    flexGrow: 1,
                    flexShrink: shouldWrapLongLines ? 1 : 0,
                    wordBreak: 'break-word'
                },
                'code > span:only-child:empty:before, code > span:only-child > span:only-child:empty:before': {
                    content: '" "'
                }
            });
    const $1f3f8b295e4f1970$export$d5fcf1b7ff23707b = ()=>{
        const theme = (0, (0, parcelRequire("dW8Ue")).getBaseTheme)();
        const baseStyles = $1f3f8b295e4f1970$export$ee58a26b5d612ac1(theme);
        return {
            ...baseStyles,
            display: 'inline',
            padding: '2px 0.5ch',
            boxDecorationBreak: 'clone',
            fontSize: '0.875em',
            overflow: 'auto',
            overflowWrap: 'break-word',
            whiteSpace: 'pre-wrap'
        };
    };
    const $1f3f8b295e4f1970$export$57a2d4b573afd64a = (maxLines)=>{
        return {
            ...(0, (0, parcelRequire("dW8Ue")).getBaseTheme)(),
            ...(0, (0, parcelRequire("dW8Ue")).getColorPalette)(),
            lineNumberWidth: maxLines ? $1f3f8b295e4f1970$export$cb7aec0206b595d2(maxLines) : undefined
        };
    };
});
parcelRegister("9jPr7", function(module, exports) {
    $parcel$export(module.exports, "CODE_FONT_SIZE", ()=>$16851b1001a2abd2$export$431ac46d758d98c8);
    $parcel$export(module.exports, "CODE_LINE_HEIGHT", ()=>$16851b1001a2abd2$export$8e3c04032121c606);
    $parcel$export(module.exports, "HIGHLIGHT_BORDER_WIDTH", ()=>$16851b1001a2abd2$export$c8b5dc30e9f2b86e);
    $parcel$export(module.exports, "SPACING", ()=>$16851b1001a2abd2$export$82ea42e772d49e5b);
    $parcel$export(module.exports, "LINE_NUMBER_GUTTER", ()=>$16851b1001a2abd2$export$eeeea0ff98e06fff);
    $parcel$export(module.exports, "VAR_CODE_LINE_NUMBER_BG_COLOR", ()=>$16851b1001a2abd2$export$254015fe817dcb9e);
    $parcel$export(module.exports, "VAR_CODE_BG_COLOR", ()=>$16851b1001a2abd2$export$1758fda69688282e);
    var $bUQGL;
    const $16851b1001a2abd2$export$431ac46d758d98c8 = 12;
    const $16851b1001a2abd2$export$8e3c04032121c606 = '20px';
    const $16851b1001a2abd2$export$c8b5dc30e9f2b86e = '4px';
    const $16851b1001a2abd2$export$82ea42e772d49e5b = (0, (0, parcelRequire("bUQGL")).gridSize)();
    const $16851b1001a2abd2$export$eeeea0ff98e06fff = $16851b1001a2abd2$export$82ea42e772d49e5b * 2;
    const $16851b1001a2abd2$export$254015fe817dcb9e = '--ds--code--line-number-bg-color';
    const $16851b1001a2abd2$export$1758fda69688282e = '--ds--code--bg-color';
    const $16851b1001a2abd2$export$2cd00c745c539a1 = `data-ds--code--code-block`;
});
parcelRegister("dW8Ue", function(module, exports) {
    $parcel$export(module.exports, "getBaseTheme", ()=>$c352b5d6d7e52441$export$4464aa303b3e4fda);
    $parcel$export(module.exports, "getColorPalette", ()=>$c352b5d6d7e52441$export$fe2a6478976e8b17);
    var $8QpSo;
    var $5w2JH;
    const $c352b5d6d7e52441$var$T800 = '#067384';
    const $c352b5d6d7e52441$var$Y1100 = '#7A5D1A';
    const $c352b5d6d7e52441$export$4464aa303b3e4fda = ()=>({
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
            fontFamilyItalic: `SFMono-MediumItalic, ${(0, (0, parcelRequire("5w2JH")).default)('font.family.code')}`,
            backgroundColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$9fdfb749e33cdf97})`,
            textColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            lineNumberColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            lineNumberBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`
        });
    const $c352b5d6d7e52441$export$fe2a6478976e8b17 = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        return {
            highlightedLineBgColor: `var(--ds-background-neutral, ${$72ba03e317f3d228$export$3e51e8f1440314ba})`,
            highlightedLineBorderColor: `var(--ds-border-focused, ${$72ba03e317f3d228$export$215b7063051591f1})`,
            substringColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            keywordColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            attributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorTagColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            docTagColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`,
            nameColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            builtInColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            literalColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            bulletColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            codeColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            regexpColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            symbolColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            variableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateVariableColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            linkColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            selectorAttributeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorPseudoColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            typeColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            stringColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            selectorIdColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            selectorClassColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            quoteColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            templateTagColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            titleColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            sectionColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            commentColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            metaKeywordColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            metaColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            functionColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            numberColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            prologColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            cdataColor: `var(--ds-text-subtlest, ${$72ba03e317f3d228$export$eece5f492e429f08})`,
            punctuationColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            propertyColor: `var(--ds-text-accent-purple, ${$72ba03e317f3d228$export$b48405b95304b5a1})`,
            constantColor: `var(--ds-text-accent-teal, ${$c352b5d6d7e52441$var$T800})`,
            booleanColor: `var(--ds-text-accent-blue, ${$72ba03e317f3d228$export$b3de0ae08da2ce64})`,
            charColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            insertedColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            deletedColor: `var(--ds-text-accent-red, ${$72ba03e317f3d228$export$2837b5a1a71d5c02})`,
            operatorColor: `var(--ds-text, ${$72ba03e317f3d228$export$7d61b15e0da132af})`,
            atruleColor: `var(--ds-text-accent-green, ${$72ba03e317f3d228$export$6fa04827ac68a4fb})`,
            importantColor: `var(--ds-text-accent-yellow, ${$c352b5d6d7e52441$var$Y1100})`
        };
    });
    const $c352b5d6d7e52441$var$getTheme = ()=>({
            ...$c352b5d6d7e52441$export$4464aa303b3e4fda(),
            ...$c352b5d6d7e52441$export$fe2a6478976e8b17()
        });
    var $c352b5d6d7e52441$export$2e2bcd8739ae039 = $c352b5d6d7e52441$var$getTheme;
});
parcelRegister("3wq9L", function(module, exports) {
    $parcel$export(module.exports, "normalizeLanguage", ()=>$41e362fed9e5618b$export$f38728011c178796);
    var $8QpSo;
    var $5lUaL;
    const $41e362fed9e5618b$export$f38728011c178796 = (0, (0, parcelRequire("8QpSo")).default)((language)=>{
        if (!language) return '';
        const match = (0, (0, parcelRequire("5lUaL")).SUPPORTED_LANGUAGES).find((val)=>{
            return val.name === language || val.alias.includes(language);
        });
        return match ? match.value : 'text';
    });
});
parcelRegister("5lUaL", function(module, exports) {
    $parcel$export(module.exports, "SUPPORTED_LANGUAGES", ()=>$91fe7c840a716685$export$7c77c3a9bb93870d);
    const $91fe7c840a716685$export$7c77c3a9bb93870d = [
        {
            name: 'PHP',
            alias: [
                'php',
                'php3',
                'php4',
                'php5'
            ],
            value: 'php'
        },
        {
            name: 'Java',
            alias: [
                'java'
            ],
            value: 'java'
        },
        {
            name: 'CSharp',
            alias: [
                'csharp',
                'c#'
            ],
            value: 'cs'
        },
        {
            name: 'Python',
            alias: [
                'python',
                'py'
            ],
            value: 'python'
        },
        {
            name: 'JavaScript',
            alias: [
                'javascript',
                'js'
            ],
            value: 'javascript'
        },
        {
            name: 'Html',
            alias: [
                'html'
            ],
            value: 'xml'
        },
        {
            name: 'C++',
            alias: [
                'c++',
                'cpp',
                'clike'
            ],
            value: 'cpp'
        },
        {
            name: 'Ruby',
            alias: [
                'ruby',
                'rb',
                'duby'
            ],
            value: 'ruby'
        },
        {
            name: 'Objective-C',
            alias: [
                'objective-c',
                'objectivec',
                'obj-c',
                'objc'
            ],
            value: 'objectivec'
        },
        {
            name: 'C',
            alias: [
                'c'
            ],
            value: 'cpp'
        },
        {
            name: 'Swift',
            alias: [
                'swift'
            ],
            value: 'swift'
        },
        {
            name: 'TeX',
            alias: [
                'tex',
                'latex'
            ],
            value: 'tex'
        },
        {
            name: 'Shell',
            alias: [
                'shell',
                'bash',
                'sh',
                'ksh',
                'zsh'
            ],
            value: 'shell'
        },
        {
            name: 'Scala',
            alias: [
                'scala'
            ],
            value: 'scala'
        },
        {
            name: 'Go',
            alias: [
                'go'
            ],
            value: 'go'
        },
        {
            name: 'ActionScript',
            alias: [
                'actionscript',
                'actionscript3',
                'as'
            ],
            value: 'actionscript'
        },
        {
            name: 'ColdFusion',
            alias: [
                'coldfusion'
            ],
            value: 'xml'
        },
        {
            name: 'JavaFX',
            alias: [
                'javafx',
                'jfx'
            ],
            value: 'java'
        },
        {
            name: 'VbNet',
            alias: [
                'vbnet',
                'vb.net',
                'vfp',
                'clipper',
                'xbase'
            ],
            value: 'vbnet'
        },
        {
            name: 'JSON',
            alias: [
                'json'
            ],
            value: 'json'
        },
        {
            name: 'MATLAB',
            alias: [
                'matlab'
            ],
            value: 'matlab'
        },
        {
            name: 'Groovy',
            alias: [
                'groovy'
            ],
            value: 'groovy'
        },
        {
            name: 'SQL',
            alias: [
                'sql',
                'postgresql',
                'postgres',
                'plpgsql',
                'psql',
                'postgresql-console',
                'postgres-console',
                'tsql',
                't-sql',
                'mysql',
                'sqlite'
            ],
            value: 'sql'
        },
        {
            name: 'R',
            alias: [
                'r'
            ],
            value: 'r'
        },
        {
            name: 'Perl',
            alias: [
                'perl',
                'pl'
            ],
            value: 'perl'
        },
        {
            name: 'Lua',
            alias: [
                'lua'
            ],
            value: 'lua'
        },
        {
            name: 'Pascal',
            alias: [
                'pas',
                'pascal',
                'objectpascal',
                'delphi'
            ],
            value: 'pascal'
        },
        {
            name: 'XML',
            alias: [
                'xml'
            ],
            value: 'xml'
        },
        {
            name: 'TypeScript',
            alias: [
                'typescript',
                'ts'
            ],
            value: 'typescript'
        },
        {
            name: 'CoffeeScript',
            alias: [
                'coffeescript',
                'coffee-script',
                'coffee'
            ],
            value: 'coffeescript'
        },
        {
            name: 'Haskell',
            alias: [
                'haskell',
                'hs'
            ],
            value: 'haskell'
        },
        {
            name: 'Puppet',
            alias: [
                'puppet'
            ],
            value: 'puppet'
        },
        {
            name: 'Arduino',
            alias: [
                'arduino'
            ],
            value: 'arduino'
        },
        {
            name: 'Fortran',
            alias: [
                'fortran'
            ],
            value: 'fortran'
        },
        {
            name: 'Erlang',
            alias: [
                'erlang',
                'erl'
            ],
            value: 'erlang'
        },
        {
            name: 'PowerShell',
            alias: [
                'powershell',
                'posh',
                'ps1',
                'psm1'
            ],
            value: 'powershell'
        },
        {
            name: 'Haxe',
            alias: [
                'haxe',
                'hx',
                'hxsl'
            ],
            value: 'haxe'
        },
        {
            name: 'Elixir',
            alias: [
                'elixir',
                'ex',
                'exs'
            ],
            value: 'elixir'
        },
        {
            name: 'Verilog',
            alias: [
                'verilog',
                'v'
            ],
            value: 'verilog'
        },
        {
            name: 'Rust',
            alias: [
                'rust'
            ],
            value: 'rust'
        },
        {
            name: 'VHDL',
            alias: [
                'vhdl'
            ],
            value: 'vhdl'
        },
        {
            name: 'Sass',
            alias: [
                'sass'
            ],
            value: 'less'
        },
        {
            name: 'OCaml',
            alias: [
                'ocaml'
            ],
            value: 'ocaml'
        },
        {
            name: 'Dart',
            alias: [
                'dart'
            ],
            value: 'dart'
        },
        {
            name: 'CSS',
            alias: [
                'css'
            ],
            value: 'css'
        },
        {
            name: 'reStructuredText',
            alias: [
                'restructuredtext',
                'rst',
                'rest'
            ],
            value: 'rest'
        },
        {
            name: 'Kotlin',
            alias: [
                'kotlin'
            ],
            value: 'kotlin'
        },
        {
            name: 'D',
            alias: [
                'd'
            ],
            value: 'd'
        },
        {
            name: 'Octave',
            alias: [
                'octave'
            ],
            value: 'matlab'
        },
        {
            name: 'QML',
            alias: [
                'qbs',
                'qml'
            ],
            value: 'qml'
        },
        {
            name: 'Prolog',
            alias: [
                'prolog'
            ],
            value: 'prolog'
        },
        {
            name: 'FoxPro',
            alias: [
                'foxpro',
                'purebasic'
            ],
            value: 'purebasic'
        },
        {
            name: 'Scheme',
            alias: [
                'scheme',
                'scm'
            ],
            value: 'scheme'
        },
        {
            name: 'CUDA',
            alias: [
                'cuda',
                'cu'
            ],
            value: 'cpp'
        },
        {
            name: 'Julia',
            alias: [
                'julia',
                'jl'
            ],
            value: 'julia'
        },
        {
            name: 'Racket',
            alias: [
                'racket',
                'rkt'
            ],
            value: 'lisp'
        },
        {
            name: 'Ada',
            alias: [
                'ada',
                'ada95',
                'ada2005'
            ],
            value: 'ada'
        },
        {
            name: 'Tcl',
            alias: [
                'tcl'
            ],
            value: 'tcl'
        },
        {
            name: 'Mathematica',
            alias: [
                'mathematica',
                'mma',
                'nb'
            ],
            value: 'mathematica'
        },
        {
            name: 'Autoit',
            alias: [
                'autoit'
            ],
            value: 'autoit'
        },
        {
            name: 'StandardML',
            alias: [
                'standardmL',
                'sml',
                'standardml'
            ],
            value: 'sml'
        },
        {
            name: 'Objective-J',
            alias: [
                'objective-j',
                'objectivej',
                'obj-j',
                'objj'
            ],
            value: 'objectivec'
        },
        {
            name: 'Smalltalk',
            alias: [
                'smalltalk',
                'squeak',
                'st'
            ],
            value: 'smalltalk'
        },
        {
            name: 'Vala',
            alias: [
                'vala',
                'vapi'
            ],
            value: 'vala'
        },
        {
            name: 'ABAP',
            alias: [
                'abap'
            ],
            value: 'sql'
        },
        {
            name: 'LiveScript',
            alias: [
                'livescript',
                'live-script'
            ],
            value: 'livescript'
        },
        {
            name: 'XQuery',
            alias: [
                'xquery',
                'xqy',
                'xq',
                'xql',
                'xqm'
            ],
            value: 'xquery'
        },
        {
            name: 'PlainText',
            alias: [
                'text',
                'plaintext'
            ],
            value: 'text'
        },
        {
            name: 'Yaml',
            alias: [
                'yaml',
                'yml'
            ],
            value: 'yaml'
        },
        {
            name: 'GraphQL',
            alias: [
                'graphql'
            ],
            value: 'graphql'
        },
        {
            name: 'AppleScript',
            alias: [
                'applescript'
            ],
            value: 'applescript'
        },
        {
            name: 'Clojure',
            alias: [
                'clojure'
            ],
            value: 'clojure'
        },
        {
            name: 'Diff',
            alias: [
                'diff'
            ],
            value: 'diff'
        },
        {
            name: 'VisualBasic',
            alias: [
                'visualbasic'
            ],
            value: 'visual-basic'
        },
        {
            name: 'JSX',
            alias: [
                'jsx'
            ],
            value: 'jsx'
        },
        {
            name: 'TSX',
            alias: [
                'tsx'
            ],
            value: 'tsx'
        },
        {
            name: 'SplunkSPL',
            alias: [
                'splunk-spl'
            ],
            value: 'splunk-spl'
        },
        {
            name: 'Dockerfile',
            alias: [
                'docker',
                'dockerfile'
            ],
            value: 'dockerfile'
        },
        {
            name: 'HCL',
            alias: [
                'hcl',
                'terraform'
            ],
            value: 'hcl'
        },
        {
            name: 'NGINX',
            alias: [
                'nginx'
            ],
            value: 'nginx'
        },
        {
            name: 'Protocol Buffers',
            alias: [
                'protobuf',
                'proto'
            ],
            value: 'protobuf'
        }
    ];
});
parcelRegister("kOLPm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a42fbdf1f5ea3ed9$export$2e2bcd8739ae039);
    var $aVBRo;
    var $a42fbdf1f5ea3ed9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("aVBRo")).default);
});
parcelRegister("aVBRo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5f9ccff03a95a648$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bTRwa;
    const $5f9ccff03a95a648$var$generator = (options)=>{
        const { loader: loader } = options;
        class AsyncHighlighter extends (0, ($parcel$interopDefault($5uXOq))).PureComponent {
            static{
                this.astGenerator = null;
            }
            static{
                this.highlightInstance = (0, (0, parcelRequire("bTRwa")).default);
            }
            static preload() {
                return AsyncHighlighter.loadAstGenerator();
            }
            static loadAstGenerator() {
                AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                    AsyncHighlighter.astGenerator = astGenerator;
                    return astGenerator;
                });
                return AsyncHighlighter.astGeneratorPromise;
            }
            componentDidMount() {
                if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
                if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                    this.forceUpdate();
                });
            }
            render() {
                return (0, ($parcel$interopDefault($5uXOq))).createElement(AsyncHighlighter.highlightInstance, {
                    ...this.props,
                    astGenerator: AsyncHighlighter.astGenerator
                });
            }
        }
        return AsyncHighlighter;
    };
    const $5f9ccff03a95a648$var$asyncGenerator = $5f9ccff03a95a648$var$generator({
        loader: ()=>(parcelRequire("kN6qz")).then((module)=>{
                return module.default || module;
            })
    });
    var $5f9ccff03a95a648$export$2e2bcd8739ae039 = $5f9ccff03a95a648$var$asyncGenerator;
});
parcelRegister("bTRwa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$714e39a7d165750f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bQkeD;
    var $bAA7E;
    const $714e39a7d165750f$var$Highlight = (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
        className: `language-${language}`
    }, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
        const code = text;
        const generatorClassName = 'prismjs';
        const containerProps = {
            ...rest,
            'data-testid': testId,
            className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
        };
        if (shouldWrapLongLines) codeTagProps.style = {
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word'
        };
        else codeTagProps.style = {
            whiteSpace: 'pre'
        };
        const codeBidiWarningConfig = {
            codeBidiWarnings: codeBidiWarnings,
            codeBidiWarningLabel: codeBidiWarningLabel,
            codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
        };
        const rows = (0, (0, parcelRequire("bQkeD")).default)({
            astGenerator: astGenerator,
            code: code,
            language: language,
            shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
            lineProps: lineProps,
            showLineNumbers: showLineNumbers,
            firstLineNumber: firstLineNumber
        });
        return (0, (0, parcelRequire("bAA7E")).default)({
            containerProps: containerProps,
            codeTagProps: codeTagProps,
            rows: rows,
            codeBidiWarningConfig: codeBidiWarningConfig
        });
    });
    var $714e39a7d165750f$export$2e2bcd8739ae039 = $714e39a7d165750f$var$Highlight;
});
parcelRegister("bQkeD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$300f970a4217b631$export$2e2bcd8739ae039);
    var $h1mgC;
    var $7cd5I;
    var $756jv;
    var $g0987;
    const $300f970a4217b631$var$newLineRegex = /\n/g;
    function $300f970a4217b631$var$getNewLines(str) {
        return str.match($300f970a4217b631$var$newLineRegex);
    }
    function $300f970a4217b631$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
        const codeTree = (0, (0, parcelRequire("g0987")).default)(language, code, astGenerator);
        const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
        const createLine = (0, (0, parcelRequire("h1mgC")).default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
        const newTree = [];
        let lastLineBreakIndex = -1;
        let index = 0;
        const tree = (0, (0, parcelRequire("756jv")).default)(codeTree);
        while(index < tree.length){
            const testNode = tree[index];
            if (testNode.type === 'text') {
                index++;
                continue;
            }
            const node = testNode;
            const firstChildNode = node.children[0];
            if (firstChildNode.type === 'text') {
                const { value: value } = firstChildNode;
                const newLines = $300f970a4217b631$var$getNewLines(value);
                if (newLines) {
                    const splitValue = value.split('\n');
                    splitValue.forEach((text, i)=>{
                        const lineNumber = newTree.length + startingLineNumber;
                        const newChild = {
                            type: 'text',
                            value: `${text}\n`
                        };
                        if (i === 0) {
                            const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, (0, parcelRequire("7cd5I")).default)({
                                children: [
                                    newChild
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            }));
                            const line = createLine(children, lineNumber);
                            newTree.push(line);
                        } else if (i === splitValue.length - 1) {
                            const nextNode = tree[index + 1];
                            const stringChild = nextNode && nextNode.children && nextNode.children[0];
                            const lastLineInPreviousSpan = {
                                type: 'text',
                                value: `${text}`
                            };
                            if (stringChild) {
                                const newElem = (0, (0, parcelRequire("7cd5I")).default)({
                                    children: [
                                        lastLineInPreviousSpan
                                    ],
                                    className: node.properties.className,
                                    lineNumber: lineNumber
                                });
                                tree.splice(index + 1, 0, newElem);
                            } else {
                                const children = [
                                    lastLineInPreviousSpan
                                ];
                                const line = createLine(children, lineNumber, node.properties.className);
                                newTree.push(line);
                            }
                        } else {
                            const children = [
                                newChild
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    });
                    lastLineBreakIndex = index;
                }
            }
            index++;
        }
        if (lastLineBreakIndex !== tree.length - 1) {
            const children = tree.slice(lastLineBreakIndex + 1, tree.length);
            if (children && children.length) {
                const lineNumber = newTree.length + startingLineNumber;
                const line = createLine(children, lineNumber);
                newTree.push(line);
            }
        }
        if (shouldCreateParentElementForLines) return newTree;
        return newTree.flat(1);
    }
});
parcelRegister("h1mgC", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e802874db56687b3$export$2e2bcd8739ae039);
    var $7cd5I;
    var $9T5KR;
    function $e802874db56687b3$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
        return (children, lineNumber, className = [])=>{
            if (shouldCreateParentElementForLines || className.length > 0) return (0, (0, parcelRequire("7cd5I")).default)({
                children: children,
                lineNumber: lineNumber,
                showLineNumbers: showLineNumbers,
                lineProps: lineProps,
                className: className
            });
            else {
                if (showLineNumbers && lineNumber) children.unshift((0, (0, parcelRequire("9T5KR")).default)(lineNumber));
                return children;
            }
        };
    }
    var $e802874db56687b3$export$2e2bcd8739ae039 = $e802874db56687b3$var$createLineGenerator;
});
parcelRegister("7cd5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fb90ce175080ebd7$export$2e2bcd8739ae039);
    var $9T5KR;
    function $fb90ce175080ebd7$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
        const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
        const properties = {
            ...propsPassedInFromCodeBlock,
            className: className
        };
        let currentChildren = children;
        if (lineNumber && showLineNumbers) {
            if (currentChildren.length === 1) currentChildren = [
                (0, (0, parcelRequire("9T5KR")).default)(lineNumber),
                ...currentChildren
            ];
            else currentChildren = [
                (0, (0, parcelRequire("9T5KR")).default)(lineNumber),
                {
                    type: 'element',
                    tagName: 'span',
                    properties: {
                        className: []
                    },
                    children: currentChildren
                }
            ];
        }
        return {
            type: 'element',
            tagName: 'span',
            properties: properties,
            children: currentChildren
        };
    }
});
parcelRegister("9T5KR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16511336cb833d65$export$2e2bcd8739ae039);
    function $16511336cb833d65$export$2e2bcd8739ae039(lineNumber) {
        return {
            type: 'element',
            tagName: 'span',
            properties: {
                key: `line-number--${lineNumber}`,
                className: [
                    'comment',
                    'linenumber',
                    'ds-line-number'
                ],
                'data-ds--line-number': lineNumber
            },
            children: []
        };
    }
});
parcelRegister("756jv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3722626977573637$export$2e2bcd8739ae039);
    var $7cd5I;
    function $3722626977573637$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
        let newTree = [];
        for(let i = 0; i < tree.length; i++){
            const node = tree[i];
            if (node.type === 'text') newTree.push((0, (0, parcelRequire("7cd5I")).default)({
                children: [
                    node
                ],
                lineNumber: offset,
                className: className
            }));
            else if (node.children) {
                const classNames = className.concat(node.properties.className || []);
                $3722626977573637$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
            }
        }
        return newTree;
    }
});
parcelRegister("g0987", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$043f48aa29101879$export$2e2bcd8739ae039);
    function $043f48aa29101879$export$2e2bcd8739ae039(language, code, astGenerator) {
        if (language === 'text' || !astGenerator) return [
            {
                type: 'text',
                value: code
            }
        ];
        try {
            return astGenerator.highlight(code, language);
        } catch (e) {
            return [
                {
                    type: 'text',
                    value: code
                }
            ];
        }
    }
});
parcelRegister("bAA7E", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ffbb5a6617decb03$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $laCYD;
    function $ffbb5a6617decb03$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
        const renderedRows = rows.map((node, i)=>(0, (0, parcelRequire("laCYD")).default)({
                node: node,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment${i}`
            }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", containerProps, (0, ($parcel$interopDefault($5uXOq))).createElement("code", codeTagProps, renderedRows));
    }
});
parcelRegister("laCYD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b56eeb7e6ac46855$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47G8n;
    var $dE7lx;
    var $4CTxJ;
    function $b56eeb7e6ac46855$var$createClassNameString(classNames) {
        return classNames ? classNames.join(' ') : '';
    }
    function $b56eeb7e6ac46855$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
        if (node.type === 'text') {
            const { value: value } = node;
            const textValue = `${value}`;
            if (codeBidiWarningConfig.codeBidiWarnings) {
                const decorated = (0, (0, parcelRequire("dE7lx")).default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("47G8n")).default), {
                        bidiCharacter: bidiCharacter,
                        key: index,
                        label: codeBidiWarningConfig.codeBidiWarningLabel,
                        tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                    }));
                return decorated;
            }
            return textValue;
        } else {
            const { properties: properties, tagName: tagName } = node;
            const childrenCreator = (0, (0, parcelRequire("4CTxJ")).default)(codeBidiWarningConfig);
            const props = {
                ...properties,
                className: $b56eeb7e6ac46855$var$createClassNameString(properties.className)
            };
            const children = childrenCreator(node.children);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(tagName, {
                key: key,
                ...props
            }, children);
        }
    }
});
parcelRegister("47G8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6c8606b73bc0e8d9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $loZC0;
    var $barbM;
    function $6c8606b73bc0e8d9$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
        if (tooltipEnabled) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label,
            tag: $6c8606b73bc0e8d9$var$CustomizedTagWithRef
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("barbM")).Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter
        }, skipChildren ? null : bidiCharacter);
    }
    const $6c8606b73bc0e8d9$var$CustomizedTagWithRef = (0, ($parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
        const { children: children, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ...rest,
            ref: ref
        }, children);
    });
});
parcelRegister("barbM", function(module, exports) {
    $parcel$export(module.exports, "Decorator", ()=>$c9e1f2aa239b72a9$export$a592b67c93d52467);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $AHUyh;
    const $c9e1f2aa239b72a9$var$decoration = (0, (0, parcelRequire("f8Sb3")).css)({
        position: 'relative',
        ':before': {
            display: 'inline-flex',
            padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'row',
            background: `var(--ds-background-warning, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #7F5F01)",
            content: '"<"attr(data-bidi-character-code)">"',
            fontSize: '14px',
            fontStyle: 'normal',
            lineHeight: '18px',
            pointerEvents: 'auto'
        },
        ':hover:before': {
            background: `var(--ds-background-warning-hovered, ${(0, $72ba03e317f3d228$export$41060a744ab0b7ae)})`,
            color: "var(--ds-text-warning, #533F04)"
        }
    });
    function $c9e1f2aa239b72a9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
        const bidiCharacterCode = $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $c9e1f2aa239b72a9$var$decoration,
            "data-testid": testId,
            "data-bidi-character-code": bidiCharacterCode,
            "aria-hidden": "true"
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), {
            testId: testId && `${testId}--visually-hidden`
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("mark", null, bidiCharacterCode)));
    }
    function $c9e1f2aa239b72a9$var$getBidiCharacterCode(bidiCharacter) {
        const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
        return `U+${bidiCharacterCode}`;
    }
});
parcelRegister("dE7lx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$511185a3065642e8$export$2e2bcd8739ae039);
    const $511185a3065642e8$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
    function $511185a3065642e8$export$2e2bcd8739ae039(originalText, decorate) {
        const matches = [
            ...originalText.matchAll($511185a3065642e8$export$ecb256e6a1f5ee7e)
        ];
        if (matches.length === 0) return originalText;
        let children = [];
        let mappedTo = 0;
        for (const match of matches){
            if (mappedTo !== match.index) children.push(originalText.substring(mappedTo, match.index));
            children.push(decorate({
                bidiCharacter: match[0],
                index: match.index
            }));
            mappedTo = match.index + match[0].length;
        }
        if (mappedTo !== originalText.length) children.push(originalText.substring(mappedTo, originalText.length));
        return children;
    }
});
parcelRegister("4CTxJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cfcf1fd1989f08a6$export$2e2bcd8739ae039);
    var $laCYD;
    function $cfcf1fd1989f08a6$export$2e2bcd8739ae039(codeBidiWarningConfig) {
        let childrenCount = 0;
        return (children)=>{
            childrenCount += 1;
            return children.map((child, i)=>(0, (0, parcelRequire("laCYD")).default)({
                    node: child,
                    codeBidiWarningConfig: codeBidiWarningConfig,
                    key: `code-segment-${childrenCount}-${i}`
                }));
        };
    }
});
parcelRegister("kN6qz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("as9qs").then(()=>parcelRequire('5zvIl'));
});
parcelRegister("lOZGq", function(module, exports) {
    $parcel$export(module.exports, "CopyAction", ()=>$b3c0013295f8779c$export$958df07cbf9735fc);
    $parcel$export(module.exports, "ActionContainer", ()=>$b3c0013295f8779c$export$37ab3bdebc286ca);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UU68;
    var $iozM6;
    var $6Ll2T;
    var $99gde;
    var $8zOmE;
    var $fEogx;
    const $b3c0013295f8779c$export$2ce9877c9c1aa16 = {
        PROMPT: 'Copy',
        SUCCESS: 'Copied!',
        FAILURE: 'Copy to clipboard failed'
    };
    const $b3c0013295f8779c$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
        const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        const handleSuccess = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.SUCCESS);
        }, [
            setTooltipMessage
        ]);
        const handleError = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.FAILURE);
        }, [
            setTooltipMessage
        ]);
        const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
            actionSubjectId && (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
            navigator.clipboard.writeText(source).then(handleSuccess, handleError);
        }, [
            source,
            handleSuccess,
            handleError,
            actionSubjectId
        ]);
        const resetMessage = (0, $5uXOq.useCallback)(()=>{
            setTooltipMessage($b3c0013295f8779c$export$2ce9877c9c1aa16.PROMPT);
        }, [
            setTooltipMessage
        ]);
        function shouldRender() {
            if (typeof document !== 'undefined') return Boolean(navigator?.clipboard?.writeText);
        }
        return shouldRender() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fEogx")).Action), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("iozM6"))))),
            label: tooltipMessage,
            onClick: writeToClipboard,
            onMouseOver: resetMessage,
            onFocus: resetMessage,
            "aria-live": "assertive",
            "aria-atomic": "true",
            name: "Copy"
        }) : null;
    };
    const $b3c0013295f8779c$var$stopPropagation = (event)=>event.stopPropagation();
    const $b3c0013295f8779c$export$37ab3bdebc286ca = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b3c0013295f8779c$var$absolutePositionWrapperStyles,
            onMouseDown: $b3c0013295f8779c$var$stopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1UU68")).default), {
            label: "actions"
        }, children));
    const $b3c0013295f8779c$var$absolutePositionWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        top: 'space.0',
        right: 'space.0',
        padding: 'space.050',
        zIndex: 'flag'
    });
});
parcelRegister("iozM6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d646380862d200fa$var$_react = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d646380862d200fa$var$_copy = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("4BWWV")));
    var $d646380862d200fa$var$_copy2 = $d646380862d200fa$var$_interopRequireDefault((parcelRequire("gu5qi")));
    function $d646380862d200fa$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d646380862d200fa$var$CopyIcon = (props)=>$d646380862d200fa$var$_react.default.createElement($d646380862d200fa$var$_copy.default, Object.assign({
            LEGACY_fallbackIcon: $d646380862d200fa$var$_copy2.default
        }, props));
    $d646380862d200fa$var$CopyIcon.Name = 'CopyIconMigration';
    var $d646380862d200fa$var$_default = module.exports.default = $d646380862d200fa$var$CopyIcon;
});
parcelRegister("4BWWV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $35b85845832ae75f$var$_react = $35b85845832ae75f$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $35b85845832ae75f$var$_UNSAFE_baseNew = $35b85845832ae75f$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $35b85845832ae75f$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $35b85845832ae75f$var$CopyIcon = (props)=>$35b85845832ae75f$var$_react.default.createElement($35b85845832ae75f$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M1.75 3c0-.69.56-1.25 1.25-1.25h8c.69 0 1.25.56 1.25 1.25v8c0 .69-.56 1.25-1.25 1.25H3c-.69 0-1.25-.56-1.25-1.25z"/><path stroke="currentcolor" stroke-width="1.5" d="M6 15.25h6.75a2.5 2.5 0 0 0 2.5-2.5V6"/>`
        }, props));
    $35b85845832ae75f$var$CopyIcon.displayName = 'CopyIcon';
    var $35b85845832ae75f$var$_default = module.exports.default = $35b85845832ae75f$var$CopyIcon;
});
parcelRegister("gu5qi", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c003a79a3c70e52e$var$_react = $c003a79a3c70e52e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $c003a79a3c70e52e$var$_copy = $c003a79a3c70e52e$var$_interopRequireDefault((parcelRequire("4BWWV")));
    function $c003a79a3c70e52e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c003a79a3c70e52e$var$CopyIcon = (props)=>$c003a79a3c70e52e$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M10 19h8V8h-8zM8 7.992C8 6.892 8.902 6 10.009 6h7.982C19.101 6 20 6.893 20 7.992v11.016c0 1.1-.902 1.992-2.009 1.992H10.01A2 2 0 0 1 8 19.008z"/><path d="M5 16V4.992C5 3.892 5.902 3 7.009 3H15v13zm2 0h8V5H7z"/></g></svg>`
        }, props, {
            newIcon: $c003a79a3c70e52e$var$_copy.default
        }));
    $c003a79a3c70e52e$var$CopyIcon.displayName = 'CopyIcon';
    var $c003a79a3c70e52e$var$_default = module.exports.default = $c003a79a3c70e52e$var$CopyIcon;
});
parcelRegister("fEogx", function(module, exports) {
    $parcel$export(module.exports, "Action", ()=>$e6da05ade6347218$export$e19cd5f9376f8cee);
    var $5uXOq = parcelRequire("5uXOq");
    var $9jNMw;
    var $loZC0;
    const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
        const updateTooltip = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            updateTooltip.current?.();
        }, [
            tooltipLabel,
            label
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: ({ update: update })=>{
                updateTooltip.current = update;
                return tooltipLabel || label;
            },
            position: "top"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            isLoading: isLoading,
            appearance: "subtle",
            icon: icon,
            label: label,
            spacing: "compact",
            ...buttonProps
        }));
    };
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("bTyOW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5073396748f92b4e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "viewBox", ()=>$5073396748f92b4e$export$a179c88182cb9d56);
    $parcel$export(module.exports, "srcLight", ()=>($parcel$interopDefault((parcelRequire("5I4tL")))));
    $parcel$export(module.exports, "srcDark", ()=>($parcel$interopDefault((parcelRequire("h8kvT")))));
    var $dCLgq;
    var $h8kvT = parcelRequire("h8kvT");
    var $5I4tL = parcelRequire("5I4tL");
    const $5073396748f92b4e$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($5I4tL)),
        srcDark: ($parcel$interopDefault($h8kvT))
    });
    var $5073396748f92b4e$export$2e2bcd8739ae039 = $5073396748f92b4e$var$Illustration;
    const $5073396748f92b4e$export$a179c88182cb9d56 = [
        0,
        0,
        164,
        218
    ];
});
parcelRegister("h8kvT", function(module, exports) {
    module.exports = new URL("error-darkmode.9dba78cd.svg", import.meta.url).toString();
});
parcelRegister("5I4tL", function(module, exports) {
    module.exports = new URL("error.b7de7f77.svg", import.meta.url).toString();
});
parcelRegister("fC09Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bb376757c4acc5ab$export$2e2bcd8739ae039);
    var $dCLgq;
    var $3pGSh = parcelRequire("3pGSh");
    const $bb376757c4acc5ab$var$Illustration = (0, (0, parcelRequire("dCLgq")).createIllustration)({
        srcLight: ($parcel$interopDefault($3pGSh)),
        srcDark: ($parcel$interopDefault($3pGSh))
    });
    var $bb376757c4acc5ab$export$2e2bcd8739ae039 = $bb376757c4acc5ab$var$Illustration;
    const $bb376757c4acc5ab$export$a179c88182cb9d56 = [
        0,
        0,
        167,
        226
    ];
});
parcelRegister("3pGSh", function(module, exports) {
    module.exports = new URL("search-error.a6df7c97.svg", import.meta.url).toString();
});
parcelRegister("4AdE6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$135a9e70a6f11b3e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $135a9e70a6f11b3e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        notFoundDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-document-title-jsm",
            "defaultMessage": "Project not found - Service project"
        },
        notFoundTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-title",
            "defaultMessage": "This project isn't available"
        },
        notFoundDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-description",
            "defaultMessage": "It may have been deleted or your permissions may have changed"
        },
        notFoundAction: {
            "id": "servicedesk-spa-commons.common.utils.errors.not-found-action",
            "defaultMessage": "View a list of all projects"
        },
        genericDocumentTitleJsm: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-document-title-jsm",
            "defaultMessage": "Error - Service project"
        },
        genericErrorTitle: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-title",
            "defaultMessage": "An error occurred"
        },
        genericErrorDescription: {
            "id": "servicedesk-spa-commons.common.utils.errors.generic-error-description",
            "defaultMessage": "An error occurred while loading this page"
        }
    });
});
parcelRegister("e33py", function(module, exports) {
    $parcel$export(module.exports, "PageTitle", ()=>$ae40b537a934bf9c$export$155581e8dc02007a);
    $parcel$export(module.exports, "ServiceDeskDocumentTitle", ()=>$ae40b537a934bf9c$export$c7841d2c1c13065e);
    var $5uXOq = parcelRequire("5uXOq");
    var $9sGI6;
    var $ew1Lk;
    var $koVbs;
    var $2BHCj;
    const $ae40b537a934bf9c$export$155581e8dc02007a = (props)=>{
        const { DocumentTitle: DocumentTitle, section: section, projectName: projectName, subsection: subsection } = props;
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const title = subsection ? `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${subsection} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}` : `${projectName} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default)[section])} - ${formatMessage((0, (0, parcelRequire("2BHCj")).default).serviceProject)}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(DocumentTitle, {
            title: title
        });
    };
    const $ae40b537a934bf9c$export$c7841d2c1c13065e = (0, (0, parcelRequire("9sGI6")).default)($ae40b537a934bf9c$export$155581e8dc02007a, {
        DocumentTitle: (0, (0, parcelRequire("ew1Lk")).DocumentTitle)
    });
    var $ae40b537a934bf9c$export$2e2bcd8739ae039 = $ae40b537a934bf9c$export$c7841d2c1c13065e;
});
parcelRegister("2BHCj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7d7eb5ce3479323e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $7d7eb5ce3479323e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        atlassianAnalytics: {
            "id": "servicedesk-spa-commons.common.utils.document-title.atlassian-analytics",
            "defaultMessage": "Atlassian Analytics"
        },
        serviceProject: {
            "id": "servicedesk-spa-commons.common.utils.document-title.service-project",
            "defaultMessage": "Service project"
        },
        knowledge: {
            "id": "servicedesk-spa-commons.common.utils.document-title.knowledge",
            "defaultMessage": "Knowledge base"
        },
        itsmFeatures: {
            "id": "servicedesk-spa-commons.common.utils.document-title.itsm-features",
            "defaultMessage": "Features"
        },
        queues: {
            "id": "servicedesk-spa-commons.common.utils.document-title.queues",
            "defaultMessage": "Queues"
        },
        customers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customers",
            "defaultMessage": "Customers"
        },
        organizations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.organizations",
            "defaultMessage": "Organizations"
        },
        customerServiceEscalations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-service-escalations",
            "defaultMessage": "Developer escalations"
        },
        reports: {
            "id": "servicedesk-spa-commons.common.utils.document-title.reports",
            "defaultMessage": "Reports"
        },
        services: {
            "id": "servicedesk-spa-commons.common.utils.document-title.services",
            "defaultMessage": "Services"
        },
        oncall: {
            "id": "servicedesk-spa-commons.common.utils.document-title.oncall",
            "defaultMessage": "On-call"
        },
        email: {
            "id": "servicedesk-spa-commons.common.utils.document-title.email",
            "defaultMessage": "Email request"
        },
        sla: {
            "id": "servicedesk-spa-commons.common.utils.document-title.sla",
            "defaultMessage": "Service level agreements"
        },
        csat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.csat",
            "defaultMessage": "Customer satisfaction"
        },
        details: {
            "id": "servicedesk-spa-commons.common.utils.document-title.details",
            "defaultMessage": "Details"
        },
        portal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal",
            "defaultMessage": "Customer portal"
        },
        externalLinks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.external-links",
            "defaultMessage": "External resources"
        },
        portalSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.portal-settings",
            "defaultMessage": "Portal settings"
        },
        automation: {
            "id": "servicedesk-spa-commons.common.utils.document-title.automation",
            "defaultMessage": "Automation"
        },
        advanced: {
            "id": "servicedesk-spa-commons.common.utils.document-title.advanced",
            "defaultMessage": "Advanced"
        },
        languageSupport: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-support",
            "defaultMessage": "Language support"
        },
        languageTranslations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.language-translations",
            "defaultMessage": "Language translations"
        },
        notificationEmail: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notification-email",
            "defaultMessage": "Notification email"
        },
        notifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.notifications",
            "defaultMessage": "Notifications"
        },
        internalNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.internal-notifications",
            "defaultMessage": "Internal notifications"
        },
        customerNotifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-notifications",
            "defaultMessage": "Customer notifications"
        },
        widget: {
            "id": "servicedesk-spa-commons.common.utils.document-title.widget",
            "defaultMessage": "Widget"
        },
        customerPermissions: {
            "id": "servicedesk-spa-commons.common.utils.document-title.customer-permissions",
            "defaultMessage": "Customer permissions"
        },
        people: {
            "id": "servicedesk-spa-commons.common.utils.document-title.people",
            "defaultMessage": "Internal access"
        },
        issueType: {
            "id": "servicedesk-spa-commons.common.utils.document-title.issue-type",
            "defaultMessage": "Request types"
        },
        connectAppControls: {
            "id": "servicedesk-spa-commons.common.utils.document-title.connect-app-controls",
            "defaultMessage": "Apps"
        },
        features: {
            "id": "servicedesk-spa-commons.common.utils.document-title.features",
            "defaultMessage": "Features"
        },
        calendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.calendar",
            "defaultMessage": "Calendar"
        },
        projectSummary: {
            "id": "servicedesk-spa-commons.common.utils.document-title.project-summary",
            "defaultMessage": "Summary"
        },
        changeCalendar: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-calendar",
            "defaultMessage": "Change calendar"
        },
        changeManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.change-management-settings",
            "defaultMessage": "Change management"
        },
        incidentManagementSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.incident-management-settings",
            "defaultMessage": "Incident management"
        },
        virtualAgentConversations: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-conversations",
            "defaultMessage": "Conversations"
        },
        virtualAgentIntents: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-intents",
            "defaultMessage": "Intents"
        },
        virtualAgentStandardFlows: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-standard-flows",
            "defaultMessage": "Standard flows"
        },
        virtualAgentSettings: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-settings",
            "defaultMessage": "Settings"
        },
        virtualAgentLanding: {
            "id": "servicedesk-spa-commons.common.utils.document-title.virtual-agent-landing",
            "defaultMessage": "Virtual agent"
        },
        chat: {
            "id": "servicedesk-spa-commons.common.utils.document-title.chat",
            "defaultMessage": "Chat"
        },
        proformaForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.proforma-forms",
            "defaultMessage": "Forms"
        },
        playbooks: {
            "id": "servicedesk-spa-commons.common.utils.document-title.playbooks-non-final",
            "defaultMessage": "Playbooks"
        },
        dataClassifications: {
            "id": "servicedesk-spa-commons.common.utils.document-title.data-classifications",
            "defaultMessage": "Data classification"
        },
        fieldsNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.fields-non-final",
            "defaultMessage": "Fields"
        },
        workflowScheme: {
            "id": "servicedesk-spa-commons.common.utils.document-title.workflow-scheme",
            "defaultMessage": "Workflows"
        },
        journeysNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journeys-non-final",
            "defaultMessage": "Journeys"
        },
        journeyConfigNonFinal: {
            "id": "servicedesk-spa-commons.common.utils.document-title.journey-config-non-final",
            "defaultMessage": "Journey configuration"
        },
        helpCenterForms: {
            "id": "servicedesk-spa-commons.common.utils.document-title.helpcenter-forms",
            "defaultMessage": "Forms"
        },
        virtualAgentAiAnswers: {
            "id": "servicedesk-spa-commons.common.utils.document-title.ai-answers",
            "defaultMessage": "Atlassian Intelligence answers"
        }
    });
});
parcelRegister("4S0uJ", function(module, exports) {
    $parcel$export(module.exports, "PageStyle", ()=>$7307247c9fc02c84$export$c59987a647e9a55);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dUzNt;
    const $7307247c9fc02c84$export$c59987a647e9a55 = ({ Page: Page, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($7307247c9fc02c84$var$JSDSpaPageWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Page, null, children));
    $7307247c9fc02c84$export$c59987a647e9a55.defaultProps = {
        Page: (0, (0, parcelRequire("dUzNt")).default)
    };
    var $7307247c9fc02c84$export$2e2bcd8739ae039 = $7307247c9fc02c84$export$c59987a647e9a55;
    const $7307247c9fc02c84$var$JSDSpaPageWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8zdiv",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dUzNt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1ee69114caaf0a79$export$2e2bcd8739ae039);
    var $ip1ks;
    var $esRRj;
    var $PhrmH;
    var $1ee69114caaf0a79$export$2e2bcd8739ae039 = (0, (0, parcelRequire("ip1ks")).default);
});
parcelRegister("ip1ks", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c50f4f87827a8a74$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $2xIx0;
    function $c50f4f87827a8a74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c50f4f87827a8a74$var$bannerStyles = {
        name: "4oew4k",
        styles: "width:100%;position:fixed"
    };
    const $c50f4f87827a8a74$var$bannerContainerStyles = {
        name: "1x3pv69",
        styles: "width:100%;position:relative;z-index:3;flex:1 0 auto;transition:height 0.25s ease-in-out"
    };
    const $c50f4f87827a8a74$var$pageContentStyles = {
        name: "15n167b",
        styles: "min-width:0;position:relative;z-index:1;flex:1 1 auto"
    };
    const $c50f4f87827a8a74$var$wrapperStyles = {
        name: "m5v4sl",
        styles: "display:flex;width:100%;min-height:100%;flex-direction:column"
    };
    const $c50f4f87827a8a74$var$mainContainerStyles = {
        name: "1cete8c",
        styles: "display:flex;flex:1 1 auto"
    };
    const $c50f4f87827a8a74$var$navigationStyles = {
        name: "wrqbg1",
        styles: "position:relative;z-index:2"
    };
    const $c50f4f87827a8a74$var$Page = ({ isBannerOpen: isBannerOpen = false, bannerHeight: bannerHeight = (0, (0, parcelRequire("2xIx0")).defaultBannerHeight), banner: banner, navigation: navigation, children: children, testId: testId })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$wrapperStyles,
            "data-testid": testId
        }, banner ? (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$bannerContainerStyles,
            style: {
                height: isBannerOpen ? `${bannerHeight}px` : '0'
            },
            "aria-hidden": !isBannerOpen,
            "data-testid": testId ? `${testId}--banner-container` : undefined
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$bannerStyles
        }, banner)) : null, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$mainContainerStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$navigationStyles
        }, navigation), (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $c50f4f87827a8a74$var$pageContentStyles
        }, children)));
    };
    var $c50f4f87827a8a74$export$2e2bcd8739ae039 = $c50f4f87827a8a74$var$Page;
});
parcelRegister("2xIx0", function(module, exports) {
    $parcel$export(module.exports, "defaultGridColumns", ()=>$03960cd5eff6a11d$export$74797698e12f8baa);
    $parcel$export(module.exports, "defaultGridColumnWidth", ()=>$03960cd5eff6a11d$export$b8241a1616ab1b96);
    $parcel$export(module.exports, "spacingMapping", ()=>$03960cd5eff6a11d$export$2a89a65a43bab52d);
    $parcel$export(module.exports, "defaultSpacing", ()=>$03960cd5eff6a11d$export$8ec7372efd74b753);
    $parcel$export(module.exports, "defaultBannerHeight", ()=>$03960cd5eff6a11d$export$d77f83c3d17a7b8a);
    $parcel$export(module.exports, "defaultMedium", ()=>$03960cd5eff6a11d$export$f8725d21f81f3e01);
    $parcel$export(module.exports, "defaultLayout", ()=>$03960cd5eff6a11d$export$2303d2bd9eeff99a);
    $parcel$export(module.exports, "varColumnsNum", ()=>$03960cd5eff6a11d$export$9ddc3632bbfb8966);
    $parcel$export(module.exports, "varColumnSpan", ()=>$03960cd5eff6a11d$export$8b7e31f391e6e681);
    $parcel$export(module.exports, "varGridSpacing", ()=>$03960cd5eff6a11d$export$936829b4511db3e4);
    const $03960cd5eff6a11d$export$3aaf3a78c909ea56 = 8;
    const $03960cd5eff6a11d$export$74797698e12f8baa = 12;
    const $03960cd5eff6a11d$export$b8241a1616ab1b96 = $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 10;
    const $03960cd5eff6a11d$export$2a89a65a43bab52d = {
        comfortable: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 5,
        cosy: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 2,
        compact: $03960cd5eff6a11d$export$3aaf3a78c909ea56 * 0.5
    };
    const $03960cd5eff6a11d$export$8ec7372efd74b753 = 'cosy';
    const $03960cd5eff6a11d$export$d77f83c3d17a7b8a = 52;
    const $03960cd5eff6a11d$export$f8725d21f81f3e01 = 0;
    const $03960cd5eff6a11d$export$2303d2bd9eeff99a = 'fixed';
    const $03960cd5eff6a11d$export$9ddc3632bbfb8966 = '--ds-columns-num';
    const $03960cd5eff6a11d$export$8b7e31f391e6e681 = '--ds-column-span';
    const $03960cd5eff6a11d$export$936829b4511db3e4 = '--ds-grid-spacing';
});
parcelRegister("esRRj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a731a05bdccc64ea$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2xIx0;
    var $2cP5D;
    var $PhrmH;
    var $6MCgd;
    const $a731a05bdccc64ea$var$GridWrapper = ({ spacing: spacingProp, columns: columnsProp, layout: layout, testId: testId, children: children, theme: theme })=>{
        const { isRoot: isRoot } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        const { medium: medium } = (0, $5uXOq.useContext)((0, (0, parcelRequire("PhrmH")).GridColumnContext));
        const defaultColumns = medium > 0 ? medium : (0, (0, parcelRequire("2xIx0")).defaultGridColumns);
        const spacing = spacingProp ?? theme?.spacing ?? (0, (0, parcelRequire("2xIx0")).defaultSpacing);
        const columns = columnsProp ?? theme?.columns ?? defaultColumns;
        const isNested = theme?.isNestedGrid ?? !isRoot;
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                isRoot: false,
                isNested: isNested,
                spacing: spacing,
                columns: columns
            }), [
            spacing,
            columns,
            isNested
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6MCgd")).GridContext).Provider, {
            value: contextValue
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2cP5D")).Grid), {
            layout: layout,
            testId: testId
        }, children));
    };
    var $a731a05bdccc64ea$export$2e2bcd8739ae039 = $a731a05bdccc64ea$var$GridWrapper;
});
parcelRegister("2cP5D", function(module, exports) {
    $parcel$export(module.exports, "Grid", ()=>$674dfadcfd40015c$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2xIx0;
    var $6MCgd;
    function $674dfadcfd40015c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $674dfadcfd40015c$var$gridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'flex',
        margin: '0 auto',
        padding: `0 calc(var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}) / 2)`,
        position: 'relative',
        alignItems: 'flex-start',
        flexWrap: 'wrap'
    });
    const $674dfadcfd40015c$var$gridLayoutStyles = {
        fixed: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(var(${(0, (0, parcelRequire("2xIx0")).varColumnsNum)}) * ${(0, (0, parcelRequire("2xIx0")).defaultGridColumnWidth)}px)`
        }),
        fluid: {
            name: "qhxz92",
            styles: "max-width:100%"
        }
    };
    const $674dfadcfd40015c$var$nestedGridStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        margin: `0 calc(-1 * var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`
    });
    const $674dfadcfd40015c$export$ef2184bd89960b14 = ({ layout: layout = (0, (0, parcelRequire("2xIx0")).defaultLayout), testId: testId, children: children })=>{
        const { isNested: isNested, columns: columns, spacing: spacing } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $674dfadcfd40015c$var$gridStyles,
                $674dfadcfd40015c$var$gridLayoutStyles[layout],
                isNested && $674dfadcfd40015c$var$nestedGridStyles
            ],
            style: {
                [(0, (0, parcelRequire("2xIx0")).varColumnsNum)]: columns,
                [(0, (0, parcelRequire("2xIx0")).varGridSpacing)]: `${(0, (0, parcelRequire("2xIx0")).spacingMapping)[spacing]}px`
            },
            "data-testid": testId
        }, children);
    };
});
parcelRegister("6MCgd", function(module, exports) {
    $parcel$export(module.exports, "GridContext", ()=>$d3f7b1d05770bd6c$export$11cae3e04ab99fae);
    var $5uXOq = parcelRequire("5uXOq");
    var $2xIx0;
    const $d3f7b1d05770bd6c$export$11cae3e04ab99fae = (0, $5uXOq.createContext)({
        isRoot: true,
        isNested: false,
        spacing: (0, (0, parcelRequire("2xIx0")).defaultSpacing),
        columns: (0, (0, parcelRequire("2xIx0")).defaultGridColumns)
    });
});
parcelRegister("PhrmH", function(module, exports) {
    $parcel$export(module.exports, "GridColumnContext", ()=>$505f9b94cbbad1b8$export$1229ad7112b989f5);
    $parcel$export(module.exports, "default", ()=>$505f9b94cbbad1b8$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2xIx0;
    var $6MCgd;
    var $505f9b94cbbad1b8$var$ColumnVariant;
    (function(ColumnVariant) {
        ColumnVariant["Auto"] = "auto";
        ColumnVariant["Bounded"] = "bounded";
        ColumnVariant["FullWidth"] = "fullWidth";
    })($505f9b94cbbad1b8$var$ColumnVariant || ($505f9b94cbbad1b8$var$ColumnVariant = {}));
    const $505f9b94cbbad1b8$var$getVariant = ({ medium: medium, columns: columns })=>{
        if (medium === (0, (0, parcelRequire("2xIx0")).defaultMedium)) return "auto";
        else if (medium < columns) return "bounded";
        return "fullWidth";
    };
    const $505f9b94cbbad1b8$var$availableWidth = '99.9999%';
    const $505f9b94cbbad1b8$var$singleColumnWidth = `(${$505f9b94cbbad1b8$var$availableWidth} / var(${(0, (0, parcelRequire("2xIx0")).varColumnsNum)}))`;
    const $505f9b94cbbad1b8$var$gridColumnStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        minWidth: `calc(${$505f9b94cbbad1b8$var$singleColumnWidth} - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
        margin: `0 calc(var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}) / 2)`,
        flexGrow: 1,
        flexShrink: 0,
        wordWrap: 'break-word'
    });
    const $505f9b94cbbad1b8$var$gridColumnWidthStyles = {
        ["auto"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `auto`
        }),
        ["bounded"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(${$505f9b94cbbad1b8$var$singleColumnWidth} *  var(${(0, (0, parcelRequire("2xIx0")).varColumnSpan)}) - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `100%`
        }),
        ["fullWidth"]: (0, (0, parcelRequire("f8Sb3")).css)({
            maxWidth: `calc(100% - var(${(0, (0, parcelRequire("2xIx0")).varGridSpacing)}))`,
            flexBasis: `100%`
        })
    };
    const $505f9b94cbbad1b8$export$1229ad7112b989f5 = (0, $5uXOq.createContext)({
        medium: (0, (0, parcelRequire("2xIx0")).defaultMedium)
    });
    const $505f9b94cbbad1b8$var$GridColumn = ({ medium: medium = (0, (0, parcelRequire("2xIx0")).defaultMedium), children: children, testId: testId })=>{
        const { columns: columns } = (0, $5uXOq.useContext)((0, (0, parcelRequire("6MCgd")).GridContext));
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                medium: medium
            }), [
            medium
        ]);
        const colSpan = Math.max(1, Math.min(medium, columns));
        const variant = $505f9b94cbbad1b8$var$getVariant({
            medium: medium,
            columns: columns
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)($505f9b94cbbad1b8$export$1229ad7112b989f5.Provider, {
            value: contextValue
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: [
                $505f9b94cbbad1b8$var$gridColumnStyles,
                $505f9b94cbbad1b8$var$gridColumnWidthStyles[variant]
            ],
            style: {
                [(0, (0, parcelRequire("2xIx0")).varColumnSpan)]: variant === "auto" ? 'auto' : colSpan
            },
            "data-testid": testId
        }, children));
    };
    var $505f9b94cbbad1b8$export$2e2bcd8739ae039 = $505f9b94cbbad1b8$var$GridColumn;
});
parcelRegister("hh9mX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("dsiAd"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("lW5B9")
    ]).then(()=>parcelRequire('MCPYd'));
});
